import c01 from "./styles/c01.json.gz"
import c02 from "./styles/c02.json.gz"
import c03 from "./styles/c03.json.gz"
import c04 from "./styles/c04.json.gz"
import c05 from "./styles/c05.json.gz"
import c06 from "./styles/c06.json.gz"
import c07 from "./styles/c07.json.gz"
import c08 from "./styles/c08.json.gz"
import c09 from "./styles/c09.json.gz"
import c10 from "./styles/c10.json.gz"
import c11 from "./styles/c11.json.gz"
import c12 from "./styles/c12.json.gz"
import c13 from "./styles/c13.json.gz"
import c14 from "./styles/c14.json.gz"
import c15 from "./styles/c15.json.gz"
import c16 from "./styles/c16.json.gz"
import c17 from "./styles/c17.json.gz"
import c18 from "./styles/c18.json.gz"
import c19 from "./styles/c19.json.gz"
import c20 from "./styles/c20.json.gz"
import c21 from "./styles/c21.json.gz"
import c22 from "./styles/c22.json.gz"
import c23 from "./styles/c23.json.gz"
import c24 from "./styles/c24.json.gz"
import c25 from "./styles/c25.json.gz"

export const styleLocations = {
    "academy-of-management-perspectives": c01,
    "academy-of-management-review": c02,
    "accident-analysis-and-prevention": c03,
    "aci-materials-journal": c04,
    "acm-sig-proceedings-long-author-list": c05,
    "acm-sig-proceedings": c06,
    "acm-sigchi-proceedings-extended-abstract-format": c07,
    "acm-sigchi-proceedings": c08,
    "acm-siggraph": c09,
    "acme-an-international-journal-for-critical-geographies": c10,
    "acta-adriatica": c11,
    "acta-amazonica": c12,
    "acta-anaesthesiologica-scandinavica": c13,
    "acta-anaesthesiologica-taiwanica": c14,
    "acta-botanica-croatica": c15,
    "acta-chiropterologica": c16,
    "acta-chirurgiae-orthopaedicae-et-traumatologiae-cechoslovaca": c17,
    "acta-hydrotechnica": c18,
    "acta-medica-peruana": c19,
    "acta-medica-portuguesa": c20,
    "acta-naturae": c21,
    "acta-neurobiologiae-experimentalis": c22,
    "acta-neurochirurgica": c23,
    "acta-ophthalmologica": c24,
    "acta-ornithologica": c25,
    "acta-orthopaedica-belgica": c01,
    "acta-orthopaedica": c02,
    "acta-paediatrica": c03,
    "acta-palaeontologica-polonica": c04,
    "acta-pharmaceutica-sinica-b": c05,
    "acta-pharmaceutica": c06,
    "acta-philosophica": c07,
    "acta-physica-sinica": c08,
    "acta-physiologica": c09,
    "acta-polytechnica": c10,
    "acta-radiologica": c11,
    "acta-scientiae-veterinariae": c12,
    "acta-societatis-botanicorum-poloniae": c13,
    "acta-universitatis-agriculturae-et-silviculturae-mendelianae-brunensis": c14,
    "acta-universitatis-agriculturae-sueciae": c15,
    "acta-zoologica-academiae-scientiarum-hungaricae": c16,
    "administrative-science-quarterly": c17,
    "advanced-engineering-materials": c18,
    "advanced-functional-materials": c19,
    "advanced-healthcare-materials": c20,
    "advanced-materials": c21,
    "advanced-optical-materials": c22,
    "advanced-pharmaceutical-bulletin": c23,
    "advanced-science": c24,
    "advances-in-alzheimers-disease": c25,
    "advances-in-complex-systems": c01,
    "aerosol-and-air-quality-research": c02,
    "aerosol-science-and-technology": c03,
    "aerospace-medicine-and-human-performance": c04,
    "african-journal-of-food-agriculture-nutrition-development": c05,
    "african-journal-of-marine-science": c06,
    "african-online-scientific-information-systems-harvard": c07,
    "african-online-scientific-information-systems-vancouver": c08,
    "african-zoology": c09,
    "afro-asia": c10,
    "ageing-and-society": c11,
    "aging-and-disease": c12,
    "aging-cell": c13,
    "aging": c14,
    "agora": c15,
    "agriculturae-conspectus-scientificus": c16,
    "aib-studi": c17,
    "aids": c18,
    "aims-press": c19,
    "aix-marseille-universite-departement-d-etudes-asiatiques": c20,
    "al-jamiah-journal-of-islamic-studies": c21,
    "alcohol-and-alcoholism": c22,
    "alcoholism-clinical-and-experimental-research": c23,
    "alkoholizmus-a-drogove-zavislosti": c24,
    "allergology-international": c25,
    "allergy": c01,
    "alternatif-politika": c02,
    "alternatives-to-animal-experimentation": c03,
    "ambio": c04,
    "ameghiniana": c05,
    "american-anthropological-association": c06,
    "american-association-for-cancer-research": c07,
    "american-association-of-petroleum-geologists": c08,
    "american-chemical-society": c09,
    "american-college-of-clinical-pharmacy": c10,
    "american-fisheries-society": c11,
    "american-geophysical-union": c12,
    "american-heart-association": c13,
    "american-institute-of-aeronautics-and-astronautics": c14,
    "american-institute-of-physics": c15,
    "american-journal-of-archaeology": c16,
    "american-journal-of-botany": c17,
    "american-journal-of-cancer-research": c18,
    "american-journal-of-climate-change": c19,
    "american-journal-of-clinical-pathology": c20,
    "american-journal-of-enology-and-viticulture": c21,
    "american-journal-of-health-behavior": c22,
    "american-journal-of-medical-genetics": c23,
    "american-journal-of-neuroradiology": c24,
    "american-journal-of-orthodontics-and-dentofacial-orthopedics": c25,
    "american-journal-of-plant-sciences": c01,
    "american-journal-of-political-science": c02,
    "american-journal-of-respiratory-and-critical-care-medicine": c03,
    "american-journal-of-roentgenology": c04,
    "american-journal-of-science": c05,
    "american-journal-of-sociology": c06,
    "american-journal-of-sonography": c07,
    "american-journal-of-surgical-pathology": c08,
    "american-journal-of-translational-research": c09,
    "american-marketing-association": c10,
    "american-mathematical-society-label": c11,
    "american-mathematical-society-numeric": c12,
    "american-medical-association-10th-edition": c13,
    "american-medical-association-alphabetical": c14,
    "american-medical-association-brackets": c15,
    "american-medical-association-no-et-al": c16,
    "american-medical-association-no-url-alphabetical": c17,
    "american-medical-association-no-url": c18,
    "american-medical-association-parentheses": c19,
    "american-medical-association": c20,
    "american-meteorological-society": c21,
    "american-mineralogist": c22,
    "american-nuclear-society": c23,
    "american-physical-society-et-al": c24,
    "american-physics-society-without-titles": c25,
    "american-physics-society": c01,
    "american-physiological-society": c02,
    "american-phytopathological-society": c03,
    "american-political-science-association": c04,
    "american-school-of-classical-studies-at-athens": c05,
    "american-society-for-horticultural-science": c06,
    "american-society-for-microbiology": c07,
    "american-society-for-pharmacology-and-experimental-therapeutics": c08,
    "american-society-of-agricultural-and-biological-engineers": c09,
    "american-society-of-civil-engineers": c10,
    "american-society-of-mechanical-engineers": c11,
    "american-sociological-association": c12,
    "american-statistical-association": c13,
    "american-veterinary-medical-association": c14,
    "amerindia": c15,
    "amphibia-reptilia": c16,
    "anabases": c17,
    "anaesthesia": c18,
    "anais-da-academia-brasileira-de-ciencias": c19,
    "analytical-sciences": c20,
    "anatomical-sciences-education": c21,
    "ancilla-iuris": c22,
    "andean-geology": c23,
    "anesthesia-and-analgesia": c24,
    "anesthesiology": c25,
    "angewandte-chemie": c01,
    "angiologia": c02,
    "angiology": c03,
    "anglia": c04,
    "animal-conservation": c05,
    "animal-migration": c06,
    "animal-welfare": c07,
    "animal": c08,
    "ankara-universitesi-sosyal-bilimler-enstitusu-hukuk-fakultesi": c09,
    "annalen-des-naturhistorischen-museums-in-wien": c10,
    "annales-de-demographie-historique": c11,
    "annales": c12,
    "annals-of-allergy-asthma-and-immunology": c13,
    "annals-of-applied-biology": c14,
    "annals-of-behavioral-medicine": c15,
    "annals-of-biomedical-engineering": c16,
    "annals-of-botany": c17,
    "annals-of-eye-science": c18,
    "annals-of-joint": c19,
    "annals-of-laboratory-medicine": c20,
    "annals-of-neurology": c21,
    "annals-of-oncology": c22,
    "annals-of-public-and-cooperative-economics": c23,
    "annals-of-surgery": c24,
    "annals-of-the-association-of-american-geographers": c25,
    "annals-of-the-new-york-academy-of-sciences": c01,
    "annual-review-of-astronomy-and-astrophysics": c02,
    "annual-review-of-linguistics": c03,
    "annual-review-of-medicine": c04,
    "annual-review-of-nuclear-and-particle-science": c05,
    "annual-reviews-alphabetical": c06,
    "annual-reviews-author-date": c07,
    "annual-reviews-without-titles": c08,
    "annual-reviews": c09,
    "antarctic-science": c10,
    "anthropologie-et-societes": c11,
    "anti-trafficking-review": c12,
    "anticancer-research": c13,
    "antipode": c14,
    "antiquites-africaines": c15,
    "antiquity": c16,
    "apa-6th-edition": c17,
    "apa-annotated-bibliography": c18,
    "apa-cv": c19,
    "apa-eu": c20,
    "apa-fr-provost": c21,
    "apa-no-ampersand": c22,
    "apa-no-initials": c23,
    "apa-numeric-superscript-brackets": c24,
    "apa-numeric-superscript": c25,
    "apa-single-spaced": c01,
    "apa-tr": c02,
    "apa-with-abstract": c03,
    "apa": c04,
    "aporia-the-nursing-journal": c05,
    "applications-in-plant-sciences": c06,
    "applied-clay-science": c07,
    "applied-spectroscopy-reviews": c08,
    "applied-spectroscopy": c09,
    "aquatic-conservation": c10,
    "aquatic-invasions": c11,
    "aquatic-living-resources": c12,
    "aquitania": c13,
    "arachne": c14,
    "arachnologische-mitteilungen": c15,
    "arachnology": c16,
    "arbok-hins-islenzka-fornleifafelags": c17,
    "arcadia-science": c18,
    "archaeologia-austriaca": c19,
    "archaeometry": c20,
    "archaeonautica": c21,
    "archeologia-classica": c22,
    "archeologia-e-calcolatori": c23,
    "archeologicke-rozhledy": c24,
    "archeologie-medievale": c25,
    "archeologies-et-sciences-de-lantiquite": c01,
    "archeosciences": c02,
    "archimede-archeologie-et-histoire-ancienne": c03,
    "archiv-fur-die-civilistische-praxis": c04,
    "archiv-fur-geschichte-der-philosophie": c05,
    "archives-of-hand-and-microsurgery": c06,
    "archives-of-medical-research": c07,
    "archives-of-physical-medicine-and-rehabilitation": c08,
    "archivos-de-bronconeumologia": c09,
    "archivos-de-la-sociedad-espanola-de-oftalmologia": c10,
    "archivos-peruanos-de-cardiologia-y-cirugia-cardiovascular": c11,
    "archivum-latinitatis-medii-aevi": c12,
    "arctic-antarctic-and-alpine-research": c13,
    "arctic": c14,
    "arhiv-za-higijenu-rada-i-toksikologiju": c15,
    "arkivoc": c16,
    "art-history": c17,
    "art-libraries-society-of-north-america-arlisna-reviews": c18,
    "artery-research": c19,
    "arthritis-and-rheumatism": c20,
    "arthropod-systematics-and-phylogeny": c21,
    "arts-university-bournemouth": c22,
    "arzneimitteltherapie": c23,
    "asa-cssa-sssa": c24,
    "asaio-journal": c25,
    "asia-and-the-pacific-policy-studies": c01,
    "asia-pacific-journal-of-human-resources": c02,
    "asian-journal-of-neurosurgery": c03,
    "asian-myrmecology": c04,
    "asian-studies-review": c05,
    "associacao-brasileira-de-normas-tecnicas-eceme": c06,
    "associacao-brasileira-de-normas-tecnicas-instituto-meira-mattos": c07,
    "associacao-brasileira-de-normas-tecnicas-ipea": c08,
    "associacao-brasileira-de-normas-tecnicas-note": c09,
    "associacao-brasileira-de-normas-tecnicas-numerico": c10,
    "associacao-brasileira-de-normas-tecnicas-ufmg-face-full": c11,
    "associacao-brasileira-de-normas-tecnicas-ufmg-face-initials": c12,
    "associacao-brasileira-de-normas-tecnicas-ufpr": c13,
    "associacao-brasileira-de-normas-tecnicas-ufrgs-initials": c14,
    "associacao-brasileira-de-normas-tecnicas-ufrgs-note-initials-with-ibid": c15,
    "associacao-brasileira-de-normas-tecnicas-ufrgs": c16,
    "associacao-brasileira-de-normas-tecnicas-ufs": c17,
    "associacao-brasileira-de-normas-tecnicas-unirio-eipp": c18,
    "associacao-brasileira-de-normas-tecnicas-usp-fmvz": c19,
    "associacao-brasileira-de-normas-tecnicas": c20,
    "associacao-nacional-de-pesquisa-e-ensino-em-transportes": c21,
    "association-de-science-regionale-de-langue-francaise": c22,
    "association-for-computational-linguistics": c23,
    "association-for-computing-machinery": c24,
    "atlande": c25,
    "atlas-of-genetics-and-cytogenetics-in-oncology-and-haematology": c01,
    "auci": c02,
    "ausonius-editions": c03,
    "austral-ecology": c04,
    "austral-entomology": c05,
    "australasian-journal-of-philosophy": c06,
    "australian-archaeology": c07,
    "australian-critical-care": c08,
    "australian-dental-journal": c09,
    "australian-guide-to-legal-citation-3rd-edition": c10,
    "australian-guide-to-legal-citation": c11,
    "australian-historical-studies": c12,
    "australian-journal-of-earth-sciences": c13,
    "australian-journal-of-grape-and-wine-research": c14,
    "australian-road-research-board": c15,
    "australian-veterinary-journal": c16,
    "austrian-journal-of-development-studies": c17,
    "austrian-legal": c18,
    "aves": c19,
    "avian-conservation-and-ecology": c20,
    "avian-diseases": c21,
    "avian-pathology": c22,
    "avocetta-journal-of-ornithology": c23,
    "ayer": c24,
    "azr-abkurzungs-und-zitierregeln-der-osterreichischen-rechtssprache-und-europarechtlicher-rechtsquellen": c25,
    "babes-bolyai-university-faculty-of-orthodox-theology": c01,
    "babesch-annual-papers-on-mediterranean-archaeology": c02,
    "baghdad-science-journal": c03,
    "baishideng-publishing-group": c04,
    "bakhtiniana-journal-of-discourse-studies": c05,
    "barbara-budrich": c06,
    "begell-house-apa": c07,
    "begell-house-chicago-author-date": c08,
    "behaviour": c09,
    "beilstein-journal-of-organic-chemistry": c10,
    "beltz-padagogik": c11,
    "berghahn-books-author-date-en-gb": c12,
    "berlin-school-of-economics-and-law-international-marketing-management": c13,
    "bern-university-of-applied-sciences-school-of-agricultural-forest-and-food-sciences-hafl": c14,
    "betriebswirtschaftliche-forschung-und-praxis": c15,
    "biblio-3w": c16,
    "bibliotheca-hertziana-max-planck-institute-for-art-history": c17,
    "bibliothecae-it": c18,
    "bibliothek-forschung-und-praxis": c19,
    "bibliothek-fur-bildungsgeschichtliche-forschung": c20,
    "bibliotheque-d-archeologie-mediterraneenne-et-africaine-biama": c21,
    "bibliotheque-universitaire-de-medecine-vancouver": c22,
    "bibtex": c23,
    "biens-symboliques-symbolic-goods": c24,
    "bio-protocol": c25,
    "bioarchaeology-international": c01,
    "bioarchaeology-of-the-near-east": c02,
    "biochemical-journal": c03,
    "biochemical-society-transactions": c04,
    "biochemistry-and-molecular-biology-education": c05,
    "biochemistry": c06,
    "biochimica-et-biophysica-acta": c07,
    "bioelectromagnetics": c08,
    "bioethics": c09,
    "biofuel-research-journal": c10,
    "biologia": c11,
    "biological-and-pharmaceutical-bulletin": c12,
    "biological-journal-of-the-linnean-society": c13,
    "biological-psychiatry": c14,
    "biological-reviews": c15,
    "biologiceskie-membrany": c16,
    "biology-of-reproduction": c17,
    "biomarkers": c18,
    "biomed-central": c19,
    "biomed-research-international": c20,
    "biometrics": c21,
    "biomolecular-concepts": c22,
    "biophysical-journal": c23,
    "biophysics-and-physicobiology": c24,
    "biopolymers": c25,
    "bioresources": c01,
    "bioscience": c02,
    "biosocieties": c03,
    "biostatistics": c04,
    "biota-neotropica": c05,
    "biotechniques": c06,
    "biotechnology-and-bioengineering": c07,
    "biotechnology-and-bioprocess-engineering": c08,
    "biotropica": c09,
    "bitonline": c10,
    "biuletyn-polskiego-towarzystwa-jezykoznawczego": c11,
    "bloomsbury-academic": c12,
    "bluebook-inline": c13,
    "bluebook-law-review-with-abstract": c14,
    "bluebook-law-review": c15,
    "bmj": c16,
    "body-and-society": c17,
    "boletin-de-la-sociedad-geologica-mexicana": c18,
    "boletin-de-pediatria": c19,
    "bollettino-d-archeologia-online": c20,
    "bollettino-della-societa-italiana-di-paleontologia": c21,
    "boreal-environment-research": c22,
    "boreas": c23,
    "borgyogyaszati-es-venerologiai-szemle": c24,
    "botanical-journal-of-the-linnean-society": c25,
    "bourgogne-franche-comte-nature": c01,
    "brachytherapy": c02,
    "brain-behavior-and-evolution": c03,
    "brazilian-journal-of-experimental-design-data-analysis-and-inferential-statistics": c04,
    "brazilian-journal-of-infectious-diseases": c05,
    "brazilian-journal-of-psychiatry": c06,
    "brazilian-journal-of-veterinary-research-and-animal-science": c07,
    "brazilian-oral-research": c08,
    "brewingscience": c09,
    "bristol-university-press": c10,
    "british-journal-of-anaesthesia": c11,
    "british-journal-of-cancer": c12,
    "british-journal-of-dermatology": c13,
    "british-journal-of-haematology": c14,
    "british-journal-of-industrial-relations": c15,
    "british-journal-of-nutrition": c16,
    "british-journal-of-pharmacology": c17,
    "british-journal-of-political-science": c18,
    "british-journal-of-surgery": c19,
    "british-psychological-society": c20,
    "brumaire-verlag": c21,
    "budownictwo-i-architektura-pl": c22,
    "building-structure": c23,
    "buletin-agrohorti": c24,
    "bulletin-de-correspondance-hellenique": c25,
    "bulletin-de-la-societe-entomologique-de-france": c01,
    "bulletin-de-la-societe-prehistorique-francaise": c02,
    "bulletin-du-centre-detudes-medievales-dauxerre": c03,
    "bulletin-of-applied-glycoscience": c04,
    "bulletin-of-geosciences": c05,
    "bulletin-of-insectology": c06,
    "bulletin-of-marine-science": c07,
    "bulletin-of-the-american-schools-of-oriental-research": c08,
    "bulletin-of-the-seismological-society-of-america": c09,
    "bursa-uludag-universitesi-egitim-bilimleri-enstitusu": c10,
    "bursa-uludag-universitesi-saglik-bilimleri-enstitusu": c11,
    "business-and-human-rights-journal": c12,
    "business-ethics-a-european-review": c13,
    "byzantina-symmeikta": c14,
    "byzantine-and-modern-greek-studies": c15,
    "cahiers-d-ethnomusicologie": c16,
    "cahiers-du-centre-gustave-glotz": c17,
    "cahiers-mondes-anciens": c18,
    "california-agriculture": c19,
    "cambridge-journal-of-economics": c20,
    "cambridge-quarterly-of-healthcare-ethics": c21,
    "cambridge-university-press-author-date-cambridge-a": c22,
    "cambridge-university-press-author-date": c23,
    "cambridge-university-press-law-note": c24,
    "cambridge-university-press-note": c25,
    "cambridge-university-press-numeric": c01,
    "campus-adventiste-du-saleve-faculte-adventiste-de-theologie": c02,
    "canadian-biosystems-engineering": c03,
    "canadian-geotechnical-journal": c04,
    "canadian-journal-of-chemistry": c05,
    "canadian-journal-of-criminology-and-criminal-justice": c06,
    "canadian-journal-of-dietetic-practice-and-research": c07,
    "canadian-journal-of-earth-sciences": c08,
    "canadian-journal-of-economics": c09,
    "canadian-journal-of-fisheries-and-aquatic-sciences": c10,
    "canadian-journal-of-mineralogy-and-petrology": c11,
    "canadian-journal-of-physics": c12,
    "canadian-journal-of-public-health": c13,
    "canadian-journal-of-remote-sensing": c14,
    "canadian-journal-of-soil-science": c15,
    "canadian-public-policy": c16,
    "canadian-urological-association-journal": c17,
    "cancer-biomarkers": c18,
    "cancer-drug-resistance": c19,
    "cancer-translational-medicine": c20,
    "cardiff-university-harvard": c21,
    "cardiff-university-vancouver": c22,
    "cardiocore": c23,
    "carolinea": c24,
    "casopis-pro-pravni-vedu-a-praxi": c25,
    "cath-lab-digest": c01,
    "catholic-biblical-association": c02,
    "cell-numeric": c03,
    "cell-research": c04,
    "cell-structure-and-function": c05,
    "cell-transplantation": c06,
    "cell": c07,
    "cellular-and-molecular-bioengineering": c08,
    "cellular-and-molecular-gastroenterology-and-hepatology": c09,
    "centaurus": c10,
    "centre-de-recherche-sur-les-civilisations-de-l-asie-orientale-auteur-date": c11,
    "centre-de-recherche-sur-les-civilisations-de-l-asie-orientale": c12,
    "centro-regional-de-estudios-teologicos-de-aragon": c13,
    "ceska-zemedelska-univerzita-v-praze-fakulta-agrobiologie-potravinovych-a-prirodnich-zdroju": c14,
    "changer-d-epoque": c15,
    "chemical-and-pharmaceutical-bulletin": c16,
    "chemical-biology-and-drug-design": c17,
    "chemical-engineering-progress": c18,
    "chemical-engineering-technology": c19,
    "chemie-ingenieur-technik": c20,
    "chemistry-education-research-and-practice": c21,
    "chest": c22,
    "chicago-author-date-16th-edition": c23,
    "chicago-author-date-17th-edition": c24,
    "chicago-author-date-access-dates": c25,
    "chicago-author-date-archive-place-first-no-url": c01,
    "chicago-author-date-archive-place-first": c02,
    "chicago-author-date-basque": c03,
    "chicago-author-date-classic-no-url": c04,
    "chicago-author-date-classic": c05,
    "chicago-author-date-de": c06,
    "chicago-author-date-fr": c07,
    "chicago-author-date-no-url": c08,
    "chicago-author-date": c09,
    "chicago-in-text-full-no-url": c10,
    "chicago-in-text-full": c11,
    "chicago-in-text-shortened-author-no-url": c12,
    "chicago-in-text-shortened-author-title-no-url": c13,
    "chicago-in-text-shortened-author-title": c14,
    "chicago-in-text-shortened-author": c15,
    "chicago-notes-archive-place-first-no-url": c16,
    "chicago-notes-archive-place-first": c17,
    "chicago-notes-bibliography-16th-edition": c18,
    "chicago-notes-bibliography-17th-edition": c19,
    "chicago-notes-bibliography-access-dates": c20,
    "chicago-notes-bibliography-annotated-abstract": c21,
    "chicago-notes-bibliography-annotated": c22,
    "chicago-notes-bibliography-archive-place-first-no-url": c23,
    "chicago-notes-bibliography-archive-place-first": c24,
    "chicago-notes-bibliography-classic-archive-place-first-no-url": c25,
    "chicago-notes-bibliography-classic-archive-place-first": c01,
    "chicago-notes-bibliography-classic-no-url": c02,
    "chicago-notes-bibliography-classic": c03,
    "chicago-notes-bibliography-fr": c04,
    "chicago-notes-bibliography-no-url": c05,
    "chicago-notes-bibliography-subsequent-author-classic-no-url": c06,
    "chicago-notes-bibliography-subsequent-author-classic": c07,
    "chicago-notes-bibliography-subsequent-author-no-url": c08,
    "chicago-notes-bibliography-subsequent-author-title-17th-edition": c09,
    "chicago-notes-bibliography-subsequent-author": c10,
    "chicago-notes-bibliography-subsequent-ibid-17th-edition": c11,
    "chicago-notes-bibliography-subsequent-ibid-classic-no-url": c12,
    "chicago-notes-bibliography-subsequent-ibid-classic": c13,
    "chicago-notes-bibliography-subsequent-ibid-no-url": c14,
    "chicago-notes-bibliography-subsequent-ibid": c15,
    "chicago-notes-bibliography-subsequent-title-no-url": c16,
    "chicago-notes-bibliography-subsequent-title": c17,
    "chicago-notes-bibliography": c18,
    "chicago-notes-classic-archive-place-first-no-url": c19,
    "chicago-notes-classic-archive-place-first": c20,
    "chicago-notes-classic-no-url": c21,
    "chicago-notes-classic": c22,
    "chicago-notes-no-url": c23,
    "chicago-notes-publisher-place-archive-place-first-no-url": c24,
    "chicago-notes-publisher-place-archive-place-first": c25,
    "chicago-notes-publisher-place-label-page-archive-place-first-no-url": c01,
    "chicago-notes-publisher-place-label-page-archive-place-first": c02,
    "chicago-notes-publisher-place-no-url": c03,
    "chicago-notes-publisher-place": c04,
    "chicago-notes": c05,
    "chicago-shortened-notes-bibliography-16th-edition": c06,
    "chicago-shortened-notes-bibliography-17th-edition": c07,
    "chicago-shortened-notes-bibliography-access-dates": c08,
    "chicago-shortened-notes-bibliography-archive-place-first-no-url": c09,
    "chicago-shortened-notes-bibliography-archive-place-first": c10,
    "chicago-shortened-notes-bibliography-classic-archive-place-first-no-url": c11,
    "chicago-shortened-notes-bibliography-classic-archive-place-first": c12,
    "chicago-shortened-notes-bibliography-classic-no-url": c13,
    "chicago-shortened-notes-bibliography-classic": c14,
    "chicago-shortened-notes-bibliography-no-url": c15,
    "chicago-shortened-notes-bibliography-subsequent-author-classic-no-url": c16,
    "chicago-shortened-notes-bibliography-subsequent-author-classic": c17,
    "chicago-shortened-notes-bibliography-subsequent-author-no-url": c18,
    "chicago-shortened-notes-bibliography-subsequent-author-title-17th-edition": c19,
    "chicago-shortened-notes-bibliography-subsequent-author": c20,
    "chicago-shortened-notes-bibliography-subsequent-ibid-17th-edition": c21,
    "chicago-shortened-notes-bibliography-subsequent-ibid-classic-no-url": c22,
    "chicago-shortened-notes-bibliography-subsequent-ibid-classic": c23,
    "chicago-shortened-notes-bibliography-subsequent-ibid-no-url": c24,
    "chicago-shortened-notes-bibliography-subsequent-ibid": c25,
    "chicago-shortened-notes-bibliography-subsequent-title-no-url": c01,
    "chicago-shortened-notes-bibliography-subsequent-title": c02,
    "chicago-shortened-notes-bibliography": c03,
    "chimia": c04,
    "china-information": c05,
    "china-national-standard-gb-t-7714-2015-author-date": c06,
    "china-national-standard-gb-t-7714-2015-note": c07,
    "china-national-standard-gb-t-7714-2015-numeric": c08,
    "china-national-standard-gb-t-7714-2025-author-date": c09,
    "china-national-standard-gb-t-7714-2025-note": c10,
    "china-national-standard-gb-t-7714-2025-numeric": c11,
    "chinese-gb7714-1987-numeric": c12,
    "chinese-gb7714-2005-author-date": c13,
    "chinese-gb7714-2005-numeric": c14,
    "chinese-journal-of-aeronautics": c15,
    "chinese-medical-journal": c16,
    "chinese-science-bulletin": c17,
    "chroniques-des-activites-archeologiques-de-l-ecole-francaise-de-rome": c18,
    "chungara-revista-de-antropologia-chilena": c19,
    "circulation-journal": c20,
    "cirugia-cardiovascular": c21,
    "citation-compass-apa-note": c22,
    "citizen-science-theory-and-practice": c23,
    "civil-engineering-journal": c24,
    "civilta-italiana": c25,
    "civitas-revista-de-ciencias-sociais": c01,
    "cladistics": c02,
    "clara-architecture-recherche": c03,
    "clay-minerals": c04,
    "clays-and-clay-minerals": c05,
    "climate-change-economics": c06,
    "clinica-e-investigacion-en-arteriosclerosis": c07,
    "clinical-anatomy": c08,
    "clinical-dysmorphology": c09,
    "clinical-gastroenterology-and-hepatology": c10,
    "clinical-hemorheology-and-microcirculation": c11,
    "clinical-infectious-diseases": c12,
    "clinical-journal-of-sport-medicine": c13,
    "clinical-journal-of-the-american-society-of-nephrology": c14,
    "clinical-management-issues": c15,
    "clinical-nuclear-medicine": c16,
    "clinical-oral-implants-research": c17,
    "clinical-orthopaedics-and-related-research": c18,
    "clinical-otolaryngology": c19,
    "clinical-pharmacology-and-therapeutics": c20,
    "clinical-physiology-and-functional-imaging": c21,
    "clinical-radiology": c22,
    "clinical-spine-surgery": c23,
    "clio-medica": c24,
    "cns-and-neurological-disorders-drug-targets": c25,
    "cns-spectrums": c01,
    "cold-spring-harbor-laboratory-press": c02,
    "collection-de-l-ecole-francaise-de-rome-full-note": c03,
    "collection-de-l-ecole-francaise-de-rome-note": c04,
    "collection-du-centre-jean-berard": c05,
    "collections-electroniques-de-l-inha-author-date": c06,
    "collections-electroniques-de-l-inha-full-note": c07,
    "college-montmorency": c08,
    "college-of-naturopathic-medicine": c09,
    "colombian-journal-of-anesthesiology": c10,
    "colorado-state-university-school-of-biomedical-engineering": c11,
    "comision-economica-para-america-latina-y-el-caribe": c12,
    "common-market-law-review": c13,
    "communication-et-langages": c14,
    "comparativ": c15,
    "comparative-parasitology": c16,
    "comparative-politics": c17,
    "comparative-population-studies": c18,
    "comptes-rendus-author-date": c19,
    "comptes-rendus-numeric": c20,
    "computer-supported-cooperative-work": c21,
    "computer-und-recht": c22,
    "conservation-and-society": c23,
    "conservation-biology": c24,
    "conservation-letters": c25,
    "conservation-physiology": c01,
    "constructivist-foundations": c02,
    "contemporary-accounting-research": c03,
    "continuity-and-change": c04,
    "contributions-to-the-archaeology-of-egypt-nubia-and-the-levant": c05,
    "copeia": c06,
    "copenhagen-university-legal-proper-attribution": c07,
    "copernicus-publications": c08,
    "coral-reefs": c09,
    "cornea": c10,
    "corrosion": c11,
    "cranfield-university-numeric": c12,
    "creativity-and-innovation-management": c13,
    "critical-care-medicine": c14,
    "critical-reviews-in-plant-sciences": c15,
    "critical-reviews-in-solid-state-and-materials-sciences": c16,
    "cronache-di-archeologia": c17,
    "crop-breeding-and-applied-biotechnology": c18,
    "crustaceana": c19,
    "cse-citation-name-8th-edition": c20,
    "cse-citation-name": c21,
    "cse-citation-sequence-8th-edition": c22,
    "cse-citation-sequence-brackets-8th-edition": c23,
    "cse-citation-sequence": c24,
    "cse-name-year-8th-edition": c25,
    "cse-name-year": c01,
    "cuadernos-de-filologia-clasica": c02,
    "cultivos-tropicales": c03,
    "cultural-geographies": c04,
    "cultural-studies-of-science-education": c05,
    "culture-medicine-and-psychiatry": c06,
    "cumhuriyet-universitesi-fen-bilimleri-enstitusu": c07,
    "cureus": c08,
    "current-alzheimer-research": c09,
    "current-gene-therapy": c10,
    "current-neurology-aktualnosci-neurologiczne": c11,
    "current-opinion-in-endocrinology-diabetes-and-obesity": c12,
    "current-opinion": c13,
    "current-organic-synthesis": c14,
    "current-pharmaceutical-design": c15,
    "current-proteomics": c16,
    "current-protocols": c17,
    "current-science": c18,
    "current-topics-in-medicinal-chemistry": c19,
    "currents-in-biblical-research": c20,
    "cybium": c21,
    "cytometry": c22,
    "czech-journal-of-international-relations": c23,
    "data-science-journal": c24,
    "database": c25,
    "de-buck": c01,
    "decision-sciences": c02,
    "degruyter-american-chemical-society": c03,
    "demographic-research": c04,
    "der-moderne-staat": c05,
    "dermatology-online-journal": c06,
    "deutsche-gesellschaft-fur-psychologie": c07,
    "deutsche-sprache": c08,
    "deutsche-zeitschrift-fur-sportmedizin": c09,
    "deutsches-archaologisches-institut-romisch-germanische-kommission-author-date": c10,
    "deutsches-archaologisches-institut": c11,
    "deutsches-arzteblatt": c12,
    "developing-world-bioethics": c13,
    "development-and-change": c14,
    "development-policy-review": c15,
    "developmental-dynamics": c16,
    "developmental-medicine-and-child-neurology": c17,
    "developmental-neurobiology": c18,
    "diabetologia": c19,
    "diagnostico-prenatal": c20,
    "dialisis-y-trasplante": c21,
    "diatom-research": c22,
    "die-bachelorarbeit-samac-et-al-in-text": c23,
    "die-bachelorarbeit-samac-et-al-note": c24,
    "digestive-and-liver-disease": c25,
    "digital-humanities-im-deutschsprachigen-raum": c01,
    "din-1505-2-alphanumeric": c02,
    "din-1505-2-numeric-alphabetical": c03,
    "din-1505-2-numeric": c04,
    "din-1505-2": c05,
    "diplo": c06,
    "disability-and-rehabilitation": c07,
    "discover-food": c08,
    "discovery-medicine": c09,
    "documents-d-archeologie-francaise": c10,
    "donau-universitat-krems-department-fur-e-governance-in-wirthschaft-und-verwaltung": c11,
    "drug-development-research": c12,
    "drug-testing-and-analysis": c13,
    "drugs-of-today": c14,
    "duale-hochschule-baden-wurttemberg-department-of-international-business": c15,
    "duale-hochschule-baden-wurttemberg-villingen-schwenningen-roter-grubert-mattern": c16,
    "durban-university-of-technology-harvard": c17,
    "e3s-web-of-conferences": c18,
    "ear-and-hearing": c19,
    "early-christianity": c20,
    "early-medieval-europe": c21,
    "earth-surface-processes-and-landforms": c22,
    "earthquake-engineering-and-structural-dynamics": c23,
    "earthquake-spectra": c24,
    "ecclesial-practices": c25,
    "ecole-de-technologie-superieure-apa": c01,
    "ecole-pratique-des-hautes-etudes-sciences-historiques-et-philologiques": c02,
    "ecological-entomology": c03,
    "ecological-restoration": c04,
    "ecology-and-society": c05,
    "ecology-letters": c06,
    "ecology-of-freshwater-fish": c07,
    "ecology": c08,
    "econometrica": c09,
    "economia-y-politica": c10,
    "economic-commission-for-latin-america-and-the-caribbean": c11,
    "economic-geology": c12,
    "economie-et-statistique": c13,
    "ecoscience": c14,
    "ecosistemas": c15,
    "ecosystems": c16,
    "edward-elgar-business-and-social-sciences": c17,
    "effective-altruism-wiki": c18,
    "egretta": c19,
    "einaudi": c20,
    "eksploatacja-i-niezawodnosc": c21,
    "el-profesional-de-la-informacion": c22,
    "electrophoresis": c23,
    "elementa": c24,
    "elife": c25,
    "elsevier-american-chemical-society": c01,
    "elsevier-harvard-without-titles": c02,
    "elsevier-harvard": c03,
    "elsevier-harvard2": c04,
    "elsevier-vancouver-author-date-alphabetical": c05,
    "elsevier-vancouver-author-date": c06,
    "elsevier-vancouver-no-et-al": c07,
    "elsevier-vancouver-short-author-list": c08,
    "elsevier-vancouver": c09,
    "elsevier-with-titles-alphabetical": c10,
    "elsevier-with-titles": c11,
    "elsevier-without-titles": c12,
    "em-normandie-business-school-harvard-english": c13,
    "em-normandie-business-school-harvard-francais": c14,
    "embnet-journal": c15,
    "embo-press": c16,
    "emerald-harvard": c17,
    "emu-austral-ornithology": c18,
    "endocrine-connections": c19,
    "endocrine-journal": c20,
    "endocrine-press": c21,
    "endoscopia": c22,
    "energy-research-and-social-science": c23,
    "eneuro": c24,
    "enfances-familles-generations": c25,
    "enfermeria-clinica": c01,
    "enfermeria-intensiva": c02,
    "engineered-regeneration": c03,
    "engineering-in-life-sciences": c04,
    "engineering-technology-and-applied-science-research": c05,
    "ens-de-lyon-centre-d-ingenierie-documentaire": c06,
    "entecho": c07,
    "entomologia-experimentalis-et-applicata": c08,
    "entomological-review": c09,
    "entomological-society-of-america": c10,
    "environment-and-planning": c11,
    "environment-and-urbanization": c12,
    "environmental-and-engineering-geoscience": c13,
    "environmental-chemistry": c14,
    "environmental-conservation": c15,
    "environmental-health-perspectives": c16,
    "environmental-microbiology": c17,
    "environmental-values": c18,
    "environnement-risques-et-sante": c19,
    "ephemerides-theologicae-lovanienses": c20,
    "epidemiologie-et-sante-animale": c21,
    "epidemiology-and-infection": c22,
    "epidemiology-psychiatric-sciences": c23,
    "epilepsia": c24,
    "equine-veterinary-education": c25,
    "equine-veterinary-journal": c01,
    "ergo": c02,
    "ergoscience": c03,
    "errata": c04,
    "escuela-nacional-de-antropologia-e-historia-author-date": c05,
    "escuela-nacional-de-antropologia-e-historia-full-note": c06,
    "escuela-nacional-de-antropologia-e-historia-short-note": c07,
    "estonian-journal-of-archaeology": c08,
    "estonian-journal-of-earth-sciences": c09,
    "estudios-de-cultura-maya": c10,
    "estudios-de-fonetica-experimental": c11,
    "estudios-hispanicos": c12,
    "ethics-book-reviews": c13,
    "ethnobiology-and-conservation": c14,
    "ethnobiology-letters": c15,
    "ethnographiques-org": c16,
    "ethnologie-francaise": c17,
    "ethnomusicology": c18,
    "etri-journal": c19,
    "ets-ecole-de-technologie-superieure": c20,
    "etudes-chinoises": c21,
    "etudes-francaises": c22,
    "eu-interinstitutional-style": c23,
    "eunomia-revista-en-cultura-de-la-legalidad": c24,
    "eurasian-journal-of-medical-investigation": c25,
    "eurasian-journal-of-medicine-and-oncology": c01,
    "eurointervention": c02,
    "europace": c03,
    "european-cells-and-materials": c04,
    "european-environment-agency-numeric": c05,
    "european-environment-agency": c06,
    "european-journal-for-philosophy-of-religion": c07,
    "european-journal-of-anaesthesiology": c08,
    "european-journal-of-clinical-microbiology-and-infectious-diseases": c09,
    "european-journal-of-emergency-medicine": c10,
    "european-journal-of-endocrinology": c11,
    "european-journal-of-entomology": c12,
    "european-journal-of-human-genetics": c13,
    "european-journal-of-immunology": c14,
    "european-journal-of-information-systems": c15,
    "european-journal-of-international-law": c16,
    "european-journal-of-lipid-science-and-technology": c17,
    "european-journal-of-microbiology-and-immunology": c18,
    "european-journal-of-neuroscience": c19,
    "european-journal-of-ophthalmology": c20,
    "european-journal-of-paediatric-neurology": c21,
    "european-journal-of-pain": c22,
    "european-journal-of-political-research": c23,
    "european-journal-of-public-health": c24,
    "european-journal-of-soil-science": c25,
    "european-journal-of-taxonomy": c01,
    "european-journal-of-theology": c02,
    "european-journal-of-ultrasound": c03,
    "european-journal-of-vascular-and-endovascular-surgery": c04,
    "european-journal-physical-medicine-and-rehabilitation": c05,
    "european-respiratory-journal": c06,
    "european-retail-research": c07,
    "european-review-of-agricultural-economics": c08,
    "european-review-of-international-studies": c09,
    "european-society-of-cardiology": c10,
    "european-union-interinstitutional-style-guide-author-date": c11,
    "european-union-interinstitutional-style-guide": c12,
    "eva-berlin-konferenz": c13,
    "evangelikus-hittudomanyi-egyetem": c14,
    "evidence-based-complementary-and-alternative-medicine": c15,
    "evolution-and-development": c16,
    "evolution-letters": c17,
    "evolution": c18,
    "evolutionary-anthropology": c19,
    "evolutionary-ecology-research": c20,
    "excli-journal": c21,
    "exercer": c22,
    "experimental-biology-and-medicine": c23,
    "experimental-biomedical-research": c24,
    "expert-reviews-in-molecular-medicine": c25,
    "exploration-of-targeted-anti-tumor-therapy": c01,
    "express-polymer-letters": c02,
    "extracellular-vesicles-and-circulating-nucleic-acids": c03,
    "eye": c04,
    "facets": c05,
    "fachhochschule-kiel-fachbereich-medien": c06,
    "fachhochschule-sudwestfalen": c07,
    "fachhochschule-vorarlberg-author-date": c08,
    "fachhochschule-vorarlberg-note": c09,
    "facial-plastic-surgery-clinics-of-north-america": c10,
    "facolta-teologica-dell-italia-settentrionale-milano": c11,
    "family-business-review": c12,
    "farmeconomia": c13,
    "fatigue-and-fracture-of-engineering-materials-and-structures": c14,
    "feminist-economics": c15,
    "feminist-theory": c16,
    "ferdinand-porsche-fern-fachhochschule": c17,
    "ferdinand-porsche-fernfh-betriebswirtschaft-und-wirtschaftspsychologie-dgps": c18,
    "fertility-and-sterility": c19,
    "fh-joanneum-institute-of-software-design-and-security": c20,
    "finance-and-society": c21,
    "finanzarchiv": c22,
    "fine-focus": c23,
    "firephyschem": c24,
    "first-break": c25,
    "first-monday": c01,
    "fishery-bulletin": c02,
    "fizyoloji-medical-journal": c03,
    "flavour-and-fragrance-journal": c04,
    "florida-entomologist": c05,
    "flux": c06,
    "focaal-journal-of-global-and-historical-anthropology": c07,
    "foerster-geisteswissenschaft": c08,
    "fold-and-r": c09,
    "folia-amazonica": c10,
    "folia-biologica": c11,
    "folia-malacologica": c12,
    "folia-morphologia": c13,
    "food-and-agriculture-organization-of-the-united-nations-numeric": c14,
    "food-and-agriculture-organization-of-the-united-nations": c15,
    "food-science-and-biotechnology": c16,
    "forensic-anthropology": c17,
    "forensic-science-review": c18,
    "forest-science": c19,
    "forestry": c20,
    "forschungsjournal-soziale-bewegungen-fjsb": c21,
    "forum-qualitative-social-research": c22,
    "forum-qualitative-sozialforschung": c23,
    "frattura-ed-integrita-strutturale-fracture-and-structural-integrity": c24,
    "free-radical-research": c25,
    "freie-hochschule-stuttgart": c01,
    "freie-universitat-berlin-geographische-wissenschaften": c02,
    "french-politics": c03,
    "french1": c04,
    "french2": c05,
    "french3": c06,
    "french4": c07,
    "freshwater-biology": c08,
    "freshwater-crayfish": c09,
    "freshwater-science": c10,
    "friedrich-schiller-universitat-jena-medizinische-fakultat": c11,
    "frontiers-in-bioscience": c12,
    "frontiers-in-ecology-and-the-environment": c13,
    "frontiers-in-optics": c14,
    "frontiers-in-physics": c15,
    "frontiers-medical-journals": c16,
    "frontiers": c17,
    "fundamental-and-applied-limnology": c18,
    "future-medicine": c19,
    "future-science-group": c20,
    "g-giappichelli-editore": c21,
    "gaceta-sanitaria": c22,
    "gaia": c23,
    "gait-and-posture": c24,
    "galatasaray-universitesi-sosyal-bilimler-enstitusu": c25,
    "gallia-prehistoire": c01,
    "gallia": c02,
    "gastroenterology": c03,
    "gastrointestinal-endoscopy-clinics-of-north-america": c04,
    "gastrointestinal-intervention": c05,
    "gayana-botanica": c06,
    "gayana": c07,
    "gazeta-medica": c08,
    "geistes-und-kulturwissenschaften-heilmann": c09,
    "gender-and-society": c10,
    "gender-zeitschrift-fur-geschlecht-kultur-und-gesellschaft": c11,
    "generic-style-rules-for-linguistics": c12,
    "genes-brain-and-behavior": c13,
    "genes-to-cells": c14,
    "geneses": c15,
    "genetics-and-molecular-biology": c16,
    "gengo-kenkyu-journal-of-the-linguistic-society-of-japan": c17,
    "genomics-and-informatics": c18,
    "geoarchaeology": c19,
    "geobiology": c20,
    "geochemical-perspectives-letters": c21,
    "geochimica-et-cosmochimica-acta": c22,
    "geochronometria": c23,
    "geografia-fisica-e-dinamica-quaternaria": c24,
    "geografie-sbornik-cgs": c25,
    "geographical-analysis": c01,
    "geographie-et-cultures": c02,
    "geographische-zeitschrift": c03,
    "geological-magazine": c04,
    "geophysical-journal-international": c05,
    "geophysics": c06,
    "geopolitics": c07,
    "georg-august-universitat-gottingen-institut-fur-ethnologie-und-ethnologische-sammlung": c08,
    "geriatrics-and-gerontology-international": c09,
    "geriatrie-et-psychologie-neuropsychiatrie-du-vieillissement": c10,
    "german-council-of-economic-experts": c11,
    "german-journal-of-agricultural-economics": c12,
    "german-yearbook-of-international-law": c13,
    "geschichte-und-gesellschaft": c14,
    "gesellschaft-fur-popularmusikforschung": c15,
    "gewerblicher-rechtsschutz-und-urheberrecht": c16,
    "gigascience": c17,
    "global-ecology-and-biogeography": c18,
    "glossa": c19,
    "gnosis-journal-of-gnostic-studies": c20,
    "gost-r-7-0-5-2008-numeric-alphabetical": c21,
    "gost-r-7-0-5-2008-numeric": c22,
    "gost-r-7-0-5-2008": c23,
    "government-and-opposition": c24,
    "grasas-y-aceites": c25,
    "greek-and-roman-musical-studies": c01,
    "griffith-college-harvard": c02,
    "groundwater": c03,
    "groupe-danthropologie-et-darcheologie-funeraire": c04,
    "guide-des-citations-references-et-abreviations-juridiques": c05,
    "guide-pour-la-redaction-et-la-presentation-des-theses-a-lusage-des-doctorants": c06,
    "haaga-helia-university-of-applied-sciences-harvard": c07,
    "haematologica": c08,
    "haemophilia": c09,
    "haffner-style-manual": c10,
    "hainan-medical-university-journal-publisher": c11,
    "hamburg-school-of-food-science": c12,
    "hand": c13,
    "handbook-of-clinical-neurology": c14,
    "harvard-anglia-ruskin-university": c15,
    "harvard-bournemouth-university": c16,
    "harvard-cape-peninsula-university-of-technology": c17,
    "harvard-cite-them-right-10th-edition": c18,
    "harvard-cite-them-right-11th-edition": c19,
    "harvard-cite-them-right-no-et-al": c20,
    "harvard-cite-them-right": c21,
    "harvard-coventry-university": c22,
    "harvard-cranfield-university": c23,
    "harvard-deakin-university": c24,
    "harvard-dundalk-institute-of-technology": c25,
    "harvard-durham-university-business-school": c01,
    "harvard-edge-hill-university": c02,
    "harvard-european-archaeology": c03,
    "harvard-fachhochschule-salzburg": c04,
    "harvard-falmouth-university": c05,
    "harvard-gesellschaft-fur-bildung-und-forschung-in-europa": c06,
    "harvard-institut-fur-praxisforschung-de": c07,
    "harvard-kings-college-london": c08,
    "harvard-leeds-beckett-university": c09,
    "harvard-leeds-metropolitan-university": c10,
    "harvard-limerick": c11,
    "harvard-london-south-bank-university": c12,
    "harvard-manchester-business-school": c13,
    "harvard-manchester-metropolitan-university": c14,
    "harvard-melbourne-polytechnic": c15,
    "harvard-newcastle-university": c16,
    "harvard-north-west-university": c17,
    "harvard-pontificia-universidad-catolica-del-ecuador": c18,
    "harvard-review-of-psychiatry": c19,
    "harvard-robert-gordon-university": c20,
    "harvard-staffordshire-university": c21,
    "harvard-stellenbosch-university": c22,
    "harvard-swinburne-university-of-technology": c23,
    "harvard-the-university-of-northampton": c24,
    "harvard-the-university-of-sheffield-school-of-east-asian-studies": c25,
    "harvard-the-university-of-sheffield-town-and-regional-planning": c01,
    "harvard-theologisches-seminar-adelshofen": c02,
    "harvard-universiti-teknologi-malaysia": c03,
    "harvard-universiti-tunku-abdul-rahman": c04,
    "harvard-university-for-the-creative-arts": c05,
    "harvard-university-of-abertay-dundee": c06,
    "harvard-university-of-bath": c07,
    "harvard-university-of-birmingham": c08,
    "harvard-university-of-brighton-school-of-environment-and-technology": c09,
    "harvard-university-of-cape-town": c10,
    "harvard-university-of-exeter-geography": c11,
    "harvard-university-of-greenwich": c12,
    "harvard-university-of-kent": c13,
    "harvard-university-of-leeds": c14,
    "harvard-university-of-technology-sydney": c15,
    "harvard-university-of-the-west-of-england": c16,
    "harvard-university-of-the-west-of-scotland": c17,
    "harvard-university-of-westminster": c18,
    "harvard-university-of-wolverhampton": c19,
    "harvard-xi-an-jiaotong-liverpool-university": c20,
    "harvard-york-st-john-university": c21,
    "haute-ecole-de-gestion-de-geneve-iso-690": c22,
    "haute-ecole-pedagogique-fribourg": c23,
    "hawaii-international-conference-on-system-sciences-proceedings": c24,
    "health-and-human-rights-journal": c25,
    "health-and-social-care-in-the-community": c01,
    "health-economics-policy-and-law": c02,
    "health-economics": c03,
    "health-education-england-harvard": c04,
    "health-education-research": c05,
    "health-physics": c06,
    "health-reform-observer-observatoire-des-reformes-de-sante": c07,
    "health-sciences-university-uco-school-of-osteopathy": c08,
    "health-sports-and-rehabilitation-medicine": c09,
    "heart-failure-clinics": c10,
    "heart-rhythm": c11,
    "heidelberg-university-faculty-of-medicine": c12,
    "heiliger-dienst": c13,
    "helvetica-chimica-acta": c14,
    "hematology-oncology-clinics-of-north-america": c15,
    "hemijska-industrija": c16,
    "henoch": c17,
    "hepatology": c18,
    "heredity": c19,
    "herpetologica": c20,
    "hiob-ludolf-centre-for-ethiopian-studies-long-names": c21,
    "hiob-ludolf-centre-for-ethiopian-studies-with-url-doi": c22,
    "hiob-ludolf-centre-for-ethiopian-studies": c23,
    "hipertension-y-riesgo-vascular": c24,
    "histoire-at-politique": c25,
    "histoire-et-mesure": c01,
    "histopathology": c02,
    "historia-scribere": c03,
    "historical-materialism": c04,
    "historio-plus": c05,
    "history-and-theory": c06,
    "history-of-the-human-sciences": c07,
    "hochschule-bonn-rhein-sieg": c08,
    "hochschule-der-kunste-bern-musikforschung": c09,
    "hochschule-fur-soziale-arbeit-fhnw": c10,
    "hochschule-fur-wirtschaft-und-recht-berlin": c11,
    "hochschule-hannover-soziale-arbeit": c12,
    "hochschule-munchen-fakultat-fur-angewandte-sozialwissenschaften": c13,
    "hochschule-osnabruck-fakultat-agrarwissenschaften-und-landschaftsarchitektur": c14,
    "hochschule-pforzheim-fakultat-fur-wirtschaft-und-recht": c15,
    "hochschule-rheinmain-wiesbaden-business-school-gesundheitsokonomie": c16,
    "homeopathy-thieme": c17,
    "hong-kong-journal-of-radiology": c18,
    "hospital-a-domicilio": c19,
    "housing-studies": c20,
    "howard-hughes-medical-institute": c21,
    "hpb": c22,
    "hue-university-of-medicine-and-pharmacy": c23,
    "human-brain-mapping": c24,
    "human-ecology": c25,
    "human-molecular-genetics": c01,
    "human-mutation": c02,
    "human-reproduction-update": c03,
    "human-reproduction": c04,
    "human-resource-management-journal": c05,
    "human-rights-law-review": c06,
    "human-wildlife-interactions": c07,
    "humboldt-state-university-environmental-resources-engineering": c08,
    "hydrobiologia": c09,
    "hydrological-processes": c10,
    "hydrological-sciences-journal": c11,
    "hypertension-research": c12,
    "hypotheses-in-the-life-sciences": c13,
    "hystrix-the-italian-journal-of-mammalogy": c14,
    "iainutuban": c15,
    "iawa-journal": c16,
    "ib-tauris-note": c17,
    "ibis": c18,
    "idojaras-quarterly-journal-of-the-hungarian-meteorological-service": c19,
    "ie-comunicaciones": c20,
    "ieee-transactions-on-medical-imaging": c21,
    "ieee": c22,
    "iforest": c23,
    "igaku-toshokan": c24,
    "iica-catie": c25,
    "ilahiyat-studies": c01,
    "im-gesprach": c02,
    "imperial-college-london-author-date": c03,
    "imperial-college-london-numerical": c04,
    "incontext-studies-in-translation-and-interculturalism": c05,
    "indian-dermatology-online-journal": c06,
    "indian-journal-of-agricultural-sciences": c07,
    "indian-journal-of-medical-research": c08,
    "indian-journal-of-orthopaedics": c09,
    "indian-journal-of-physics": c10,
    "indian-journal-of-traditional-knowledge": c11,
    "indian-journal-of-veterinary-and-animal-sciences-research": c12,
    "indiana": c13,
    "indoor-air": c14,
    "infectio": c15,
    "infectious-disease-clinics-of-north-america": c16,
    "inflammatory-bowel-diseases": c17,
    "influenza-and-other-respiratory-viruses": c18,
    "infoclio-de-kurzbelege": c19,
    "infoclio-de": c20,
    "infoclio-fr-nocaps": c21,
    "infoclio-fr-smallcaps": c22,
    "infomin": c23,
    "informal-logic": c24,
    "informationswissenschaft-theorie-methode-praxis": c25,
    "ingenieria-agricola": c01,
    "innovations-therapeutiques-en-oncologie": c02,
    "instap-academic-press": c03,
    "institut-francais-darcheologie-orientale-arab-studies": c04,
    "institut-francais-darcheologie-orientale-en": c05,
    "institut-francais-darcheologie-orientale-etudes-arabes": c06,
    "institut-francais-darcheologie-orientale": c07,
    "institut-fur-geschichte-des-landlichen-raums": c08,
    "institut-national-de-la-recherche-scientifique-sciences-sociales": c09,
    "institut-national-de-recherches-archeologiques-preventives": c10,
    "institut-national-de-sante-publique-du-quebec-napp": c11,
    "institut-national-de-sante-publique-du-quebec-topo": c12,
    "institut-pertanian-bogor": c13,
    "institut-teknologi-bandung-sekolah-pascasarjana": c14,
    "institute-for-operations-research-and-the-management-sciences": c15,
    "institute-of-mathematical-statistics": c16,
    "institute-of-mathematics-and-its-applications": c17,
    "institute-of-physics-harvard": c18,
    "institute-of-physics-numeric": c19,
    "instituto-brasileiro-de-informacao-em-ciencia-e-tecnologia-abnt-initials": c20,
    "instituto-brasileiro-de-informacao-em-ciencia-e-tecnologia-abnt": c21,
    "instituto-de-investigaciones-sobre-la-universidad-y-la-educacion-moderno": c22,
    "instituto-de-pesquisas-energeticas-e-nucleares": c23,
    "instituto-de-pesquisas-tecnologicas": c24,
    "instituto-superior-de-teologia-de-las-islas-canarias": c25,
    "instituto-universitario-militar": c01,
    "instrumenta-patristica-et-mediaevalia": c02,
    "integrated-science-publishing-journals": c03,
    "integrative-and-comparative-biology": c04,
    "intellect-newgen-books": c05,
    "inter-research-science-center": c06,
    "inter-ro": c07,
    "interaction-design-and-architectures": c08,
    "interactive-cardiovascular-and-thoracic-surgery": c09,
    "interdisziplinare-anthropologie": c10,
    "interdisziplinare-zeitschrift-fur-technologie-und-lernen": c11,
    "interkulturelle-germanistik-gottingen": c12,
    "international-affairs": c13,
    "international-atomic-energy-agency": c14,
    "international-biodeterioration-and-biodegradation": c15,
    "international-brazilian-journal-of-urology": c16,
    "international-conference-on-information-systems-development": c17,
    "international-development-policy": c18,
    "international-energy-agency-organisation-for-economic-co-operation-and-development": c19,
    "international-islamic-university-malaysia-ahmad-ibrahim-kulliyyah-of-laws": c20,
    "international-journal-for-numerical-methods-in-biomedical-engineering": c21,
    "international-journal-of-audiology": c22,
    "international-journal-of-automotive-technology": c23,
    "international-journal-of-cancer": c24,
    "international-journal-of-circuit-theory-and-applications": c25,
    "international-journal-of-climatology": c01,
    "international-journal-of-clinical-research": c02,
    "international-journal-of-cosmetic-science": c03,
    "international-journal-of-electrochemical-science": c04,
    "international-journal-of-electronic-commerce": c05,
    "international-journal-of-epidemiology": c06,
    "international-journal-of-exercise-science": c07,
    "international-journal-of-food-science-and-technology": c08,
    "international-journal-of-geriatric-psychiatry": c09,
    "international-journal-of-humanoid-robotics": c10,
    "international-journal-of-language-and-communication-disorders": c11,
    "international-journal-of-management-reviews": c12,
    "international-journal-of-nuclear-security": c13,
    "international-journal-of-obstetric-anesthesia": c14,
    "international-journal-of-occupational-medicine-and-environmental-health": c15,
    "international-journal-of-oral-and-maxillofacial-surgery": c16,
    "international-journal-of-osteoarchaeology": c17,
    "international-journal-of-plant-sciences": c18,
    "international-journal-of-polymer-analysis-and-characterization": c19,
    "international-journal-of-polymeric-materials-and-polymeric-biomaterials": c20,
    "international-journal-of-population-data-science": c21,
    "international-journal-of-quantum-chemistry": c22,
    "international-journal-of-radiation-oncology-biology-physics": c23,
    "international-journal-of-research-in-exercise-physiology": c24,
    "international-journal-of-simulation-modelling": c25,
    "international-journal-of-spatial-data-infrastructures-research": c01,
    "international-journal-of-sports-medicine": c02,
    "international-journal-of-urban-and-regional-research": c03,
    "international-journal-of-wildland-fire": c04,
    "international-microbiology": c05,
    "international-organization": c06,
    "international-pig-veterinary-society-congress-proceedings": c07,
    "international-relations": c08,
    "international-review-of-the-red-cross": c09,
    "international-security": c10,
    "international-studies-association": c11,
    "international-union-of-crystallography": c12,
    "international-union-of-forest-research-organizations-headquarters": c13,
    "internet-archaeology": c14,
    "interpreting": c15,
    "inventaire-general-du-patrimoine-culturel-iso-690-full-note-with-ibid": c16,
    "inventaire-general-du-patrimoine-culturel-iso-690-full-note": c17,
    "inventaire-general-du-patrimoine-culturel-iso-690-note": c18,
    "invertebrate-biology": c19,
    "investigative-radiology": c20,
    "invisu": c21,
    "ios-press-books": c22,
    "ipag-business-school-apa": c23,
    "iran-manual-of-style": c24,
    "iranian-journal-of-basic-medical-sciences": c25,
    "iranian-journal-of-pharmaceutical-research": c01,
    "irish-historical-studies": c02,
    "isabella-stewart-gardner-museum": c03,
    "isara-iso-690": c04,
    "isnad-dipnotlu": c05,
    "isnad-metinici": c06,
    "isnad": c07,
    "iso690-author-date-cat": c08,
    "iso690-author-date-cs": c09,
    "iso690-author-date-de": c10,
    "iso690-author-date-en": c11,
    "iso690-author-date-es": c12,
    "iso690-author-date-fr-no-abstract": c13,
    "iso690-author-date-fr": c14,
    "iso690-author-date-pt-br": c15,
    "iso690-author-date-sk": c16,
    "iso690-full-note-cs": c17,
    "iso690-full-note-en": c18,
    "iso690-full-note-es": c19,
    "iso690-full-note-sk": c20,
    "iso690-full-note-with-ibid-ro": c21,
    "iso690-note-cs": c22,
    "iso690-note-fr": c23,
    "iso690-numeric-brackets-cs": c24,
    "iso690-numeric-cat": c25,
    "iso690-numeric-cs": c01,
    "iso690-numeric-en": c02,
    "iso690-numeric-fr": c03,
    "iso690-numeric-lt": c04,
    "iso690-numeric-sk": c05,
    "israel-medical-association-journal": c06,
    "istanbul-bilgi-universitesi-lisansustu-programlar-enstitusu-hukuk": c07,
    "istanbul-medical-journal": c08,
    "istanbul-universitesi-sosyal-bilimler-enstitusu": c09,
    "istanus-journal-on-applied-and-biological-sciences": c10,
    "italian-journal-of-agronomy": c11,
    "italus-hortus": c12,
    "ithaque": c13,
    "iubmb-life": c14,
    "ius-ecclesiae": c15,
    "izmir-katip-celebi-universitesi-sosyal-bilimler-enstitusu": c16,
    "jacc-cardiovascular-imaging": c17,
    "jacc-cardiovascular-interventions": c18,
    "jahrbuch-der-osterreichischen-byzantinischen-gesellschaft": c19,
    "jahrbuch-fur-evangelikale-theologie": c20,
    "japanese-journal-of-applied-physics": c21,
    "javnost-the-public": c22,
    "jbi-evidence-synthesis": c23,
    "jcom-journal-of-science-communication": c24,
    "john-benjamins-publishing-company-iconicity-in-language-and-literature": c25,
    "john-benjamins-publishing-company-linguistik-aktuell-linguistics-today": c01,
    "johnson-matthey-technology-review": c02,
    "journal-and-proceedings-of-the-royal-society-of-new-south-wales": c03,
    "journal-de-la-societe-des-americanistes": c04,
    "journal-de-la-societe-des-oceanistes": c05,
    "journal-der-deutschen-dermatologischen-gesellschaft": c06,
    "journal-for-the-history-of-astronomy": c07,
    "journal-for-the-study-of-the-new-testament": c08,
    "journal-for-veterinary-medicine-biotechnology-and-biosafety": c09,
    "journal-fur-kulturpflanzen-journal-of-cultivated-plants": c10,
    "journal-fur-kunstgeschichte": c11,
    "journal-fur-medienlinguistik": c12,
    "journal-of-accounting-research": c13,
    "journal-of-acoustics": c14,
    "journal-of-adolescent-health": c15,
    "journal-of-advanced-ceramics": c16,
    "journal-of-advertising-research": c17,
    "journal-of-agricultural-and-applied-economics": c18,
    "journal-of-agricultural-and-resource-economics": c19,
    "journal-of-alzheimers-disease": c20,
    "journal-of-anatomy": c21,
    "journal-of-animal-and-feed-sciences": c22,
    "journal-of-animal-physiology-and-animal-nutrition": c23,
    "journal-of-animal-science": c24,
    "journal-of-antimicrobial-chemotherapy": c25,
    "journal-of-aoac-international": c01,
    "journal-of-applied-animal-science": c02,
    "journal-of-applied-clinical-medical-physics": c03,
    "journal-of-applied-engineering-sciences-technology": c04,
    "journal-of-applied-entomology": c05,
    "journal-of-applied-glycoscience": c06,
    "journal-of-applied-pharmaceutical-research": c07,
    "journal-of-applied-philosophy": c08,
    "journal-of-applied-polymer-science": c09,
    "journal-of-archaeological-research": c10,
    "journal-of-atrial-fibrillation": c11,
    "journal-of-australian-strength-and-conditioning": c12,
    "journal-of-avian-biology": c13,
    "journal-of-basic-microbiology": c14,
    "journal-of-behavioral-health-and-psychology": c15,
    "journal-of-biological-chemistry": c16,
    "journal-of-biological-regulators-and-homeostatic-agents": c17,
    "journal-of-biomedical-materials-research-part-a": c18,
    "journal-of-bioscience-and-bioengineering": c19,
    "journal-of-biosciences": c20,
    "journal-of-bone-and-mineral-research": c21,
    "journal-of-brachial-plexus-and-peripheral-nerve-injury": c22,
    "journal-of-breast-cancer": c23,
    "journal-of-burn-care-and-research": c24,
    "journal-of-business-logistics": c25,
    "journal-of-cachexia-sarcopenia-and-muscle": c01,
    "journal-of-cardiothoracic-and-vascular-anesthesia": c02,
    "journal-of-cellular-and-molecular-medicine": c03,
    "journal-of-cellular-biochemistry": c04,
    "journal-of-chemistry-and-chemical-engineering": c05,
    "journal-of-chemometrics": c06,
    "journal-of-clinical-and-translational-science": c07,
    "journal-of-clinical-neurology": c08,
    "journal-of-clinical-neurophysiology": c09,
    "journal-of-clinical-oncology": c10,
    "journal-of-clinical-rheumatology": c11,
    "journal-of-clinical-sleep-medicine": c12,
    "journal-of-combinatorics": c13,
    "journal-of-common-market-studies": c14,
    "journal-of-comparative-pathology": c15,
    "journal-of-computational-chemistry": c16,
    "journal-of-computer-applications-in-archaeology": c17,
    "journal-of-computer-assisted-tomography": c18,
    "journal-of-computer-information-systems": c19,
    "journal-of-conchology": c20,
    "journal-of-consumer-research": c21,
    "journal-of-contemporary-medicine": c22,
    "journal-of-contemporary-water-research-and-education": c23,
    "journal-of-crohns-and-colitis-supplements": c24,
    "journal-of-crohns-and-colitis": c25,
    "journal-of-dairy-research": c01,
    "journal-of-dairy-science": c02,
    "journal-of-demographic-economics": c03,
    "journal-of-dental-research": c04,
    "journal-of-dental-traumatology": c05,
    "journal-of-early-christian-studies": c06,
    "journal-of-economic-impact": c07,
    "journal-of-egyptian-history": c08,
    "journal-of-elections-public-opinion-and-parties": c09,
    "journal-of-emerging-investigators": c10,
    "journal-of-endodontics": c11,
    "journal-of-environmental-science-and-health-part-b": c12,
    "journal-of-ethnobiology": c13,
    "journal-of-european-public-policy": c14,
    "journal-of-evolution-and-health": c15,
    "journal-of-evolutionary-biology": c16,
    "journal-of-experimental-botany": c17,
    "journal-of-field-ornithology": c18,
    "journal-of-finance": c19,
    "journal-of-financial-and-quantitative-analysis": c20,
    "journal-of-fish-biology": c21,
    "journal-of-food-protection": c22,
    "journal-of-foraminiferal-research": c23,
    "journal-of-forensic-sciences": c24,
    "journal-of-frailty-and-aging": c25,
    "journal-of-geriatric-psychiatry-and-neurology": c01,
    "journal-of-glaciology": c02,
    "journal-of-global-health": c03,
    "journal-of-hazardous-materials": c04,
    "journal-of-health-care-for-the-poor-and-underserved": c05,
    "journal-of-hearing-science": c06,
    "journal-of-historical-linguistics": c07,
    "journal-of-human-evolution": c08,
    "journal-of-human-nutrition-and-dietetics": c09,
    "journal-of-human-rights": c10,
    "journal-of-hypertension": c11,
    "journal-of-industrial-and-engineering-chemistry": c12,
    "journal-of-industrial-ecology": c13,
    "journal-of-infection": c14,
    "journal-of-infectious-diseases": c15,
    "journal-of-information-technology": c16,
    "journal-of-innovation-economics-and-management": c17,
    "journal-of-institutional-and-theoretical-economics": c18,
    "journal-of-instrumentation": c19,
    "journal-of-integrated-omics": c20,
    "journal-of-interactive-marketing": c21,
    "journal-of-interactive-media-in-education-harvard": c22,
    "journal-of-intercultural-studies": c23,
    "journal-of-internal-medicine": c24,
    "journal-of-international-business-studies": c25,
    "journal-of-international-peacekeeping": c01,
    "journal-of-international-relations-and-development": c02,
    "journal-of-investigative-dermatology": c03,
    "journal-of-jewish-studies": c04,
    "journal-of-juridical-sciences": c05,
    "journal-of-korean-neurosurgical-society": c06,
    "journal-of-law-medicine-ethics": c07,
    "journal-of-leukocyte-biology": c08,
    "journal-of-limnology": c09,
    "journal-of-linguistics": c10,
    "journal-of-lipid-research": c11,
    "journal-of-lithic-studies": c12,
    "journal-of-magnetic-resonance-imaging": c13,
    "journal-of-mammalogy": c14,
    "journal-of-management-information-systems": c15,
    "journal-of-management-studies": c16,
    "journal-of-management": c17,
    "journal-of-materials-research": c18,
    "journal-of-mechanical-science-and-technology": c19,
    "journal-of-medical-genetics": c20,
    "journal-of-medical-internet-research": c21,
    "journal-of-microbiology-and-biotechnology": c22,
    "journal-of-microbiology": c23,
    "journal-of-microscopy": c24,
    "journal-of-midwifery-science": c25,
    "journal-of-minimally-invasive-gynecology": c01,
    "journal-of-molecular-cell-biology": c02,
    "journal-of-molecular-endocrinology": c03,
    "journal-of-molecular-recognition": c04,
    "journal-of-molecular-signaling": c05,
    "journal-of-move-and-therapeutic-science": c06,
    "journal-of-multidisciplinary-applied-natural-science": c07,
    "journal-of-musculoskeletal-research": c08,
    "journal-of-music-technology-and-education": c09,
    "journal-of-nanoscience-and-nanotechnology": c10,
    "journal-of-natural-history": c11,
    "journal-of-neolithic-archaeology": c12,
    "journal-of-neurochemistry": c13,
    "journal-of-neuroendocrinology": c14,
    "journal-of-neuroimaging": c15,
    "journal-of-neurological-disorders": c16,
    "journal-of-neurophysiology": c17,
    "journal-of-neuroscience-and-neuroengineering": c18,
    "journal-of-new-zealand-grasslands": c19,
    "journal-of-nutrition": c20,
    "journal-of-obstetrics-and-gynaecology-canada": c21,
    "journal-of-occupational-and-environmental-medicine": c22,
    "journal-of-oil-palm-research": c23,
    "journal-of-open-research-software": c24,
    "journal-of-oral-and-maxillofacial-surgery": c25,
    "journal-of-orthopaedic-research": c01,
    "journal-of-orthopaedic-trauma": c02,
    "journal-of-orthopaedics-trauma-and-rehabilitation": c03,
    "journal-of-pain-and-symptom-management": c04,
    "journal-of-paleontology": c05,
    "journal-of-peace-research": c06,
    "journal-of-pediatric-gastroenterology-and-nutrition": c07,
    "journal-of-pediatric-surgery": c08,
    "journal-of-peptide-science": c09,
    "journal-of-perinatal-medicine": c10,
    "journal-of-periodontal-research": c11,
    "journal-of-pharmacy-and-pharmacology": c12,
    "journal-of-phycology": c13,
    "journal-of-physical-therapy-science": c14,
    "journal-of-plankton-research": c15,
    "journal-of-plant-ecology": c16,
    "journal-of-plant-nutrition-and-soil-science": c17,
    "journal-of-plant-protection-research": c18,
    "journal-of-political-ideologies": c19,
    "journal-of-political-philosophy": c20,
    "journal-of-pollination-ecology": c21,
    "journal-of-polymer-science-part-a-polymer-chemistry": c22,
    "journal-of-porphyrins-and-phthalocyanines": c23,
    "journal-of-product-innovation-management": c24,
    "journal-of-prosthodontics": c25,
    "journal-of-psychiatric-and-mental-health-nursing": c01,
    "journal-of-psychiatry-and-neuroscience": c02,
    "journal-of-raman-spectroscopy": c03,
    "journal-of-reconstructive-microsurgery": c04,
    "journal-of-refugee-studies": c05,
    "journal-of-rehabilitation-medicine": c06,
    "journal-of-remote-sensing": c07,
    "journal-of-retailing": c08,
    "journal-of-rheumatology": c09,
    "journal-of-roman-archaeology-a": c10,
    "journal-of-roman-archaeology-b": c11,
    "journal-of-science-and-medicine-in-sport": c12,
    "journal-of-separation-science": c13,
    "journal-of-shoulder-and-elbow-surgery": c14,
    "journal-of-simulation": c15,
    "journal-of-sleep-research": c16,
    "journal-of-small-animal-practice": c17,
    "journal-of-small-business-management": c18,
    "journal-of-social-archaeology": c19,
    "journal-of-social-philosophy": c20,
    "journal-of-soil-and-water-conservation": c21,
    "journal-of-soil-science-and-plant-nutrition": c22,
    "journal-of-sport-and-health-science": c23,
    "journal-of-sports-science-and-medicine": c24,
    "journal-of-strength-and-conditioning-research": c25,
    "journal-of-stroke": c01,
    "journal-of-structural-geology": c02,
    "journal-of-studies-on-alcohol-and-drugs": c03,
    "journal-of-surgery-and-medicine": c04,
    "journal-of-surgical-oncology": c05,
    "journal-of-systematic-palaeontology": c06,
    "journal-of-systematics-and-evolution": c07,
    "journal-of-the-air-and-waste-management-association": c08,
    "journal-of-the-american-academy-of-audiology": c09,
    "journal-of-the-american-academy-of-orthopaedic-surgeons": c10,
    "journal-of-the-american-animal-hospital-association": c11,
    "journal-of-the-american-association-of-laboratory-animal-science": c12,
    "journal-of-the-american-ceramic-society": c13,
    "journal-of-the-american-college-of-cardiology": c14,
    "journal-of-the-american-college-of-surgeons": c15,
    "journal-of-the-american-heart-association": c16,
    "journal-of-the-american-philosophical-association": c17,
    "journal-of-the-american-society-of-brewing-chemists": c18,
    "journal-of-the-american-society-of-nephrology": c19,
    "journal-of-the-american-water-resources-association": c20,
    "journal-of-the-association-for-information-systems": c21,
    "journal-of-the-association-of-environmental-and-resource-economists": c22,
    "journal-of-the-botanical-research-institute-of-texas": c23,
    "journal-of-the-brazilian-chemical-society": c24,
    "journal-of-the-electrochemical-society": c25,
    "journal-of-the-european-academy-of-dermatology-and-venereology": c01,
    "journal-of-the-history-of-collections": c02,
    "journal-of-the-indian-law-institute": c03,
    "journal-of-the-korean-society-of-civil-engineers": c04,
    "journal-of-the-marine-biological-association-of-the-united-kingdom": c05,
    "journal-of-the-royal-anthropological-institute": c06,
    "journal-of-the-royal-society-of-western-australia": c07,
    "journal-of-the-royal-statistical-society": c08,
    "journal-of-the-science-of-food-and-agriculture": c09,
    "journal-of-the-serbian-chemical-society": c10,
    "journal-of-the-warburg-and-courtauld-institutes": c11,
    "journal-of-thermal-spray-technology": c12,
    "journal-of-threatened-taxa": c13,
    "journal-of-thrombosis-and-haemostasis": c14,
    "journal-of-tropical-ecology": c15,
    "journal-of-tropical-life-science": c16,
    "journal-of-universal-computer-science": c17,
    "journal-of-urban-and-environmental-engineering": c18,
    "journal-of-urban-technology": c19,
    "journal-of-value-inquiry": c20,
    "journal-of-vegetation-science": c21,
    "journal-of-vertebrate-biology": c22,
    "journal-of-vertebrate-paleontology": c23,
    "journal-of-vestibular-research": c24,
    "journal-of-veterinary-diagnostic-investigation": c25,
    "journal-of-visualized-experiments": c01,
    "journal-of-water-sanitation-and-hygiene-for-development": c02,
    "journal-of-wildlife-diseases": c03,
    "journal-of-zoo-and-wildlife-medicine": c04,
    "journal-of-zoo-biology": c05,
    "journal-of-zoology": c06,
    "journal-on-efficiency-and-responsibility-in-education-and-science": c07,
    "journalistica": c08,
    "jurisprudence": c09,
    "juristische-schulung": c10,
    "juristische-zitierweise-offentliches-recht": c11,
    "juristische-zitierweise-schweizer": c12,
    "juristische-zitierweise": c13,
    "jurnal-ilmu-dan-teknologi-hasil-ternak": c14,
    "jurnal-pangan-dan-agroindustri": c15,
    "jurnal-sains-farmasi-dan-klinis": c16,
    "jurnal-teknik-mesin-indonesia": c17,
    "jyvaskylan-yliopisto-kemian-laitos": c18,
    "karabuk-university-graduate-school-of-natural-and-applied-sciences": c19,
    "karger-journals-author-date": c20,
    "karger-journals": c21,
    "karlstad-universitet-harvard": c22,
    "karstenia": c23,
    "keel-ja-kirjandus": c24,
    "keele-university-school-of-allied-health-professions": c25,
    "kidney-research-and-clinical-practice": c01,
    "kindheit-und-entwicklung": c02,
    "kit-karlsruher-institut-fur-technologie-germanistik-ndl-neuere-deutsche-literaturwissenschaft": c03,
    "klinische-padiatrie": c04,
    "knee-surgery-and-related-research": c05,
    "knee-surgery-sports-traumatology-arthroscopy": c06,
    "knowledge-and-management-of-aquatic-ecosystems": c07,
    "kolner-zeitschrift-fur-soziologie-und-sozialpsychologie": c08,
    "kommunikation-und-recht": c09,
    "kona-powder-and-particle-journal": c10,
    "korean-journal-of-anesthesiology": c11,
    "korean-journal-of-radiology": c12,
    "kritische-ausgabe": c13,
    "ksce-journal-of-civil-engineering": c14,
    "kth-royal-institute-of-technology-school-of-computer-science-and-communication-sv": c15,
    "kth-royal-institute-of-technology-school-of-computer-science-and-communication": c16,
    "kunstakademie-munster": c17,
    "l-homme-english": c18,
    "l-homme": c19,
    "la-nouvelle-revue-du-travail": c20,
    "la-revue-des-sciences-de-gestion": c21,
    "la-trobe-university-apa": c22,
    "la-trobe-university-harvard": c23,
    "laboratory-animal-science-professional": c24,
    "lancaster-university-harvard": c25,
    "land-degradation-and-development": c01,
    "landes-bioscience-journals": c02,
    "language-in-society": c03,
    "language": c04,
    "lannee-sociologique": c05,
    "latin-american-perspectives": c06,
    "latin-american-research-review": c07,
    "lauterbornia": c08,
    "law-and-society-review": c09,
    "law-citation-manual": c10,
    "law-technology-and-humans": c11,
    "lcgc": c12,
    "le-mouvement-social": c13,
    "le-tapuscrit-author-date": c14,
    "le-tapuscrit-note": c15,
    "leiden-journal-of-international-law": c16,
    "leidraad-voor-juridische-auteurs": c17,
    "leonardo": c18,
    "les-cahiers-du-journalisme": c19,
    "les-journees-de-la-recherche-avicole": c20,
    "les-journees-de-la-recherche-porcine": c21,
    "les-mondes-du-travail": c22,
    "les-nouvelles-de-l-archeologie": c23,
    "lethaia": c24,
    "letters-in-applied-microbiology": c25,
    "lettres-et-sciences-humaines-fr": c01,
    "leuphana-universitaet-lueneburg-institut-fuer-produktionstechnik-und-systeme": c02,
    "leviathan": c03,
    "lien-social-et-politiques": c04,
    "life-science-alliance": c05,
    "limnetica": c06,
    "limnology-and-oceanography": c07,
    "linguistica-uralica": c08,
    "literatura": c09,
    "liver-international": c10,
    "liverpool-john-moores-university-harvard": c11,
    "lluelles-no-ibid": c12,
    "lluelles": c13,
    "london-review-of-international-law": c14,
    "london-south-bank-university-numeric": c15,
    "lund-university-school-of-economics-and-management": c16,
    "macromolecular-reaction-engineering": c17,
    "magnetic-resonance-in-medical-sciences": c18,
    "magnetic-resonance-materials-in-physics-biology-and-medicine": c19,
    "maison-de-l-orient-et-de-la-mediterranee-en": c20,
    "maison-de-l-orient-et-de-la-mediterranee": c21,
    "malaysian-orthopaedic-journal": c22,
    "mammal-review": c23,
    "mammalia": c24,
    "mammalogy-notes": c25,
    "management-et-avenir": c01,
    "management-international": c02,
    "management-of-biological-invasions": c03,
    "manchester-university-press-author-date": c04,
    "manchester-university-press": c05,
    "marine-biology": c06,
    "marine-mammal-science": c07,
    "marine-ornithology": c08,
    "marine-turtle-newsletter": c09,
    "marmara-universitesi-turkiyat-arastirmalari-enstitusu": c10,
    "mary-ann-liebert-harvard": c11,
    "mary-ann-liebert-vancouver": c12,
    "masarykova-univerzita-pravnicka-fakulta": c13,
    "mastozoologia-neotropical": c14,
    "materials-express": c15,
    "mathematical-geosciences": c16,
    "mathematics-and-computers-in-simulation": c17,
    "mcdonald-institute-monographs": c18,
    "mcgill-en": c19,
    "mcgill-fr": c20,
    "medecine-intensive-reanimation": c21,
    "medecine-sciences": c22,
    "media-culture-and-society": c23,
    "medical-dosimetry": c24,
    "medical-education-and-clinical-practice": c25,
    "medical-history": c01,
    "medicina-clinica": c02,
    "medicina-delle-dipendenze-italian-journal-of-the-addictions": c03,
    "medicinal-research-reviews": c04,
    "medicine-and-science-in-sports-and-exercise": c05,
    "medicine-publishing": c06,
    "medicinski-razgledi": c07,
    "medicinskiy-akademicheskiy-zhurnal": c08,
    "mediterranean-journal-of-chemistry": c09,
    "mediterranean-journal-of-infection-microbes-and-antimicrobials": c10,
    "mediterranean-politics": c11,
    "medizinische-hochschule-hannover": c12,
    "medizinische-universitat-innsbruck-vancouver": c13,
    "melanges-de-linstitut-dominicain-detudes-orientales-en": c14,
    "melanges-de-linstitut-dominicain-detudes-orientales-fr": c15,
    "melbourne-school-of-theology": c16,
    "memorias-do-instituto-oswaldo-cruz": c17,
    "mercator-institut-fur-sprachforderung-und-deutsch-als-zweitsprache": c18,
    "mercatus-center": c19,
    "meta": c20,
    "metaaltijden": c21,
    "metallurgical-and-materials-transactions-a": c22,
    "metallurgical-and-materials-transactions": c23,
    "meteoritics-and-planetary-science": c24,
    "meteorological-applications": c25,
    "method-and-theory-in-the-study-of-religion": c01,
    "methods-of-information-in-medicine": c02,
    "metropol-verlag": c03,
    "metropolia-university-of-applied-sciences-harvard-english": c04,
    "metropolia-university-of-applied-sciences-harvard": c05,
    "metropolitiques": c06,
    "mexicon": c07,
    "mhra-author-date-no-url": c08,
    "mhra-author-date-publisher-place-no-url": c09,
    "mhra-author-date-publisher-place": c10,
    "mhra-author-date": c11,
    "mhra-notes-no-url": c12,
    "mhra-notes-publisher-place-no-url": c13,
    "mhra-notes-publisher-place": c14,
    "mhra-notes-subsequent-ibid-no-url": c15,
    "mhra-notes-subsequent-ibid": c16,
    "mhra-notes": c17,
    "mhra-shortened-notes-no-url": c18,
    "mhra-shortened-notes-publisher-place-no-url": c19,
    "mhra-shortened-notes-publisher-place": c20,
    "mhra-shortened-notes": c21,
    "microbial-cell": c22,
    "microbiology-society": c23,
    "microbiome-research-reports": c24,
    "microcirculation": c25,
    "microscopy-and-microanalysis": c01,
    "middle-east-critique": c02,
    "midwestern-baptist-theological-seminary": c03,
    "mimbar-hukum": c04,
    "mimesis-edizioni": c05,
    "mind-and-language": c06,
    "mineralogical-magazine": c07,
    "mis-quarterly": c08,
    "modern-chinese-literature-and-culture": c09,
    "modern-language-association-annotated-bibliography": c10,
    "modern-language-association-no-url": c11,
    "modern-language-association-notes-no-url": c12,
    "modern-language-association-notes": c13,
    "modern-language-association": c14,
    "modern-pathology": c15,
    "modern-phytomorphology": c16,
    "mohr-siebeck-recht": c17,
    "molecular-and-cellular-proteomics": c18,
    "molecular-biology-and-evolution": c19,
    "molecular-biology-of-the-cell": c20,
    "molecular-biology": c21,
    "molecular-metabolism": c22,
    "molecular-microbiology": c23,
    "molecular-nutrition-and-food-research": c24,
    "molecular-oncology": c25,
    "molecular-plant-microbe-interactions": c01,
    "molecular-plant-pathology": c02,
    "molecular-plant": c03,
    "molecular-psychiatry-letters": c04,
    "molecular-psychiatry": c05,
    "monash-university-csiro": c06,
    "mondes-en-developpement": c07,
    "monographs-of-the-palaeontographical-society": c08,
    "moorlands-college": c09,
    "mots": c10,
    "movement-disorders": c11,
    "mrs-bulletin": c12,
    "multidisciplinary-digital-publishing-institute": c13,
    "multilingual-matters": c14,
    "multimed": c15,
    "multiple-sclerosis-journal": c16,
    "muscle-and-nerve": c17,
    "museum-national-dhistoire-naturelle": c18,
    "mutagenesis": c19,
    "mycobiology": c20,
    "mycologia": c21,
    "myrmecological-news": c22,
    "nano-biomedicine-and-engineering": c23,
    "natbib-plainnat-author-date": c24,
    "national-archives-of-australia": c25,
    "national-institute-of-health-research": c01,
    "national-institute-of-organisation-dynamics-australia-harvard": c02,
    "national-institute-of-technology-karnataka": c03,
    "national-institute-of-technology-tiruchirappalli": c04,
    "national-marine-fisheries-service-national-environmental-policy-act": c05,
    "national-natural-science-foundation-of-china": c06,
    "national-science-foundation-grant-proposals": c07,
    "national-university-of-singapore-department-of-geography-harvard": c08,
    "nations-and-nationalism": c09,
    "natur-und-landschaft": c10,
    "natura-croatica": c11,
    "nature-brackets": c12,
    "nature-neuroscience-brief-communications": c13,
    "nature-no-et-al": c14,
    "nature-publishing-group-vancouver": c15,
    "nature": c16,
    "natures-sciences-societes": c17,
    "nauplius": c18,
    "navigation": c19,
    "nccr-mediality": c20,
    "necmettin-erbakan-universitesi-fen-ve-muhendislik-bilimleri-dergisi": c21,
    "nehet": c22,
    "nejm-catalyst-innovations-in-care-delivery": c23,
    "nephrology-dialysis-transplantation": c24,
    "netherlands-journal-of-geosciences-geologie-en-mijnbouw": c25,
    "neue-juristische-wochenschrift": c01,
    "neue-kriminalpolitik": c02,
    "neues-jahrbuch-fur-geologie-und-palaontologie": c03,
    "neural-plasticity": c04,
    "neuroendocrinology-letters": c05,
    "neuroimaging-clinics-of-north-america": c06,
    "neurologia-argentina": c07,
    "neurologia": c08,
    "neurology-india": c09,
    "neurology": c10,
    "neuropsychopharmacology": c11,
    "neurorehabilitation-and-neural-repair": c12,
    "neuroreport": c13,
    "neurospine": c14,
    "neurosurgery-clinics-of-north-america": c15,
    "new-harts-rules-author-date-publisher": c16,
    "new-harts-rules-author-date-space-publisher": c17,
    "new-harts-rules-author-date": c18,
    "new-harts-rules-notes-initials-bracket-role-page-range-no-url": c19,
    "new-harts-rules-notes-initials-bracket-role-page-range": c20,
    "new-harts-rules-notes-initials-label-page-no-url": c21,
    "new-harts-rules-notes-initials-label-page": c22,
    "new-harts-rules-notes-initials-no-url": c23,
    "new-harts-rules-notes-initials-publisher-no-url": c24,
    "new-harts-rules-notes-initials-publisher": c25,
    "new-harts-rules-notes-initials": c01,
    "new-harts-rules-notes-label-page-no-url": c02,
    "new-harts-rules-notes-label-page": c03,
    "new-harts-rules-notes-no-url": c04,
    "new-harts-rules-notes-publisher-no-url": c05,
    "new-harts-rules-notes-publisher": c06,
    "new-harts-rules-notes": c07,
    "new-harts-rules-numbered": c08,
    "new-harts-rules-short-notes-no-url": c09,
    "new-harts-rules-short-notes": c10,
    "new-phytologist": c11,
    "new-solutions": c12,
    "new-testament-studies": c13,
    "new-zealand-dental-journal": c14,
    "new-zealand-journal-of-forestry-science": c15,
    "new-zealand-journal-of-history": c16,
    "new-zealand-plant-protection": c17,
    "new-zealand-veterinary-journal": c18,
    "nist-technical-publication-journal-of-research-of-nist": c19,
    "nlm-citation-name": c20,
    "nlm-citation-sequence-brackets-no-et-al": c21,
    "nlm-citation-sequence-brackets-year-only-no-issue": c22,
    "nlm-citation-sequence-brackets": c23,
    "nlm-citation-sequence-superscript-brackets-year-only": c24,
    "nlm-citation-sequence-superscript-year-only-no-issue": c25,
    "nlm-citation-sequence-superscript": c01,
    "nlm-citation-sequence": c02,
    "nlm-name-year": c03,
    "nordic-pulp-and-paper-research-journal": c04,
    "norma-portuguesa-405": c05,
    "norois": c06,
    "norsk-apa-manual-note": c07,
    "norsk-apa-manual": c08,
    "norsk-henvisningsstandard-for-rettsvitenskapelige-tekster-full-firstnote": c09,
    "norsk-henvisningsstandard-for-rettsvitenskapelige-tekster": c10,
    "north-pacific-anadromous-fish-commission-bulletin": c11,
    "northeastern-naturalist": c12,
    "nottingham-trent-university-library-harvard": c13,
    "nouvelles-perspectives-en-sciences-sociales": c14,
    "nova-univerza": c15,
    "novasinergia": c16,
    "nowa-audiofonologia": c17,
    "nuclear-receptor-signaling": c18,
    "nucleic-acids-research-web-server-issue": c19,
    "nucleic-acids-research": c20,
    "nueva-norma-estudios-de-la-humanidad": c21,
    "nutrition-research-reviews": c22,
    "nys-nydanske-sprogstudier": c23,
    "obafemi-awolowo-university-faculty-of-technology": c24,
    "obesity": c25,
    "obstetrics-and-gynecology-science": c01,
    "occupational-medicine": c02,
    "ocean-and-coastal-research": c03,
    "oceanography": c04,
    "oecologia-australis": c05,
    "offa": c06,
    "oikos": c07,
    "oil-shale": c08,
    "oncoimmunology": c09,
    "oncotarget": c10,
    "open-gender-journal": c11,
    "open-theology": c12,
    "open-window": c13,
    "operative-dentistry": c14,
    "ophthalmic-genetics": c15,
    "ophthalmic-plastic-and-reconstructive-surgery": c16,
    "ophthalmology-retina": c17,
    "ophthalmology": c18,
    "optics-express": c19,
    "optics-letters": c20,
    "opto-electronic-advances": c21,
    "optometry-and-vision-science": c22,
    "opuscula": c23,
    "oral-diseases": c24,
    "organic-geochemistry": c25,
    "organised-sound": c01,
    "organization-studies": c02,
    "organization": c03,
    "organon": c04,
    "ornitologia-neotropical": c05,
    "orthopedic-clinics-of-north-america": c06,
    "oryx": c07,
    "oscola-journal-abbreviations": c08,
    "oscola-no-ibid": c09,
    "oscola": c10,
    "osterreichische-zeitschrift-fur-politikwissenschaft": c11,
    "otto-von-guricke-universitat-magdeburg-medizinische-fakultat-numeric": c12,
    "owbarth-verlag": c13,
    "oxford-art-journal": c14,
    "oxford-guide-to-style-notes-initials-article-sentence-case-roman-volume-label-page": c15,
    "oxford-guide-to-style-notes-initials-label-page-no-url": c16,
    "oxford-guide-to-style-notes-initials-label-page": c17,
    "oxford-guide-to-style-notes-initials-no-url": c18,
    "oxford-guide-to-style-notes-initials": c19,
    "oxford-guide-to-style-notes-no-url": c20,
    "oxford-guide-to-style-notes-roman-volume-archive-first-no-url": c21,
    "oxford-guide-to-style-notes-roman-volume-archive-first": c22,
    "oxford-guide-to-style-notes": c23,
    "oxford-journals-scimed-author-date": c24,
    "oxford-journals-scimed-numeric-parentheses": c25,
    "oxford-journals-scimed-numeric-superscript": c01,
    "oxford-journals-scimed-numeric": c02,
    "oxford-studies-on-the-roman-economy": c03,
    "oxidation-of-metals": c04,
    "pacific-conservation-biology": c05,
    "pacific-science": c06,
    "padagogische-hochschule-bern-institut-vorschulstufe-und-primarstufe": c07,
    "padagogische-hochschule-fachhochschule-nordwestschweiz": c08,
    "padagogische-hochschule-heidelberg": c09,
    "padagogische-hochschule-vorarlberg": c10,
    "paediatric-and-perinatal-epidemiology": c11,
    "pain-medicine": c12,
    "pain-physician": c13,
    "pain": c14,
    "pakistan-journal-of-agricultural-sciences": c15,
    "pakistani-veterinary-journal": c16,
    "palaeodiversity": c17,
    "palaeontographica-abteilung-b-palaeobotany-palaeophytology": c18,
    "palaeontologia-electronica": c19,
    "palaeontology": c20,
    "palaeovertebrata": c21,
    "palaios": c22,
    "paleobiology": c23,
    "pallas": c24,
    "pamukkale-universitesi-fen-bilimleri-enstitusu": c25,
    "parasite": c01,
    "parasitology": c02,
    "pathogens-and-immunity": c03,
    "pediatric-allergy-and-immunology": c04,
    "pediatric-anesthesia": c05,
    "pediatric-blood-and-cancer": c06,
    "pediatric-infectious-disease-journal": c07,
    "pediatric-physical-therapy": c08,
    "pediatric-practice-and-research": c09,
    "pediatric-pulmonology": c10,
    "pediatric-research": c11,
    "pediatric-urology-case-reports": c12,
    "pedosphere": c13,
    "peerj": c14,
    "pensoft-journals": c15,
    "periodicum-biologorum": c16,
    "periodontology-2000": c17,
    "permafrost-and-periglacial-processes": c18,
    "perspectives-on-sexual-and-reproductive-health": c19,
    "pesquisa-agropecuaria-brasileira": c20,
    "pest-management-science": c21,
    "peter-lang-social-sciences": c22,
    "petit-chicago-author-date": c23,
    "pharmacoepidemiology-and-drug-safety": c24,
    "philippika": c25,
    "philippine-journal-of-natural-sciences": c01,
    "philipps-universitat-marburg-note": c02,
    "philosophia-scientiae": c03,
    "philosophiques": c04,
    "philosophy-and-public-affairs": c05,
    "photochemistry-and-photobiology": c06,
    "photogrammetric-engineering-and-remote-sensing": c07,
    "photosynthetica": c08,
    "phycological-research": c09,
    "phyllomedusa": c10,
    "physiologia-plantarum": c11,
    "physiological-and-biochemical-zoology": c12,
    "physiotherapy-theory-and-practice": c13,
    "phytopathologia-mediterranea": c14,
    "phytotaxa": c15,
    "pisa-university-press": c16,
    "planning-practice-and-research": c17,
    "plant-and-cell-physiology": c18,
    "plant-biology": c19,
    "plant-biotechnology-journal": c20,
    "plant-cell-and-environment": c21,
    "plant-genetic-resources-characterization-and-utilization": c22,
    "plant-pathology": c23,
    "plant-physiology": c24,
    "plant-species-biology": c25,
    "plos": c01,
    "pnas": c02,
    "podzemna-voda": c03,
    "polar-research": c04,
    "polish-archives-of-internal-medicine": c05,
    "polish-legal": c06,
    "politechnika-opolska-wydzial-wychowania-fizycznego-i-fizjoterapii": c07,
    "politeknik-negeri-manado-jurnal-p3m": c08,
    "politica-tidsskrift-for-politisk-videnskab": c09,
    "political-studies": c10,
    "politique-europeenne": c11,
    "politische-vierteljahresschrift": c12,
    "politix": c13,
    "polygraphia": c14,
    "polymer-reviews": c15,
    "polytechnique-montreal-apa": c16,
    "polytechnique-montreal-ieee": c17,
    "pontifical-athenaeum-regina-apostolorum": c18,
    "pontifical-biblical-institute": c19,
    "pontifical-gregorian-university": c20,
    "pontificia-universidade-catolica-do-parana-abnt": c21,
    "population-space-and-place": c22,
    "population": c23,
    "postepy-higieny-i-medycyny-doswiadczalnej": c24,
    "poultry-science": c25,
    "pour-reussir-note": c01,
    "pravnik": c02,
    "pravny-obzor": c03,
    "praxis": c04,
    "prehistoires-mediterraneennes": c05,
    "prehospital-and-disaster-medicine": c06,
    "prehospital-emergency-care": c07,
    "preslia": c08,
    "presses-universitaires-de-paris-nanterre": c09,
    "presses-universitaires-de-rennes-archeologie-et-culture": c10,
    "presses-universitaires-de-rennes-author-date": c11,
    "presses-universitaires-de-rennes": c12,
    "presses-universitaires-de-strasbourg-note": c13,
    "preventive-nutrition-and-food-science": c14,
    "primary-care-clinics-in-office-practice": c15,
    "proceedings-of-the-estonian-academy-of-sciences-author-date": c16,
    "proceedings-of-the-estonian-academy-of-sciences-numeric": c17,
    "proceedings-of-the-joint-international-grassland-and-international-rangeland-congress-2021": c18,
    "proceedings-of-the-royal-society-b": c19,
    "processing-and-application-of-ceramics": c20,
    "production-and-operations-management": c21,
    "progress-on-chemistry-and-application-of-chitin-and-its-derivatives": c22,
    "proinflow": c23,
    "protein-engineering-design-and-selection": c24,
    "protein-science": c25,
    "proteomics": c01,
    "psychiatric-clinics-of-north-america": c02,
    "psychiatric-services": c03,
    "psychiatry-and-clinical-neurosciences": c04,
    "psychosomatic-medicine": c05,
    "psychosomatics": c06,
    "public-health-nutrition": c07,
    "publicatiewijzer-voor-de-archeologie": c08,
    "pure-and-applied-geophysics": c09,
    "qeios": c10,
    "quaderni-degli-avogadro-colloquia": c11,
    "quaderni-materialisti": c12,
    "quaderni": c13,
    "quaternaire": c14,
    "quaternary-international": c15,
    "queen-margaret-university-harvard": c16,
    "r-and-d-management": c17,
    "radiation-protection-dosimetry": c18,
    "radiation-research": c19,
    "radiochimica-acta": c20,
    "radiographics": c21,
    "radiography": c22,
    "radiologic-clinics-of-north-america": c23,
    "radiology": c24,
    "radiopaedia": c25,
    "raffles-bulletin-of-zoology": c01,
    "raptor-journal": c02,
    "rassegna-degli-archivi-di-stato-bibliografia-generale": c03,
    "rassegna-degli-archivi-di-stato": c04,
    "recent-patents-on-drug-delivery-and-formulation": c05,
    "recherches-en-sciences-de-gestion": c06,
    "refugee-survey-quarterly": c07,
    "register-studies": c08,
    "religion-in-the-roman-empire": c09,
    "renewable-agriculture-and-food-systems": c10,
    "reports-of-practical-oncology-and-radiotherapy": c11,
    "representation": c12,
    "reproduction-fertility-and-development": c13,
    "reproduction": c14,
    "research-and-education-promotion-association": c15,
    "research-in-plant-disease": c16,
    "research-institute-for-nature-and-forest": c17,
    "research-on-biomedical-engineering": c18,
    "respiratory-care-journal": c19,
    "respirology": c20,
    "restoration-ecology": c21,
    "retina": c22,
    "rever-revista-de-estudos-da-religiao": c23,
    "review-of-international-studies": c24,
    "review-of-political-economy": c25,
    "reviews-of-modern-physics-with-titles": c01,
    "revista-argentina-de-antropologia-biologica": c02,
    "revista-biblica": c03,
    "revista-brasileira-de-ciencia-do-solo": c04,
    "revista-chilena-de-derecho-y-tecnologia": c05,
    "revista-ciencias-tecnicas-agropecuarias": c06,
    "revista-cubana-de-meteorologia": c07,
    "revista-da-sociedade-brasileira-de-medicina-tropical": c08,
    "revista-de-biologia-marina-y-oceanografia": c09,
    "revista-de-biologia-tropical": c10,
    "revista-de-derecho-de-la-universidad-austral-de-chile": c11,
    "revista-de-filologia-espanola": c12,
    "revista-do-instituto-de-medicina-tropical-de-sao-paulo": c13,
    "revista-espanola-de-nutricion-humana-y-dietetica": c14,
    "revista-fave-seccion-ciencias-agrarias": c15,
    "revista-ladinia": c16,
    "revista-latinoamericana-de-metalurgia-y-materiales": c17,
    "revista-latinoamericana-de-recursos-naturales": c18,
    "revista-materia": c19,
    "revista-medica-del-instituto-mexicano-del-seguro-social": c20,
    "revista-noesis": c21,
    "revista-peruana-de-medicina-experimental-y-salud-publica": c22,
    "revista-portuguesa-de-arqueologia": c23,
    "revista-portuguesa-de-musicologia-author-date": c24,
    "revista-virtual-de-quimica": c25,
    "revue-archeologique-de-lest": c01,
    "revue-archeologique-de-narbonnaise": c02,
    "revue-archeologique-du-centre-de-la-france": c03,
    "revue-archeologique": c04,
    "revue-d-anthropologie-des-connaissances": c05,
    "revue-d-elevage-et-de-medecine-veterinaire-des-pays-tropicaux": c06,
    "revue-de-medecine-veterinaire": c07,
    "revue-de-qumran": c08,
    "revue-des-etudes-byzantines": c09,
    "revue-des-nouvelles-technologies-de-l-information": c10,
    "revue-dhistoire-des-sciences-humaines": c11,
    "revue-dhistoire-des-sciences": c12,
    "revue-dhistoire-moderne-et-contemporaine": c13,
    "revue-europeenne-des-migrations-internationales": c14,
    "revue-forestiere-francaise": c15,
    "revue-francaise-d-administration-publique": c16,
    "revue-francaise-de-gestion": c17,
    "revue-francaise-de-pedagogie": c18,
    "revue-francaise-de-sociologie": c19,
    "revue-francaise-dhistotechnologie": c20,
    "revue-internationale-durbanisme": c21,
    "revue-metis": c22,
    "rhinology": c23,
    "rhodora": c24,
    "risk-analysis": c25,
    "ritid": c01,
    "rivista-italiana-di-paleontologia-e-stratigrafia": c02,
    "rmit-university-harvard": c03,
    "rofo": c04,
    "romanian-humanities": c05,
    "roots-monograph-series": c06,
    "rose-school": c07,
    "rossiiskii-fiziologicheskii-zhurnal-imeni-i-m-sechenova": c08,
    "royal-college-of-nursing-harvard": c09,
    "royal-college-of-surgeons-in-ireland-medical-university-of-bahrain-harvard": c10,
    "royal-entomological-society": c11,
    "royal-society-of-chemistry-with-titles": c12,
    "royal-society-of-chemistry": c13,
    "rtf-scan": c14,
    "ruhr-universitat-bochum-lehrstuhl-fur-industrial-sales-and-service-engineering": c15,
    "ruhr-universitat-bochum-medizinische-fakultat-numeric": c16,
    "sage-harvard": c17,
    "sage-vancouver-brackets": c18,
    "sage-vancouver": c19,
    "saglik-bilimleri-universitesi": c20,
    "saint-paul-university-faculty-of-canon-law": c21,
    "san-francisco-estuary-and-watershed-science": c22,
    "sanamed": c23,
    "scandinavian-journal-of-infectious-diseases": c24,
    "scandinavian-journal-of-information-systems": c25,
    "scandinavian-journal-of-medicine-and-science-in-sports": c01,
    "scandinavian-journal-of-rheumatology": c02,
    "scandinavian-journal-of-work-environment-and-health": c03,
    "scandinavian-political-studies": c04,
    "schweizerische-zeitschrift-fur-geschichte": c05,
    "science-and-technology-for-the-built-environment": c06,
    "science-china-chemistry": c07,
    "science-china-earth-sciences": c08,
    "science-china-life-sciences": c09,
    "science-china-materials": c10,
    "science-translational-medicine": c11,
    "science-without-titles": c12,
    "science": c13,
    "scienceasia": c14,
    "sciences-po-ecole-doctorale-author-date": c15,
    "sciences-po-ecole-doctorale-note-french": c16,
    "scientia-agriculturae-bohemica": c17,
    "scientia-iranica": c18,
    "scientific-online-letters-on-the-atmosphere": c19,
    "scientific-review-engineering-and-environmental-sciences": c20,
    "scrinium": c21,
    "sedimentology": c22,
    "seed-science-and-technology": c23,
    "seed-science-research": c24,
    "seismological-research-letters": c25,
    "sekolah-tinggi-meteorologi-klimatologi-dan-geofisika": c01,
    "seminaire-saint-sulpice-ecole-theologie": c02,
    "seminars-in-pediatric-neurology": c03,
    "serbian-archives-of-medicine": c04,
    "serdica-journal-of-computing": c05,
    "service-medical-de-l-assurance-maladie": c06,
    "sexual-development": c07,
    "sexual-health": c08,
    "sheffield-hallam-university-history": c09,
    "shock": c10,
    "silva-fennica": c11,
    "sinergie-italian-journal-of-management": c12,
    "sist02": c13,
    "skene-journal-of-theatre-and-drama-studies": c14,
    "skuast-journal-of-research": c15,
    "slovensko-drustvo-za-medicinsko-informatiko": c16,
    "small": c17,
    "smithsonian-institution-scholarly-press-author-date": c18,
    "smithsonian-institution-scholarly-press-botany": c19,
    "smithsonian-institution-scholarly-press-note": c20,
    "smyrna-tip-dergisi": c21,
    "sn-computer-science": c22,
    "social-anthropology": c23,
    "social-cognitive-and-affective-neuroscience": c24,
    "social-history-of-medicine": c25,
    "social-history": c01,
    "social-science-history": c02,
    "sociedade-brasileira-de-computacao": c03,
    "societe-archeologique-de-bordeaux": c04,
    "societe-francaise-degyptologie": c05,
    "societe-francaise-detude-de-la-ceramique-antique-en-gaule": c06,
    "societe-nationale-des-groupements-techniques-veterinaires": c07,
    "societes-contemporaines": c08,
    "society-for-american-archaeology": c09,
    "society-for-historical-archaeology": c10,
    "society-for-laboratory-automation-and-screening": c11,
    "society-of-automotive-engineers-technical-papers-numeric": c12,
    "society-of-biblical-literature-author-date": c13,
    "society-of-biblical-literature-fullnote-bibliography": c14,
    "sociologia-ruralis": c15,
    "sociologia-urbana-e-rurale": c16,
    "sociologie": c17,
    "sociology-of-health-and-illness": c18,
    "sodertorns-hogskola-harvard-ibid": c19,
    "sodertorns-hogskola-harvard": c20,
    "sodertorns-hogskola-oxford": c21,
    "soil-biology-and-biochemistry": c22,
    "soil-science-and-plant-nutrition": c23,
    "solent-university-harvard": c24,
    "solutions": c25,
    "sophiahemmet-hogskola": c01,
    "sorbonne-student-law-review": c02,
    "south-african-actuarial-journal": c03,
    "south-african-journal-of-animal-science": c04,
    "south-african-journal-of-enology-and-viticulture": c05,
    "south-african-journal-of-geology": c06,
    "south-african-law-journal": c07,
    "south-african-medical-journal": c08,
    "south-african-theological-seminary": c09,
    "southeastern-geographer": c10,
    "southern-african-journal-of-critical-care": c11,
    "soziale-welt": c12,
    "sozialpadagogisches-institut-berlin-walter-may": c13,
    "sozialwissenschaften-heilmann": c14,
    "soziologie": c15,
    "soziologiemagazin": c16,
    "spandidos-publications": c17,
    "spanish-legal": c18,
    "spectroscopy-letters": c19,
    "spie-bios": c20,
    "spie-journals": c21,
    "spie-proceedings": c22,
    "spine": c23,
    "spip-cite": c24,
    "spiritual-care": c25,
    "sports-health": c01,
    "springer-basic-author-date-no-et-al-with-issue": c02,
    "springer-basic-author-date-no-et-al": c03,
    "springer-basic-author-date": c04,
    "springer-basic-brackets-no-et-al-alphabetical": c05,
    "springer-basic-brackets-no-et-al": c06,
    "springer-basic-brackets": c07,
    "springer-basic-note": c08,
    "springer-fachzeitschriften-medizin-psychologie": c09,
    "springer-humanities-author-date": c10,
    "springer-humanities-brackets": c11,
    "springer-imis-series-migrationsgesellschaften": c12,
    "springer-lecture-notes-in-computer-science-alphabetical": c13,
    "springer-lecture-notes-in-computer-science": c14,
    "springer-mathphys-author-date": c15,
    "springer-mathphys-brackets": c16,
    "springer-physics-author-date": c17,
    "springer-physics-brackets": c18,
    "springer-socpsych-author-date": c19,
    "springer-socpsych-brackets": c20,
    "springer-vancouver-author-date": c21,
    "springer-vancouver-brackets": c22,
    "springer-vancouver": c23,
    "springer-vs-author-date": c24,
    "springerprotocols": c25,
    "st-patricks-college": c01,
    "stanovnistvo": c02,
    "statistika-statistics-and-economy-journal": c03,
    "stavebni-obzor": c04,
    "steel-research-international": c05,
    "steinbeis-hochschule-school-of-management-and-innovation": c06,
    "stellenbosch-law-review": c07,
    "stem-cell-reports": c08,
    "stem-cells": c09,
    "strategic-design-research-journal": c10,
    "strategic-entrepreneurship-journal": c11,
    "strategic-management-journal": c12,
    "stroke": c13,
    "structural-control-and-health-monitoring": c14,
    "studi-e-materiali-di-storia-delle-religioni": c15,
    "studi-slavistici-rivista-dellassociazione-italiana-degli-slavisti": c16,
    "studia-bas": c17,
    "studia-historiae-scientiarum": c18,
    "studia-theologica": c19,
    "studies-in-the-history-of-gardens-and-designed-landscapes": c20,
    "studii-teologice": c21,
    "stuttgart-media-university": c22,
    "style-manual-australian-government-note": c23,
    "style-manual-australian-government": c24,
    "style-manual-for-authors-editors-and-printers-6th-edition-snooks-co": c25,
    "suburban-zeitschrift-fur-kritische-stadtforschung": c01,
    "suleyman-demirel-universitesi-fen-bilimleri-enstitusu": c02,
    "sunway-college-johor-bahru": c03,
    "suomen-antropologi-journal-of-the-finnish-anthropological-society": c04,
    "surgical-clinics-of-north-america": c05,
    "surgical-neurology-international": c06,
    "surgical-pathology-clinics": c07,
    "survey-of-ophthalmology": c08,
    "svensk-exegetisk-arsbok": c09,
    "swedish-legal": c10,
    "swiss-political-science-review": c11,
    "sylwan": c12,
    "synthesis": c13,
    "system-dynamics-review": c14,
    "systematic-and-applied-microbiology": c15,
    "systematic-biology": c16,
    "szociologiai-szemle": c17,
    "tabula": c18,
    "tagungsberichte-der-historischen-kommission-fur-ost-und-westpreussische-landesforschung": c19,
    "tapir-conservation": c20,
    "targetome": c21,
    "tatup-zeitschrift-fur-technikfolgenabschatzung-in-theorie-und-praxis": c22,
    "taxon": c23,
    "taylor-and-francis-acs": c24,
    "taylor-and-francis-aip": c25,
    "taylor-and-francis-ama": c01,
    "taylor-and-francis-chicago-author-date": c02,
    "taylor-and-francis-chicago-b-author-date": c03,
    "taylor-and-francis-chicago-f": c04,
    "taylor-and-francis-council-of-science-editors-author-date": c05,
    "taylor-and-francis-council-of-science-editors-numeric": c06,
    "taylor-and-francis-harvard-x": c07,
    "taylor-and-francis-national-library-of-medicine": c08,
    "taylor-and-francis-numeric-q": c09,
    "taylor-and-francis-vancouver-national-library-of-medicine": c10,
    "techniques-et-culture": c11,
    "technische-universitat-dortmund-ag-virtual-machining": c12,
    "technische-universitat-dresden-betriebswirtschaftslehre-logistik-author-date": c13,
    "technische-universitat-dresden-betriebswirtschaftslehre-marketing": c14,
    "technische-universitat-dresden-betriebswirtschaftslehre-rechnungswesen-controlling": c15,
    "technische-universitat-dresden-erziehungswissenschaften-author-date": c16,
    "technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-author-date-with-short-titles": c17,
    "technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-author-date": c18,
    "technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-note": c19,
    "technische-universitat-dresden-forstwissenschaft": c20,
    "technische-universitat-dresden-historische-musikwissenschaft-note": c21,
    "technische-universitat-dresden-kunstgeschichte-note": c22,
    "technische-universitat-dresden-linguistik": c23,
    "technische-universitat-dresden-medienwissenschaft-und-neuere-deutsche-literatur-note": c24,
    "technische-universitat-dresden-wirtschaftswissenschaften": c25,
    "technische-universitat-hamburg-institut-fur-smarte-entwicklung-und-maschinenelemente": c01,
    "technische-universitat-munchen-controlling": c02,
    "technische-universitat-munchen-unternehmensfuhrung": c03,
    "technische-universitat-wien": c04,
    "teologia-catalunya": c05,
    "termedia-neuropsychiatria-i-neuropsychologia-neuropsychiatry-and-neuropsychology": c06,
    "terra-nova": c07,
    "tetrahedron-letters": c08,
    "textual-cultures": c09,
    "textual-practice": c10,
    "tgm-wien-diplom": c11,
    "tgm-wien-diplomarbeit-onorm": c12,
    "thai-endodontic-journal": c13,
    "the-accounting-review": c14,
    "the-american-journal-of-bioethics": c15,
    "the-american-journal-of-cardiology": c16,
    "the-american-journal-of-dermatopathology": c17,
    "the-american-journal-of-gastroenterology": c18,
    "the-american-journal-of-geriatric-psychiatry": c19,
    "the-american-journal-of-pathology": c20,
    "the-american-journal-of-psychiatry": c21,
    "the-american-journal-of-tropical-medicine-and-hygiene": c22,
    "the-american-midland-naturalist": c23,
    "the-american-naturalist": c24,
    "the-angle-orthodontist": c25,
    "the-astrophysical-journal": c01,
    "the-auk": c02,
    "the-australian-journal-of-agricultural-and-resource-economics": c03,
    "the-biological-bulletin": c04,
    "the-bone-and-joint-journal": c05,
    "the-botanical-review": c06,
    "the-bovine-practitioner": c07,
    "the-british-journal-for-the-history-of-science": c08,
    "the-british-journal-for-the-philosophy-of-science": c09,
    "the-british-journal-of-cardiology": c10,
    "the-british-journal-of-criminology": c11,
    "the-british-journal-of-psychiatry": c12,
    "the-british-journal-of-social-work": c13,
    "the-british-journal-of-sociology": c14,
    "the-canadian-geographer": c15,
    "the-canadian-journal-of-chemical-engineering": c16,
    "the-canadian-journal-of-psychiatry": c17,
    "the-cancer-journal": c18,
    "the-chemical-society-of-japan": c19,
    "the-chinese-journal-of-international-politics": c20,
    "the-coleopterists-bulletin": c21,
    "the-company-of-biologists": c22,
    "the-depositional-record": c23,
    "the-design-journal": c24,
    "the-economic-history-review": c25,
    "the-european-research-journal": c01,
    "the-faseb-journal": c02,
    "the-febs-journal": c03,
    "the-geological-society-of-america": c04,
    "the-geological-society-of-london": c05,
    "the-hastings-center-report": c06,
    "the-historical-journal": c07,
    "the-holocene": c08,
    "the-horticulture-journal": c09,
    "the-institute-of-electronics-information-and-communication-engineers": c10,
    "the-institution-of-engineering-and-technology": c11,
    "the-international-journal-of-developmental-biology": c12,
    "the-international-journal-of-psychoanalysis": c13,
    "the-international-journal-of-tuberculosis-and-lung-disease": c14,
    "the-international-spectator": c15,
    "the-isme-journal": c16,
    "the-journal-of-adhesive-dentistry": c17,
    "the-journal-of-agricultural-science": c18,
    "the-journal-of-bone-and-joint-surgery": c19,
    "the-journal-of-clinical-ethics": c20,
    "the-journal-of-clinical-investigation": c21,
    "the-journal-of-comparative-law": c22,
    "the-journal-of-comparative-neurology": c23,
    "the-journal-of-ecclesiastical-history": c24,
    "the-journal-of-egyptian-archaeology": c25,
    "the-journal-of-eukaryotic-microbiology": c01,
    "the-journal-of-foot-and-ankle-surgery": c02,
    "the-journal-of-hand-surgery-asian-pacific-volume": c03,
    "the-journal-of-hand-surgery-european-volume": c04,
    "the-journal-of-hellenic-studies": c05,
    "the-journal-of-immunology": c06,
    "the-journal-of-infection-in-developing-countries": c07,
    "the-journal-of-juristic-papyrology": c08,
    "the-journal-of-laryngology-and-otology": c09,
    "the-journal-of-molecular-diagnostics": c10,
    "the-journal-of-nervous-and-mental-disease": c11,
    "the-journal-of-neuropsychiatry-and-clinical-neurosciences": c12,
    "the-journal-of-neuroscience": c13,
    "the-journal-of-nuclear-medicine": c14,
    "the-journal-of-nutrition-health-and-aging": c15,
    "the-journal-of-pain": c16,
    "the-journal-of-parasitology": c17,
    "the-journal-of-pathology": c18,
    "the-journal-of-peasant-studies": c19,
    "the-journal-of-physiology": c20,
    "the-journal-of-pure-and-applied-chemistry-research": c21,
    "the-journal-of-roman-studies": c22,
    "the-journal-of-the-acoustical-society-of-america-numeric": c23,
    "the-journal-of-the-acoustical-society-of-america": c24,
    "the-journal-of-the-torrey-botanical-society": c25,
    "the-journal-of-transport-history": c01,
    "the-journal-of-trauma-and-acute-care-surgery": c02,
    "the-journal-of-urology": c03,
    "the-journal-of-veterinary-medical-science": c04,
    "the-journal-of-wildlife-management": c05,
    "the-korean-journal-of-gastroenterology": c06,
    "the-korean-journal-of-internal-medicine": c07,
    "the-korean-journal-of-mycology": c08,
    "the-lancet": c09,
    "the-lichenologist": c10,
    "the-national-medical-journal-of-india": c11,
    "the-neuroscientist": c12,
    "the-new-england-journal-of-medicine": c13,
    "the-oncologist": c14,
    "the-open-university-a251": c15,
    "the-open-university-harvard": c16,
    "the-open-university-m801": c17,
    "the-open-university-numeric-superscript": c18,
    "the-open-university-numeric": c19,
    "the-open-university-s390": c20,
    "the-optical-society": c21,
    "the-pan-african-medical-journal": c22,
    "the-plant-cell": c23,
    "the-plant-genome": c24,
    "the-plant-journal": c25,
    "the-quarterly-journal-of-economics": c01,
    "the-rockefeller-university-press": c02,
    "the-saudi-journal-for-dental-research": c03,
    "the-scandinavian-journal-of-clinical-and-laboratory-investigation": c04,
    "the-university-of-tokyo-law-review": c05,
    "the-university-of-western-australia-harvard": c06,
    "the-university-of-winchester-harvard": c07,
    "the-world-journal-of-biological-psychiatry": c08,
    "theologie-und-philosophie": c09,
    "theory-culture-and-society": c10,
    "theranostics": c11,
    "theses-de-sorbonne-universite": c12,
    "thieme-german": c13,
    "thomson-reuters-legal-tax-and-accounting-australia": c14,
    "thrombosis-and-haemostasis": c15,
    "tijdschrift-voor-economische-en-sociale-geografie": c16,
    "tijdschrift-voor-geneeskunde": c17,
    "topoi-orient-occident-auteur-date": c18,
    "topoi-orient-occident-classique": c19,
    "trabajos-de-prehistoria": c20,
    "traces": c21,
    "traffic-injury-prevention": c22,
    "traffic": c23,
    "tramas-y-redes-revista-del-consejo-latinoamericano-de-ciencias-sociales": c24,
    "trames": c25,
    "transactions-of-the-american-philological-association": c01,
    "transactions-of-the-materials-research-society-of-japan": c02,
    "transactions-of-the-philological-society": c03,
    "transactions-on-maritime-science": c04,
    "transboundary-and-emerging-diseases": c05,
    "transnational-environmental-law": c06,
    "transplantation": c07,
    "transport": c08,
    "transportation-research-record": c09,
    "transposition": c10,
    "transversalites": c11,
    "travail-et-emploi": c12,
    "trends-in-glycoscience-and-glycotechnology": c13,
    "trends-journals": c14,
    "triangle": c15,
    "trinity-college-dublin-zoology-botany-environmental-sciences-harvard": c16,
    "tropical-animal-health-and-production": c17,
    "tsaqafah": c18,
    "turcica": c19,
    "turkiye-bilimsel-ve-teknolojik-arastirma-kurumu": c20,
    "tyndale-bulletin": c21,
    "u-schylku-starozytnosci": c22,
    "ucl-institute-of-education-harvard": c23,
    "ucl-press-note": c24,
    "ucl-university-college-apa": c25,
    "ucl-university-college-harvard": c01,
    "ucl-university-college-vancouver": c02,
    "uclouvain-centre-charles-de-visscher-pour-le-droit-international-et-europeen": c03,
    "ugent-geschiedenis-nederlands": c04,
    "ugeskrift-for-laeger": c05,
    "ultrasound-in-medicine-and-biology": c06,
    "ulua-revista-de-historia-sociedad-y-cultura": c07,
    "uludag-universitesi-sosyal-bilimler-enstitusu-author-date": c08,
    "uludag-universitesi-sosyal-bilimler-enstitusu-full-note-with-ibid": c09,
    "uludag-universitesi-sosyal-bilimler-enstitusu-full-note": c10,
    "uludag-universitesi-sosyal-bilimler-enstitusu-ilahiyat-fakultesi-full-note-with-ibid": c11,
    "uludag-universitesi-sosyal-bilimler-enstitusu-ilahiyat-fakultesi-full-note": c12,
    "umea-university-harvard": c13,
    "umea-university-oxford": c14,
    "undergraduate-journal-of-experimental-microbiology-and-immunology": c15,
    "unesco-international-institute-for-educational-planning": c16,
    "uni-fribourg-theologie": c17,
    "unified-style-sheet-for-linguistics-de-gruyter-literature": c18,
    "unified-style-sheet-for-linguistics": c19,
    "united-nations-conference-on-trade-and-development": c20,
    "united-nations-development-programme-icca-legal-review": c21,
    "united-nations-framework-convention-on-climate-change": c22,
    "united-states-international-trade-commission": c23,
    "universidad-autonoma-cidudad-juarez-estilo-latino-humanistico": c24,
    "universidad-de-leon-harvard": c25,
    "universidad-evangelica-del-paraguay": c01,
    "universidad-nacional-autonoma-de-mexico-instituto-de-investigaciones-juridicas": c02,
    "universidade-de-sao-paulo-escola-de-comunicacoes-e-artes-abnt": c03,
    "universidade-de-sao-paulo-instituto-de-matematica-e-estatistica": c04,
    "universidade-do-estado-do-rio-de-janeiro-abnt": c05,
    "universidade-do-porto-faculdade-de-engenharia-chicago-pt": c06,
    "universidade-do-porto-faculdade-de-engenharia-chicago": c07,
    "universidade-do-porto-faculdade-de-psicologia-e-de-ciencias-da-educacao": c08,
    "universidade-estadual-de-alagoas-abnt": c09,
    "universidade-estadual-do-oeste-do-parana-programa-institucional-de-bolsas-de-iniciacao-cientifica": c10,
    "universidade-estadual-paulista-campus-de-dracena-abnt": c11,
    "universidade-estadual-paulista-faculdade-de-engenharia-de-guaratingueta-abnt": c12,
    "universidade-federal-de-goias-escola-de-veterinaria-e-zootecnia": c13,
    "universidade-federal-de-juiz-de-fora": c14,
    "universidade-federal-de-pernambuco-abnt": c15,
    "universidade-federal-de-sergipe-departamento-de-engenharia-de-producao-abnt": c16,
    "universidade-federal-do-espirito-santo-abnt-initials": c17,
    "universidade-federal-do-espirito-santo-abnt": c18,
    "universidade-federal-do-rio-de-janeiro-instituto-alberto-luiz-coimbra-de-pos-graduacao-e-pesquisa-de-engenharia-abnt": c19,
    "universita-cattolica-del-sacro-cuore": c20,
    "universita-di-bologna-lettere": c21,
    "universita-pontificia-salesiana-it": c22,
    "universita-pontificia-salesiana": c23,
    "universitas-brawijaya-fakultas-teknologi-pertanian": c24,
    "universitas-gadjah-mada-departemen-sejarah": c25,
    "universitas-gadjah-mada-doctoral-program-in-pharmaceutical-sciences": c01,
    "universitas-negeri-semarang-fakultas-matematika-dan-ilmu-pengetahuan-alam": c02,
    "universitas-negeri-yogyakarta-program-pascasarjana": c03,
    "universitat-basel-deutsche-sprachwissenschaft": c04,
    "universitat-basel-iberoromanistik": c05,
    "universitat-bern-institut-fur-musikwissenschaft-note": c06,
    "universitat-bern-institut-fur-sozialanthropologie": c07,
    "universitat-bern-institut-fur-theaterwissenschaft": c08,
    "universitat-bremen-frankoromanistik-literaturwissenschaft": c09,
    "universitat-bremen-institut-fur-politikwissenschaft": c10,
    "universitat-bremen-lehrstuhl-fur-innovatives-markenmanagement": c11,
    "universitat-freiburg-geschichte": c12,
    "universitat-graz-geographie": c13,
    "universitat-heidelberg-historisches-seminar": c14,
    "universitat-heidelberg-medizinische-fakultat-mannheim-numeric": c15,
    "universitat-mainz-geographisches-institut": c16,
    "universitat-mannheim-germanistische-linguistik": c17,
    "universitat-stuttgart-planung-und-partizipation": c18,
    "universitat-vechta-katholische-theologie": c19,
    "universitat-wien-institut-fur-geschichte": c20,
    "universitat-wurzburg-institut-fur-deutsche-philologie-museologie": c21,
    "universitat-zu-koln-seminar-fur-abwl-und-finanzierungslehre": c22,
    "universitatsmedizin-gottingen": c23,
    "universite-catholique-de-louvain-fial": c24,
    "universite-catholique-de-louvain-histoire": c25,
    "universite-cheikh-anta-diop-faculte-de-medecine-de-pharmacie-et-dodontologie": c01,
    "universite-de-bordeaux-ecole-doctorale-de-droit": c02,
    "universite-de-geneve-departement-de-langue-et-de-litterature-francaises-modernes": c03,
    "universite-de-lausanne-histoire": c04,
    "universite-de-lausanne-institut-d-archeologie-et-des-sciences-de-l-antiquite": c05,
    "universite-de-liege-droit-par-categorie": c06,
    "universite-de-liege-droit": c07,
    "universite-de-liege-histoire": c08,
    "universite-de-montreal-apa": c09,
    "universite-de-montreal-faculte-de-musique": c10,
    "universite-de-montreal-nlm-fr-ca": c11,
    "universite-de-picardie-jules-verne-ufr-de-medecine": c12,
    "universite-de-sherbrooke-departement-de-geomatique": c13,
    "universite-de-sherbrooke-faculte-d-education": c14,
    "universite-de-sherbrooke-histoire": c15,
    "universite-du-quebec-a-montreal-departement-dhistoire": c16,
    "universite-du-quebec-a-montreal-etudes-litteraires-et-semiologie": c17,
    "universite-du-quebec-a-montreal-prenoms": c18,
    "universite-du-quebec-a-montreal": c19,
    "universite-gustave-eiffel-arts-numeriques-et-cultures-visuelles": c20,
    "universite-laval-departement-des-sciences-historiques": c21,
    "universite-laval-departement-dinformation-et-de-communication": c22,
    "universite-laval-faculte-de-theologie-et-de-sciences-religieuses": c23,
    "universite-libre-de-bruxelles-histoire": c24,
    "universite-nangui-abrogoua-sciences-de-la-nature-apa": c25,
    "universiteit-utrecht-onderzoeksgids-geschiedenis": c01,
    "universitetet-i-oslo-rettsvitenskap": c02,
    "universiti-kebangsaan-malaysia": c03,
    "university-college-dublin-school-of-history-and-archives": c04,
    "university-college-lillebaelt-apa": c05,
    "university-of-aberdeen-school-of-education-harvard": c06,
    "university-of-aleppo-faculty-of-medicine": c07,
    "university-of-auckland-history": c08,
    "university-of-bradford-harvard": c09,
    "university-of-bucharest-faculty-of-law": c10,
    "university-of-cambridge-faculty-of-history": c11,
    "university-of-gothenburg-apa-7th-edition-swedish-legislations": c12,
    "university-of-gothenburg-apa-swedish-legislations": c13,
    "university-of-helsinki-faculty-of-theology": c14,
    "university-of-hull-harvard": c15,
    "university-of-lincoln-harvard": c16,
    "university-of-new-england-australia-note": c17,
    "university-of-new-south-wales-notes": c18,
    "university-of-pretoria-harvard-theology-religion": c19,
    "university-of-roehampton-harvard": c20,
    "university-of-south-africa-harvard": c21,
    "university-of-south-australia-2017-harvard": c22,
    "university-of-south-australia-harvard-2011": c23,
    "university-of-south-australia-harvard-2013": c24,
    "university-of-south-wales-harvard": c25,
    "university-of-tasmania-simplified-author-date": c01,
    "university-of-york-harvard-archaeology": c02,
    "university-of-york-harvard-environment": c03,
    "university-of-york-harvard": c04,
    "university-of-zabol-fa": c05,
    "university-of-zabol": c06,
    "univerza-na-primorskem-fakulteta-za-vede-o-zdravju-apa": c07,
    "univerza-v-ljubljani-fakulteta-za-gradbenistvo-in-geodezijo-apa-7": c08,
    "univerza-v-ljubljani-fakulteta-za-kemijo-in-kemijsko-tehnologijo": c09,
    "uniwersytet-gdanski-kulturoznawstwo-autor-rok": c10,
    "uniwersytet-gdanski-kulturoznawstwo-przypis": c11,
    "uniwersytet-im-adama-mickiewicza-w-poznaniu-wydzial-anglistyki": c12,
    "uniwersytet-kardynala-stefana-wyszynskiego-w-warszawie-autor-rok": c13,
    "uniwersytet-kardynala-stefana-wyszynskiego-w-warszawie-przypis": c14,
    "uppsala-universitet-historia": c15,
    "uppsala-universitet-institutionen-for-biologisk-grundutbildning": c16,
    "uppsala-university-library-harvard": c17,
    "urad-rs-za-makroekonomske-analize-in-razvoj": c18,
    "urban-geography": c19,
    "urban-habitats": c20,
    "urban-studies": c21,
    "urbani-izziv-en": c22,
    "urbani-izziv": c23,
    "urological-science": c24,
    "us-geological-survey": c25,
    "usda-forest-service-pacific-northwest-research-station": c01,
    "user-modeling-and-user-adapted-interaction": c02,
    "uspekhi-gerontologii": c03,
    "utah-geological-survey": c04,
    "van-yuzuncu-yil-universitesi-fen-bilimleri-enstitusu": c05,
    "veterinaria-italiana": c06,
    "veterinary-anaesthesia-analgesia": c07,
    "veterinary-clinical-pathology": c08,
    "veterinary-medicine-austria": c09,
    "veterinary-microbiology": c10,
    "veterinary-pathology": c11,
    "veterinary-radiology-and-ultrasound": c12,
    "veterinary-record-open": c13,
    "veterinary-record": c14,
    "victoria-university-harvard": c15,
    "vienna-legal": c16,
    "vietnam-journal-of-science-and-technology": c17,
    "vietnam-ministry-of-education-and-training-en": c18,
    "vietnam-ministry-of-education-and-training-vi": c19,
    "vigiliae-christianae": c20,
    "vingtieme-siecle": c21,
    "vita-latina-auteurs-anciens": c22,
    "vita-latina": c23,
    "vitis-journal-of-grapevine-research": c24,
    "vodohospodarske-technicko-ekonomicke-informace-en": c25,
    "vodohospodarske-technicko-ekonomicke-informace": c01,
    "vox-sanguinis": c02,
    "wader-study": c03,
    "water-alternatives": c04,
    "water-environment-research": c05,
    "water-sa": c06,
    "water-science-and-technology": c07,
    "waterbirds": c08,
    "weed-research": c09,
    "weed-science-society-of-america": c10,
    "west-european-politics": c11,
    "western-journal-of-emergency-medicine": c12,
    "westfalische-wilhelms-universitat-munster-medizinische-fakultat": c13,
    "wetlands": c14,
    "wheaton-college-phd-in-biblical-and-theological-studies": c15,
    "who-europe-harvard": c16,
    "who-europe-numeric": c17,
    "wiener-digitale-revue": c18,
    "wiesbaden-business-school": c19,
    "wikipedia-fr-templates": c20,
    "wikipedia-templates": c21,
    "wiley-vch-books": c22,
    "wiley-was": c23,
    "wireless-communications-and-mobile-computing": c24,
    "wirtschaftsuniversitat-wien-abteilung-fur-bildungswissenschaft": c25,
    "wirtschaftsuniversitat-wien-author-date": c01,
    "wirtschaftsuniversitat-wien-handel-und-marketing": c02,
    "wirtschaftsuniversitat-wien-health-care-management": c03,
    "wirtschaftsuniversitat-wien-institut-fur-bwl-des-aussenhandels": c04,
    "wirtschaftsuniversitat-wien-institut-fur-transportwirtschaft-und-logistik": c05,
    "wirtschaftsuniversitat-wien-unternehmensrechnung-und-controlling": c06,
    "wirtschaftsuniversitat-wien-wirtschaftspadagogik": c07,
    "wissenschaftlicher-industrielogistik-dialog": c08,
    "wolters-kluwerbrede-schrijfwijzer-author-date": c09,
    "world-applied-sciences-journal": c10,
    "world-congress-on-engineering-asset-management": c11,
    "world-mycotoxin-journal": c12,
    "world-organisation-for-animal-health-scientific-and-technical-review": c13,
    "world-politics": c14,
    "worlds-poultry-science-journal": c15,
    "worlds-veterinary-journal": c16,
    "xenotransplantation": c17,
    "yeast": c18,
    "yozgat-bozok-universitesi-fen-bilimleri-enstitusu": c19,
    "zastosowania-komputerow-w-elektrotechnice": c20,
    "zdfm-zeitschrift-fur-diversitatsforschung-und-management": c21,
    "zdravniski-vestnik": c22,
    "zeitgeschichte": c23,
    "zeithistorische-forschungen": c24,
    "zeitschrift-fur-allgemeinmedizin": c25,
    "zeitschrift-fur-antikes-christentum": c01,
    "zeitschrift-fur-deutsche-philologie": c02,
    "zeitschrift-fur-die-geschichte-des-oberrheins": c03,
    "zeitschrift-fur-digitale-geisteswissenschaften": c04,
    "zeitschrift-fur-fantastikforschung": c05,
    "zeitschrift-fur-geschichtsdidaktik": c06,
    "zeitschrift-fur-internationale-beziehungen": c07,
    "zeitschrift-fur-kunstgeschichte": c08,
    "zeitschrift-fur-medien-und-kulturforschung": c09,
    "zeitschrift-fur-medienwissenschaft": c10,
    "zeitschrift-fur-ostmitteleuropa-forschung": c11,
    "zeitschrift-fur-padagogik": c12,
    "zeitschrift-fur-papyrologie-und-epigraphik": c13,
    "zeitschrift-fur-parlamentsfragen": c14,
    "zeitschrift-fur-politik": c15,
    "zeitschrift-fur-qualitative-forschung": c16,
    "zeitschrift-fur-religionswissenschaft-author-date": c17,
    "zeitschrift-fur-religionswissenschaft-note": c18,
    "zeitschrift-fur-soziologie": c19,
    "zeitschrift-fur-theologie-und-kirche": c20,
    "zeitschrift-fur-theologie-und-philosophie": c21,
    "zeitschrift-fur-zahnarztliche-implantologie": c22,
    "zeszyty-prawnicze-bas": c23,
    "zilsel": c24,
    "zitierguide-leitfaden-zum-fachgerechten-zitieren-in-rechtswissenschaftlichen-arbeiten": c25,
    "zoological-journal-of-the-linnean-society": c01,
    "zoological-science": c02,
    "zootaxa": c03,
    "zurcher-hochschule-fur-angewandte-wissenschaften-soziale-arbeit": c04,
    "zwitscher-maschine": c05
}

export const styles = {
    "aci-materials-journal": "ACI Materials Journal",
    "acm-sig-proceedings-long-author-list": "ACM SIG Proceedings (\"et al.\" for 15+ authors)",
    "acm-sig-proceedings": "ACM SIG Proceedings (\"et al.\" for 3+ authors)",
    "acm-sigchi-proceedings": "ACM SIGCHI Proceedings (2016)",
    "acm-sigchi-proceedings-extended-abstract-format": "ACM SIGCHI Proceedings - Extended Abstract Format",
    "acm-siggraph": "ACM SIGGRAPH",
    "acme-an-international-journal-for-critical-geographies": "ACME: An International Journal for Critical Geographies",
    "american-chemical-society": "ACS Guide 2022 revision",
    "aib-studi": "AIB studi (Italiano)",
    "aids": "AIDS",
    "aims-press": "AIMS Press",
    "american-institute-of-physics": "AIP Style Manual 4th edition",
    "american-medical-association-10th-edition": "AMA Manual of Style 10th edition",
    "american-medical-association": "AMA Manual of Style 11th edition",
    "american-medical-association-brackets": "AMA Manual of Style 11th edition (brackets)",
    "american-medical-association-no-et-al": "AMA Manual of Style 11th edition (no \"et al.\")",
    "american-medical-association-parentheses": "AMA Manual of Style 11th edition (parentheses)",
    "american-medical-association-alphabetical": "AMA Manual of Style 11th edition (sorted alphabetically)",
    "american-medical-association-no-url-alphabetical": "AMA Manual of Style 11th edition (sorted alphabetically, without URLs)",
    "american-medical-association-no-url": "AMA Manual of Style 11th edition (without URLs)",
    "ambio": "AMBIO",
    "associacao-nacional-de-pesquisa-e-ensino-em-transportes": "ANPET - Congresso de Pesquisa e Ensino em Transportes (Português - Brasil)",
    "apa-6th-edition": "APA Style 6th edition",
    "apa-fr-provost": "APA Style 6th edition (Provost) (Français - Canada)",
    "apa-tr": "APA Style 6th edition (Türkçe)",
    "apa": "APA Style 7th edition",
    "apa-eu": "APA Style 7th edition (Basque/Euskara)",
    "apa-annotated-bibliography": "APA Style 7th edition (annotated bibliography)",
    "apa-cv": "APA Style 7th edition (curriculum vitae, sorted by descending date)",
    "apa-no-ampersand": "APA Style 7th edition (no ampersand)",
    "apa-no-initials": "APA Style 7th edition (no initials)",
    "apa-numeric-superscript": "APA Style 7th edition (numeric, superscript)",
    "apa-numeric-superscript-brackets": "APA Style 7th edition (numeric, superscript, brackets)",
    "apa-single-spaced": "APA Style 7th edition (single-spaced bibliography)",
    "apa-with-abstract": "APA Style 7th edition (with abstract)",
    "american-political-science-association": "APSA Style Manual revised 2018 edition",
    "american-sociological-association": "ASA Style Guide 6th/7th edition",
    "asaio-journal": "ASAIO Journal (American Society for Artificial Internal Organs)",
    "azr-abkurzungs-und-zitierregeln-der-osterreichischen-rechtssprache-und-europarechtlicher-rechtsquellen": "AZR - Abkürzungs- und Zitierregeln der österreichischen Rechtssprache und europarechtlicher Rechtsquellen (Deutsch - Österreich)",
    "academy-of-management-perspectives": "Academy of Management Perspectives",
    "academy-of-management-review": "Academy of Management Review",
    "accident-analysis-and-prevention": "Accident Analysis and Prevention",
    "acta-adriatica": "Acta Adriatica",
    "acta-amazonica": "Acta Amazonica",
    "acta-anaesthesiologica-scandinavica": "Acta Anaesthesiologica Scandinavica",
    "acta-anaesthesiologica-taiwanica": "Acta Anaesthesiologica Taiwanica",
    "acta-botanica-croatica": "Acta Botanica Croatica",
    "acta-chiropterologica": "Acta Chiropterologica",
    "acta-medica-peruana": "Acta Médica Peruana",
    "acta-medica-portuguesa": "Acta Médica Portuguesa",
    "acta-naturae": "Acta Naturae",
    "acta-neurobiologiae-experimentalis": "Acta Neurobiologiae Experimentalis",
    "acta-neurochirurgica": "Acta Neurochirurgica",
    "acta-ophthalmologica": "Acta Ophthalmologica",
    "acta-ornithologica": "Acta Ornithologica",
    "acta-orthopaedica": "Acta Orthopaedica",
    "acta-orthopaedica-belgica": "Acta Orthopædica Belgica",
    "acta-paediatrica": "Acta Paediatrica",
    "acta-palaeontologica-polonica": "Acta Palaeontologica Polonica",
    "acta-pharmaceutica": "Acta Pharmaceutica",
    "acta-pharmaceutica-sinica-b": "Acta Pharmaceutica Sinica B",
    "acta-philosophica": "Acta Philosophica",
    "acta-physica-sinica": "Acta Physica Sinica (物理学报)",
    "acta-physiologica": "Acta Physiologica",
    "acta-polytechnica": "Acta Polytechnica",
    "acta-radiologica": "Acta Radiologica",
    "acta-scientiae-veterinariae": "Acta Scientiae Veterinariae",
    "acta-societatis-botanicorum-poloniae": "Acta Societatis Botanicorum Poloniae",
    "acta-universitatis-agriculturae-sueciae": "Acta Universitatis Agriculturae Sueciae (Swedish University of Agricultural Sciences)",
    "acta-universitatis-agriculturae-et-silviculturae-mendelianae-brunensis": "Acta Universitatis Agriculturae et Silviculturae Mendelianae Brunensis",
    "auci": "Acta Universitatis Carolinae Iuridica (Čeština)",
    "acta-zoologica-academiae-scientiarum-hungaricae": "Acta Zoologica Academiae Scientiarum Hungaricae",
    "acta-chirurgiae-orthopaedicae-et-traumatologiae-cechoslovaca": "Acta chirurgiae orthopaedicae et traumatologiae Čechoslovaca",
    "acta-hydrotechnica": "Acta hydrotechnica",
    "administrative-science-quarterly": "Administrative Science Quarterly",
    "advanced-engineering-materials": "Advanced Engineering Materials",
    "advanced-functional-materials": "Advanced Functional Materials",
    "advanced-healthcare-materials": "Advanced Healthcare Materials",
    "advanced-materials": "Advanced Materials",
    "advanced-optical-materials": "Advanced Optical Materials",
    "advanced-pharmaceutical-bulletin": "Advanced Pharmaceutical Bulletin",
    "advanced-science": "Advanced Science",
    "advances-in-alzheimers-disease": "Advances in Alzheimer's Disease",
    "advances-in-complex-systems": "Advances in Complex Systems",
    "aerosol-science-and-technology": "Aerosol Science and Technology",
    "aerosol-and-air-quality-research": "Aerosol and Air Quality Research",
    "aerospace-medicine-and-human-performance": "Aerospace Medicine and Human Performance",
    "african-journal-of-marine-science": "African Journal of Marine Science",
    "african-online-scientific-information-systems-harvard": "African Online Scientific Information Systems (author-date/Harvard)",
    "african-online-scientific-information-systems-vancouver": "African Online Scientific Information Systems - NLM/Vancouver",
    "african-zoology": "African Zoology",
    "afro-asia": "Afro-Ásia (Português - Brasil)",
    "ageing-and-society": "Ageing & Society",
    "aging": "Aging",
    "aging-cell": "Aging Cell",
    "aging-and-disease": "Aging and Disease",
    "agora": "Agora",
    "agriculturae-conspectus-scientificus": "Agriculturae Conspectus Scientificus",
    "aix-marseille-universite-departement-d-etudes-asiatiques": "Aix-Marseille Université - Département d'études asiatiques (Français)",
    "al-jamiah-journal-of-islamic-studies": "Al-Jami'ah - Journal of Islamic Studies",
    "universitat-freiburg-geschichte": "Albert-Ludwigs-Universität Freiburg - Geschichte (Deutsch)",
    "alcohol-and-alcoholism": "Alcohol and Alcoholism",
    "alcoholism-clinical-and-experimental-research": "Alcoholism: Clinical and Experimental Research",
    "alkoholizmus-a-drogove-zavislosti": "Alkoholizmus a drogové závislosti",
    "allergology-international": "Allergology International",
    "allergy": "Allergy",
    "alternatif-politika": "Alternatif Politika",
    "alternatives-to-animal-experimentation": "Alternatives to Animal Experimentation",
    "ameghiniana": "Ameghiniana",
    "american-anthropological-association": "American Anthropological Association",
    "american-association-for-cancer-research": "American Association for Cancer Research",
    "american-association-of-petroleum-geologists": "American Association of Petroleum Geologists",
    "american-college-of-clinical-pharmacy": "American College of Clinical Pharmacy",
    "american-fisheries-society": "American Fisheries Society",
    "american-geophysical-union": "American Geophysical Union",
    "american-heart-association": "American Heart Association",
    "american-institute-of-aeronautics-and-astronautics": "American Institute of Aeronautics and Astronautics",
    "american-journal-of-archaeology": "American Journal of Archaeology",
    "american-journal-of-botany": "American Journal of Botany",
    "american-journal-of-cancer-research": "American Journal of Cancer Research",
    "american-journal-of-climate-change": "American Journal of Climate Change",
    "american-journal-of-clinical-pathology": "American Journal of Clinical Pathology",
    "american-journal-of-enology-and-viticulture": "American Journal of Enology and Viticulture",
    "american-journal-of-health-behavior": "American Journal of Health Behavior",
    "american-journal-of-medical-genetics": "American Journal of Medical Genetics",
    "american-journal-of-neuroradiology": "American Journal of Neuroradiology",
    "american-journal-of-orthodontics-and-dentofacial-orthopedics": "American Journal of Orthodontics & Dentofacial Orthopedics",
    "american-journal-of-plant-sciences": "American Journal of Plant Sciences",
    "american-journal-of-political-science": "American Journal of Political Science",
    "american-journal-of-respiratory-and-critical-care-medicine": "American Journal of Respiratory and Critical Care Medicine",
    "american-journal-of-roentgenology": "American Journal of Roentgenology",
    "american-journal-of-science": "American Journal of Science",
    "american-journal-of-sociology": "American Journal of Sociology",
    "american-journal-of-sonography": "American Journal of Sonography",
    "american-journal-of-surgical-pathology": "American Journal of Surgical Pathology",
    "american-journal-of-translational-research": "American Journal of Translational Research",
    "american-marketing-association": "American Marketing Association",
    "american-mathematical-society-label": "American Mathematical Society (label)",
    "american-mathematical-society-numeric": "American Mathematical Society (numeric)",
    "american-meteorological-society": "American Meteorological Society",
    "american-mineralogist": "American Mineralogist",
    "american-nuclear-society": "American Nuclear Society",
    "american-physics-society": "American Physical Society",
    "american-physics-society-without-titles": "American Physical Society (without titles)",
    "american-physical-society-et-al": "American Physical Society - et al. (if more than 3 authors)",
    "american-physiological-society": "American Physiological Society",
    "american-phytopathological-society": "American Phytopathological Society",
    "american-school-of-classical-studies-at-athens": "American School of Classical Studies at Athens",
    "american-society-for-horticultural-science": "American Society for Horticultural Science",
    "american-society-for-microbiology": "American Society for Microbiology",
    "american-society-for-pharmacology-and-experimental-therapeutics": "American Society for Pharmacology and Experimental Therapeutics",
    "american-society-of-agricultural-and-biological-engineers": "American Society of Agricultural and Biological Engineers",
    "asa-cssa-sssa": "American Society of Agronomy, Crop Science Society of America, Soil Science Society of America",
    "american-society-of-civil-engineers": "American Society of Civil Engineers",
    "american-society-of-mechanical-engineers": "American Society of Mechanical Engineers",
    "american-statistical-association": "American Statistical Association",
    "american-veterinary-medical-association": "American Veterinary Medical Association",
    "amerindia": "Amerindia",
    "amphibia-reptilia": "Amphibia-Reptilia",
    "anabases": "Anabases",
    "anaesthesia": "Anaesthesia",
    "anais-da-academia-brasileira-de-ciencias": "Anais da Academia Brasileira de Ciências",
    "analytical-sciences": "Analytical Sciences",
    "anatomical-sciences-education": "Anatomical Sciences Education",
    "ancilla-iuris": "Ancilla Iuris",
    "andean-geology": "Andean Geology",
    "anesthesia-and-analgesia": "Anesthesia and Analgesia",
    "anesthesiology": "Anesthesiology",
    "angewandte-chemie": "Angewandte Chemie International Edition",
    "angiologia": "Angiologia (Español)",
    "angiology": "Angiology",
    "anglia": "Anglia",
    "harvard-anglia-ruskin-university": "Anglia Ruskin University (author-date/Harvard)",
    "animal-conservation": "Animal Conservation",
    "animal-migration": "Animal Migration",
    "animal-welfare": "Animal Welfare",
    "ankara-universitesi-sosyal-bilimler-enstitusu-hukuk-fakultesi": "Ankara Üniversitesi - Sosyal Bilimler Enstitüsü - Hukuk Fakültesi (Türkçe)",
    "annalen-des-naturhistorischen-museums-in-wien": "Annalen des Naturhistorischen Museums in Wien",
    "annales-de-demographie-historique": "Annales de démographie historique",
    "annales": "Annales. Histoire, Sciences sociales (Français)",
    "annals-of-allergy-asthma-and-immunology": "Annals of Allergy, Asthma & Immunology",
    "annals-of-applied-biology": "Annals of Applied Biology",
    "annals-of-behavioral-medicine": "Annals of Behavioral Medicine",
    "annals-of-biomedical-engineering": "Annals of Biomedical Engineering",
    "annals-of-botany": "Annals of Botany",
    "annals-of-eye-science": "Annals of Eye Science",
    "annals-of-joint": "Annals of Joint",
    "annals-of-laboratory-medicine": "Annals of Laboratory Medicine",
    "annals-of-neurology": "Annals of Neurology",
    "annals-of-oncology": "Annals of Oncology",
    "annals-of-public-and-cooperative-economics": "Annals of Public and Cooperative Economics",
    "annals-of-surgery": "Annals of Surgery",
    "annals-of-the-association-of-american-geographers": "Annals of the Association of American Geographers",
    "annals-of-the-new-york-academy-of-sciences": "Annals of the New York Academy of Sciences",
    "annual-review-of-astronomy-and-astrophysics": "Annual Review of Astronomy and Astrophysics",
    "annual-review-of-linguistics": "Annual Review of Linguistics",
    "annual-review-of-medicine": "Annual Review of Medicine",
    "annual-review-of-nuclear-and-particle-science": "Annual Review of Nuclear and Particle Science",
    "annual-reviews-author-date": "Annual Reviews (author-date)",
    "annual-reviews-alphabetical": "Annual Reviews (sorted alphabetically)",
    "annual-reviews": "Annual Reviews (sorted by order of appearance)",
    "annual-reviews-without-titles": "Annual Reviews (sorted by order of appearance, without titles)",
    "antarctic-science": "Antarctic Science",
    "anthropologie-et-societes": "Anthropologie et Sociétés (Français)",
    "anti-trafficking-review": "Anti-Trafficking Review",
    "anticancer-research": "Anticancer Research",
    "antipode": "Antipode",
    "antiquity": "Antiquity",
    "antiquites-africaines": "Antiquités africaines",
    "aporia-the-nursing-journal": "Aporia: The Nursing Journal",
    "applications-in-plant-sciences": "Applications in Plant Sciences",
    "applied-clay-science": "Applied Clay Science",
    "applied-spectroscopy": "Applied Spectroscopy",
    "applied-spectroscopy-reviews": "Applied Spectroscopy Reviews",
    "aquatic-conservation": "Aquatic Conservation: Marine and Freshwater Ecosystems",
    "aquatic-invasions": "Aquatic Invasions",
    "aquatic-living-resources": "Aquatic Living Resources",
    "aquitania": "Aquitania (Français)",
    "arachne": "Arachne",
    "arachnologische-mitteilungen": "Arachnologische Mitteilungen",
    "arachnology": "Arachnology",
    "arcadia-science": "Arcadia Science",
    "archaeologia-austriaca": "Archaeologia Austriaca",
    "archaeometry": "Archaeometry",
    "archaeonautica": "Archaeonautica",
    "archeosciences": "ArcheoSciences (Français)",
    "archeologia-classica": "Archeologia Classica (Italiano)",
    "archeologia-e-calcolatori": "Archeologia e Calcolatori",
    "archeologicke-rozhledy": "Archeologické rozhledy",
    "archimede-archeologie-et-histoire-ancienne": "Archimède. Archéologie et histoire ancienne (French)",
    "archiv-fur-geschichte-der-philosophie": "Archiv für Geschichte der Philosophie",
    "archiv-fur-die-civilistische-praxis": "Archiv für die civilistische Praxis (Deutsch)",
    "archives-of-hand-and-microsurgery": "Archives of Hand and Microsurgery",
    "archives-of-medical-research": "Archives of Medical Research",
    "archives-of-physical-medicine-and-rehabilitation": "Archives of Physical Medicine and Rehabilitation",
    "archivos-peruanos-de-cardiologia-y-cirugia-cardiovascular": "Archivos Peruanos de Cardiología y Cirugía Cardiovascular",
    "archivos-de-bronconeumologia": "Archivos de Bronconeumología",
    "archivos-de-la-sociedad-espanola-de-oftalmologia": "Archivos de la Sociedad Española de Oftalmología (Español)",
    "archivum-latinitatis-medii-aevi": "Archivum Latinitatis Medii Aevi (Français)",
    "archeologie-medievale": "Archéologie médiévale (Français)",
    "archeologies-et-sciences-de-lantiquite": "Archéologies et Sciences de l'Antiquité (Français)",
    "arctic": "Arctic",
    "arctic-antarctic-and-alpine-research": "Arctic, Antarctic, and Alpine Research",
    "arhiv-za-higijenu-rada-i-toksikologiju": "Arhiv za higijenu rada i toksikologiju (Archives of Industrial Hygiene and Toxicology)",
    "arkivoc": "Arkivoc",
    "art-history": "Art History",
    "art-libraries-society-of-north-america-arlisna-reviews": "Art Libraries Society of North America: ARLIS/NA Reviews",
    "artery-research": "Artery Research",
    "arthritis-and-rheumatism": "Arthritis & Rheumatism",
    "arthropod-systematics-and-phylogeny": "Arthropod Systematics & Phylogeny",
    "arts-university-bournemouth": "Arts University Bournemouth",
    "arzneimitteltherapie": "Arzneimitteltherapie",
    "asia-and-the-pacific-policy-studies": "Asia & the Pacific Policy Studies",
    "asia-pacific-journal-of-human-resources": "Asia Pacific Journal of Human Resources",
    "asian-journal-of-neurosurgery": "Asian Journal of Neurosurgery",
    "asian-myrmecology": "Asian Myrmecology",
    "asian-studies-review": "Asian Studies Review",
    "association-de-science-regionale-de-langue-francaise": "Association de Science Régionale de Langue Française (Français)",
    "association-for-computational-linguistics": "Association for Computational Linguistics - Conference Proceedings",
    "association-for-computing-machinery": "Association for Computing Machinery",
    "associacao-brasileira-de-normas-tecnicas": "Associação Brasileira de Normas Técnicas (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-note": "Associação Brasileira de Normas Técnicas (note, Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-numerico": "Associação Brasileira de Normas Técnicas (numérico, Português - Brasil)",
    "atlande": "Atlande (author-date, Français)",
    "atlas-of-genetics-and-cytogenetics-in-oncology-and-haematology": "Atlas of Genetics and Cytogenetics in Oncology and Haematology",
    "ausonius-editions": "Ausonius Éditions",
    "austral-ecology": "Austral Ecology",
    "austral-entomology": "Austral Entomology",
    "australasian-journal-of-philosophy": "Australasian Journal of Philosophy",
    "australian-archaeology": "Australian Archaeology",
    "australian-critical-care": "Australian Critical Care",
    "australian-dental-journal": "Australian Dental Journal",
    "australian-guide-to-legal-citation-3rd-edition": "Australian Guide to Legal Citation 3rd edition",
    "australian-guide-to-legal-citation": "Australian Guide to Legal Citation 4th edition",
    "australian-historical-studies": "Australian Historical Studies",
    "australian-journal-of-earth-sciences": "Australian Journal of Earth Sciences",
    "australian-journal-of-grape-and-wine-research": "Australian Journal of Grape and Wine Research",
    "australian-road-research-board": "Australian Road Research Board",
    "australian-veterinary-journal": "Australian Veterinary Journal",
    "austrian-journal-of-development-studies": "Austrian Journal of Development Studies (Journal für Entwicklungspolitik)",
    "austrian-legal": "Austrian Legal (Deutsch - Österreich)",
    "aves": "Aves (Français)",
    "avian-conservation-and-ecology": "Avian Conservation and Ecology",
    "avian-diseases": "Avian Diseases",
    "avian-pathology": "Avian Pathology",
    "avocetta-journal-of-ornithology": "Avocetta Journal of Ornithology",
    "ayer": "Ayer (Español)",
    "babesch-annual-papers-on-mediterranean-archaeology": "BABESCH - Annual Papers on Mediterranean Archaeology",
    "bmj": "BMJ",
    "byzantina-symmeikta": "BYZANTINA SYMMEIKTA",
    "babes-bolyai-university-faculty-of-orthodox-theology": "Babes-Bolyai University - Faculty of Orthodox Theology (no ibid., Română)",
    "baghdad-science-journal": "Baghdad Science Journal",
    "baishideng-publishing-group": "Baishideng Publishing Group",
    "bakhtiniana-journal-of-discourse-studies": "Bakhtiniana: Journal of Discourse Studies",
    "barbara-budrich": "Barbara Budrich (Deutsch)",
    "begell-house-apa": "Begell House - APA",
    "begell-house-chicago-author-date": "Begell House - Chicago Manual of Style",
    "behaviour": "Behaviour",
    "beilstein-journal-of-organic-chemistry": "Beilstein Journal of Organic Chemistry",
    "beltz-padagogik": "Beltz - Pädagogik (Deutsch)",
    "berghahn-books-author-date-en-gb": "Berghahn Books (author-date, English - UK)",
    "berlin-school-of-economics-and-law-international-marketing-management": "Berlin School of Economics and Law - International Marketing Management",
    "bern-university-of-applied-sciences-school-of-agricultural-forest-and-food-sciences-hafl": "Bern University of Applied Sciences - School of Agricultural, Forest and Food Sciences HAFL (author-date)",
    "betriebswirtschaftliche-forschung-und-praxis": "Betriebswirtschaftliche Forschung und Praxis (Deutsch)",
    "bibtex": "BibTeX generic citation style",
    "biblio-3w": "Biblio 3W (Español)",
    "bibliotheca-hertziana-max-planck-institute-for-art-history": "Bibliotheca Hertziana - Max Planck Institute for Art History",
    "bibliothecae-it": "Bibliothecae.it (Italiano)",
    "bibliothek-fur-bildungsgeschichtliche-forschung": "Bibliothek für Bildungsgeschichtliche Forschung (BBF) (Deutsch)",
    "bibliothek-forschung-und-praxis": "Bibliothek – Forschung und Praxis",
    "bibliotheque-d-archeologie-mediterraneenne-et-africaine-biama": "Bibliothèque d'archéologie méditerranéenne et africaine (BiAMA) (Français)",
    "bibliotheque-universitaire-de-medecine-vancouver": "Bibliothèque universitaire de médecine - NLM/Vancouver",
    "biens-symboliques-symbolic-goods": "Biens symboliques / Symbolic Goods",
    "bio-protocol": "Bio-protocol",
    "biomed-central": "BioMed Central",
    "biomed-research-international": "BioMed Research International",
    "bioresources": "BioResources",
    "bioscience": "BioScience",
    "biosocieties": "BioSocieties",
    "biotechniques": "BioTechniques",
    "bioarchaeology-international": "Bioarchaeology International",
    "bioarchaeology-of-the-near-east": "Bioarchaeology of the Near East",
    "biochemical-journal": "Biochemical Journal",
    "biochemical-society-transactions": "Biochemical Society Transactions",
    "biochemistry": "Biochemistry",
    "biochemistry-and-molecular-biology-education": "Biochemistry and Molecular Biology Education",
    "biochimica-et-biophysica-acta": "Biochimica et Biophysica Acta",
    "bioelectromagnetics": "Bioelectromagnetics",
    "bioethics": "Bioethics",
    "biofuel-research-journal": "Biofuel Research Journal",
    "biologia": "Biologia",
    "biological-journal-of-the-linnean-society": "Biological Journal of the Linnean Society",
    "biological-psychiatry": "Biological Psychiatry",
    "biological-reviews": "Biological Reviews",
    "biological-and-pharmaceutical-bulletin": "Biological and Pharmaceutical Bulletin",
    "biology-of-reproduction": "Biology of Reproduction",
    "biomarkers": "Biomarkers",
    "biometrics": "Biometrics",
    "biomolecular-concepts": "Biomolecular Concepts",
    "biophysical-journal": "Biophysical Journal",
    "biophysics-and-physicobiology": "Biophysics and Physicobiology",
    "biopolymers": "Biopolymers",
    "biostatistics": "Biostatistics",
    "biota-neotropica": "Biota Neotropica",
    "biotechnology-and-bioengineering": "Biotechnology and Bioengineering",
    "biotechnology-and-bioprocess-engineering": "Biotechnology and Bioprocess Engineering",
    "biotropica": "Biotropica",
    "biuletyn-polskiego-towarzystwa-jezykoznawczego": "Biuletyn Polskiego Towarzystwa Językoznawczego (Polski)",
    "bloomsbury-academic": "Bloomsbury Academic",
    "bluebook-inline": "Bluebook Inline",
    "bluebook-law-review": "Bluebook Law Review",
    "bluebook-law-review-with-abstract": "Bluebook Law Review (with abstract)",
    "body-and-society": "Body & Society",
    "boletin-de-pediatria": "Boletín de Pediatría (Español)",
    "boletin-de-la-sociedad-geologica-mexicana": "Boletín de la Sociedad Geológica Mexicana (Español - Mexico)",
    "bollettino-d-archeologia-online": "Bollettino d'archeologia online (Italiano)",
    "bollettino-della-societa-italiana-di-paleontologia": "Bollettino della Società Italiana di Paleontologia",
    "boreal-environment-research": "Boreal Environment Research",
    "boreas": "Boreas",
    "botanical-journal-of-the-linnean-society": "Botanical Journal of the Linnean Society",
    "bourgogne-franche-comte-nature": "Bourgogne-Franche-Comté Nature (Français)",
    "harvard-bournemouth-university": "Bournemouth University (author-date/Harvard)",
    "brachytherapy": "Brachytherapy",
    "brain-behavior-and-evolution": "Brain, Behavior and Evolution",
    "brazilian-journal-of-experimental-design-data-analysis-and-inferential-statistics": "Brazilian Journal of Experimental Design, Data Analysis and Inferential Statistics",
    "brazilian-journal-of-infectious-diseases": "Brazilian Journal of Infectious Diseases",
    "brazilian-journal-of-psychiatry": "Brazilian Journal of Psychiatry",
    "brazilian-journal-of-veterinary-research-and-animal-science": "Brazilian Journal of Veterinary Research and Animal Science",
    "brazilian-oral-research": "Brazilian Oral Research",
    "brewingscience": "BrewingScience",
    "bristol-university-press": "Bristol University Press",
    "british-journal-of-anaesthesia": "British Journal of Anaesthesia",
    "british-journal-of-cancer": "British Journal of Cancer",
    "british-journal-of-dermatology": "British Journal of Dermatology",
    "british-journal-of-haematology": "British Journal of Haematology",
    "british-journal-of-industrial-relations": "British Journal of Industrial Relations",
    "british-journal-of-nutrition": "British Journal of Nutrition",
    "british-journal-of-pharmacology": "British Journal of Pharmacology",
    "british-journal-of-political-science": "British Journal of Political Science",
    "british-journal-of-surgery": "British Journal of Surgery",
    "british-psychological-society": "British Psychological Society",
    "brumaire-verlag": "Brumaire Verlag (Deutsch)",
    "budownictwo-i-architektura-pl": "Budownictwo i Architektura",
    "building-structure": "Building Structure (中文)",
    "buletin-agrohorti": "Buletin Agrohorti",
    "bulletin-de-correspondance-hellenique": "Bulletin de correspondance hellénique",
    "bulletin-de-la-societe-entomologique-de-france": "Bulletin de la Société Entomologique de France",
    "bulletin-de-la-societe-prehistorique-francaise": "Bulletin de la Société préhistorique française (Français)",
    "bulletin-du-centre-detudes-medievales-dauxerre": "Bulletin du Centre d’études médiévales d’Auxerre (Français)",
    "bulletin-of-applied-glycoscience": "Bulletin of Applied Glycoscience",
    "bulletin-of-geosciences": "Bulletin of Geosciences",
    "bulletin-of-insectology": "Bulletin of Insectology",
    "bulletin-of-marine-science": "Bulletin of Marine Science",
    "bulletin-of-the-american-schools-of-oriental-research": "Bulletin of the American Schools of Oriental Research",
    "bulletin-of-the-seismological-society-of-america": "Bulletin of the Seismological Society of America",
    "bursa-uludag-universitesi-egitim-bilimleri-enstitusu": "Bursa Uludağ Üniversitesi - Eğitim Bilimleri Enstitüsü",
    "bursa-uludag-universitesi-saglik-bilimleri-enstitusu": "Bursa Uludağ Üniversitesi - Sağlık Bilimleri Enstitüsü",
    "business-ethics-a-european-review": "Business Ethics: A European Review",
    "business-and-human-rights-journal": "Business and Human Rights Journal",
    "byzantine-and-modern-greek-studies": "Byzantine and Modern Greek Studies",
    "borgyogyaszati-es-venerologiai-szemle": "Bőrgyógyászati és Venerológiai Szemle (Magyar)",
    "chimia": "CHIMIA",
    "clara-architecture-recherche": "CLARA Architecture/Recherche (Français)",
    "cns-and-neurological-disorders-drug-targets": "CNS & Neurological Disorders - Drug Targets",
    "cns-spectrums": "CNS Spectrums",
    "cse-citation-name-8th-edition": "CSE Manual: Scientific Style and Format 8th edition (citation-name)",
    "cse-citation-sequence-8th-edition": "CSE Manual: Scientific Style and Format 8th edition (citation-sequence)",
    "cse-citation-sequence-brackets-8th-edition": "CSE Manual: Scientific Style and Format 8th edition (citation-sequence, brackets)",
    "cse-name-year-8th-edition": "CSE Manual: Scientific Style and Format 8th edition (name-year)",
    "cse-citation-name": "CSE Manual: Scientific Style and Format 9th edition (citation-name)",
    "cse-citation-sequence": "CSE Manual: Scientific Style and Format 9th edition (citation-sequence)",
    "cse-name-year": "CSE Manual: Scientific Style and Format 9th edition (name-year)",
    "cahiers-mondes-anciens": "Cahiers Mondes Anciens (Français)",
    "cahiers-d-ethnomusicologie": "Cahiers d'ethnomusicologie (Français)",
    "cahiers-du-centre-gustave-glotz": "Cahiers du Centre Gustave-Glotz (Français)",
    "california-agriculture": "California Agriculture",
    "cambridge-journal-of-economics": "Cambridge Journal of Economics",
    "cambridge-quarterly-of-healthcare-ethics": "Cambridge Quarterly of Healthcare Ethics",
    "cambridge-university-press-note": "Cambridge University Press (note)",
    "cambridge-university-press-numeric": "Cambridge University Press (numeric)",
    "cambridge-university-press-law-note": "Cambridge University Press - Law (note)",
    "cambridge-university-press-author-date-cambridge-a": "Cambridge University Press, CambridgeA (author-date)",
    "cambridge-university-press-author-date": "Cambridge University Press, CambridgeB (author-date)",
    "campus-adventiste-du-saleve-faculte-adventiste-de-theologie": "Campus adventiste du Salève - Faculté adventiste de théologie (Français)",
    "canadian-biosystems-engineering": "Canadian Biosystems Engineering",
    "canadian-geotechnical-journal": "Canadian Geotechnical Journal",
    "mcgill-en": "Canadian Guide to Uniform Legal Citation 10th edition (McGill Guide)",
    "canadian-journal-of-chemistry": "Canadian Journal of Chemistry",
    "canadian-journal-of-criminology-and-criminal-justice": "Canadian Journal of Criminology and Criminal Justice",
    "canadian-journal-of-dietetic-practice-and-research": "Canadian Journal of Dietetic Practice and Research",
    "canadian-journal-of-earth-sciences": "Canadian Journal of Earth Sciences",
    "canadian-journal-of-economics": "Canadian Journal of Economics",
    "canadian-journal-of-fisheries-and-aquatic-sciences": "Canadian Journal of Fisheries and Aquatic Sciences",
    "canadian-journal-of-mineralogy-and-petrology": "Canadian Journal of Mineralogy and Petrology",
    "canadian-journal-of-physics": "Canadian Journal of Physics",
    "canadian-journal-of-public-health": "Canadian Journal of Public Health",
    "canadian-journal-of-remote-sensing": "Canadian Journal of Remote Sensing",
    "canadian-journal-of-soil-science": "Canadian Journal of Soil Science",
    "canadian-public-policy": "Canadian Public Policy",
    "canadian-urological-association-journal": "Canadian Urological Association Journal",
    "cancer-biomarkers": "Cancer Biomarkers",
    "cancer-drug-resistance": "Cancer Drug Resistance",
    "cancer-translational-medicine": "Cancer Translational Medicine",
    "harvard-cape-peninsula-university-of-technology": "Cape Peninsula University of Technology (author-date/Harvard)",
    "cardiff-university-harvard": "Cardiff University (author-date/Harvard)",
    "cardiff-university-vancouver": "Cardiff University - NLM/Vancouver",
    "cardiocore": "Cardiocore (Español)",
    "cath-lab-digest": "Cath Lab Digest",
    "catholic-biblical-association": "Catholic Biblical Association (full note)",
    "cell": "Cell",
    "cell-research": "Cell Research",
    "cell-structure-and-function": "Cell Structure and Function",
    "cell-transplantation": "Cell Transplantation",
    "cell-numeric": "Cell journals (numeric)",
    "cellular-and-molecular-bioengineering": "Cellular and Molecular Bioengineering",
    "cellular-and-molecular-gastroenterology-and-hepatology": "Cellular and Molecular Gastroenterology and Hepatology",
    "centaurus": "Centaurus",
    "centre-de-recherche-sur-les-civilisations-de-l-asie-orientale": "Centre de recherche sur les civilisations de l'Asie orientale (Français - note)",
    "centre-de-recherche-sur-les-civilisations-de-l-asie-orientale-auteur-date": "Centre de recherche sur les civilisations de l’Asie orientale (Français - Auteur, Date)",
    "centro-regional-de-estudios-teologicos-de-aragon": "Centro Regional de Estudios Teológicos de Aragón (Español)",
    "changer-d-epoque": "Changer d'époque (Français)",
    "chemical-biology-and-drug-design": "Chemical Biology & Drug Design",
    "chemical-engineering-technology": "Chemical Engineering & Technology",
    "chemical-engineering-progress": "Chemical Engineering Progress",
    "chemical-and-pharmaceutical-bulletin": "Chemical and Pharmaceutical Bulletin",
    "chemie-ingenieur-technik": "Chemie Ingenieur Technik",
    "chemistry-education-research-and-practice": "Chemistry Education Research and Practice",
    "chest": "Chest",
    "chicago-author-date-16th-edition": "Chicago Manual of Style 16th edition (author-date)",
    "chicago-author-date-de": "Chicago Manual of Style 16th edition (author-date, Deutsch)",
    "chicago-author-date-basque": "Chicago Manual of Style 16th edition (author-date, Euskara)",
    "chicago-notes-bibliography-16th-edition": "Chicago Manual of Style 16th edition (notes and bibliography)",
    "chicago-shortened-notes-bibliography-16th-edition": "Chicago Manual of Style 16th edition (shortened notes and bibliography)",
    "chicago-author-date-17th-edition": "Chicago Manual of Style 17th edition (author-date)",
    "chicago-author-date-fr": "Chicago Manual of Style 17th edition (author-date, Français)",
    "chicago-notes-bibliography-17th-edition": "Chicago Manual of Style 17th edition (notes and bibliography)",
    "chicago-notes-bibliography-fr": "Chicago Manual of Style 17th edition (notes and bibliography, Français)",
    "chicago-notes-bibliography-subsequent-author-title-17th-edition": "Chicago Manual of Style 17th edition (notes and bibliography, subsequent author-title)",
    "chicago-notes-bibliography-subsequent-ibid-17th-edition": "Chicago Manual of Style 17th edition (notes and bibliography, subsequent ibid.)",
    "chicago-shortened-notes-bibliography-17th-edition": "Chicago Manual of Style 17th edition (shortened notes and bibliography)",
    "chicago-shortened-notes-bibliography-subsequent-author-title-17th-edition": "Chicago Manual of Style 17th edition (shortened notes and bibliography, subsequent author-title)",
    "chicago-shortened-notes-bibliography-subsequent-ibid-17th-edition": "Chicago Manual of Style 17th edition (shortened notes and bibliography, subsequent ibid.)",
    "chicago-author-date": "Chicago Manual of Style 18th edition (author-date)",
    "chicago-author-date-access-dates": "Chicago Manual of Style 18th edition (author-date, access dates)",
    "chicago-author-date-archive-place-first": "Chicago Manual of Style 18th edition (author-date, archival references with place first)",
    "chicago-author-date-archive-place-first-no-url": "Chicago Manual of Style 18th edition (author-date, archival references with place first, without URLs)",
    "chicago-author-date-classic": "Chicago Manual of Style 18th edition (author-date, classic variants)",
    "chicago-author-date-classic-no-url": "Chicago Manual of Style 18th edition (author-date, classic variants, without URLs)",
    "chicago-author-date-no-url": "Chicago Manual of Style 18th edition (author-date, without URLs)",
    "chicago-in-text-full": "Chicago Manual of Style 18th edition (in-text full citations)",
    "chicago-in-text-full-no-url": "Chicago Manual of Style 18th edition (in-text full citations, without URLs)",
    "chicago-in-text-shortened-author": "Chicago Manual of Style 18th edition (in-text shortened author-only citations)",
    "chicago-in-text-shortened-author-no-url": "Chicago Manual of Style 18th edition (in-text shortened author-only citations, without URLs)",
    "chicago-in-text-shortened-author-title": "Chicago Manual of Style 18th edition (in-text shortened author-title citations)",
    "chicago-in-text-shortened-author-title-no-url": "Chicago Manual of Style 18th edition (in-text shortened author-title citations, without URLs)",
    "chicago-notes-bibliography-annotated-abstract": "Chicago Manual of Style 18th edition (notes and annotated bibliography with abstract)",
    "chicago-notes-bibliography-annotated": "Chicago Manual of Style 18th edition (notes and annotated bibliography)",
    "chicago-notes-bibliography": "Chicago Manual of Style 18th edition (notes and bibliography)",
    "chicago-notes-bibliography-access-dates": "Chicago Manual of Style 18th edition (notes and bibliography, access dates)",
    "chicago-notes-bibliography-archive-place-first": "Chicago Manual of Style 18th edition (notes and bibliography, archival references with place first)",
    "chicago-notes-bibliography-archive-place-first-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, archival references with place first, without URLs)",
    "chicago-notes-bibliography-classic": "Chicago Manual of Style 18th edition (notes and bibliography, classic variants)",
    "chicago-notes-bibliography-classic-archive-place-first": "Chicago Manual of Style 18th edition (notes and bibliography, classic variants, archival references with place first)",
    "chicago-notes-bibliography-classic-archive-place-first-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, classic variants, archival references with place first, without URLs)",
    "chicago-notes-bibliography-classic-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, classic variants, without URLs)",
    "chicago-notes-bibliography-subsequent-author": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent author-only citations)",
    "chicago-notes-bibliography-subsequent-author-classic": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent author-only citations, classic variants)",
    "chicago-notes-bibliography-subsequent-author-classic-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent author-only citations, classic variants, without URLs)",
    "chicago-notes-bibliography-subsequent-author-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent author-only citations, without URLs)",
    "chicago-notes-bibliography-subsequent-ibid": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent ibid.)",
    "chicago-notes-bibliography-subsequent-ibid-classic": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent ibid., classic variants)",
    "chicago-notes-bibliography-subsequent-ibid-classic-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent ibid., classic variants, without URLs)",
    "chicago-notes-bibliography-subsequent-ibid-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent ibid., without URLs)",
    "chicago-notes-bibliography-subsequent-title": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent title-only citations)",
    "chicago-notes-bibliography-subsequent-title-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent title-only citations, without URLs)",
    "chicago-notes-bibliography-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, without URLs)",
    "chicago-notes": "Chicago Manual of Style 18th edition (notes without bibliography)",
    "chicago-notes-archive-place-first": "Chicago Manual of Style 18th edition (notes without bibliography, archival references with place first)",
    "chicago-notes-archive-place-first-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, archival references with place first, without URLs)",
    "chicago-notes-classic": "Chicago Manual of Style 18th edition (notes without bibliography, classic variants)",
    "chicago-notes-classic-archive-place-first": "Chicago Manual of Style 18th edition (notes without bibliography, classic variants, archival references with place first)",
    "chicago-notes-classic-archive-place-first-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, classic variants, archival references with place first, without URLs)",
    "chicago-notes-classic-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, classic variants, without URLs)",
    "chicago-notes-publisher-place": "Chicago Manual of Style 18th edition (notes without bibliography, place of publication substituted for publisher)",
    "chicago-notes-publisher-place-archive-place-first": "Chicago Manual of Style 18th edition (notes without bibliography, place of publication substituted for publisher, archival references with place first)",
    "chicago-notes-publisher-place-archive-place-first-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, place of publication substituted for publisher, archival references with place first, without URLs)",
    "chicago-notes-publisher-place-label-page-archive-place-first": "Chicago Manual of Style 18th edition (notes without bibliography, place of publication substituted for publisher, page abbreviations, archival references with place first)",
    "chicago-notes-publisher-place-label-page-archive-place-first-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, place of publication substituted for publisher, page abbreviations, archival references with place first, without URLs)",
    "chicago-notes-publisher-place-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, place of publication substituted for publisher, without URLs)",
    "chicago-notes-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, without URLs)",
    "chicago-shortened-notes-bibliography": "Chicago Manual of Style 18th edition (shortened notes and bibliography)",
    "chicago-shortened-notes-bibliography-access-dates": "Chicago Manual of Style 18th edition (shortened notes and bibliography, access dates)",
    "chicago-shortened-notes-bibliography-archive-place-first": "Chicago Manual of Style 18th edition (shortened notes and bibliography, archival references with place first)",
    "chicago-shortened-notes-bibliography-archive-place-first-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, archival references with place first, without URLs)",
    "chicago-shortened-notes-bibliography-classic": "Chicago Manual of Style 18th edition (shortened notes and bibliography, classic variants)",
    "chicago-shortened-notes-bibliography-classic-archive-place-first": "Chicago Manual of Style 18th edition (shortened notes and bibliography, classic variants, archival references with place first)",
    "chicago-shortened-notes-bibliography-classic-archive-place-first-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, classic variants, archival references with place first, without URLs)",
    "chicago-shortened-notes-bibliography-classic-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, classic variants, without URLs)",
    "chicago-shortened-notes-bibliography-subsequent-author": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent author-only citations)",
    "chicago-shortened-notes-bibliography-subsequent-author-classic": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent author-only citations, classic variants)",
    "chicago-shortened-notes-bibliography-subsequent-author-classic-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent author-only citations, classic variants, without URLs)",
    "chicago-shortened-notes-bibliography-subsequent-author-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent author-only citations, without URLs)",
    "chicago-shortened-notes-bibliography-subsequent-ibid": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent ibid.)",
    "chicago-shortened-notes-bibliography-subsequent-ibid-classic": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent ibid., classic variants)",
    "chicago-shortened-notes-bibliography-subsequent-ibid-classic-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent ibid., classic variants, without URLs)",
    "chicago-shortened-notes-bibliography-subsequent-ibid-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent ibid., without URLs)",
    "chicago-shortened-notes-bibliography-subsequent-title": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent title-only citations)",
    "chicago-shortened-notes-bibliography-subsequent-title-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent title-only citations, without URLs)",
    "chicago-shortened-notes-bibliography-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, without URLs)",
    "china-information": "China Information",
    "chinese-gb7714-1987-numeric": "China National Standard GB/T 7714-1987 (numeric, 中文)",
    "chinese-gb7714-2005-author-date": "China National Standard GB/T 7714-2005 (author-date, 中文)",
    "chinese-gb7714-2005-numeric": "China National Standard GB/T 7714-2005 (numeric, 中文)",
    "china-national-standard-gb-t-7714-2015-author-date": "China National Standard GB/T 7714-2015 (author-date, 中文)",
    "china-national-standard-gb-t-7714-2015-note": "China National Standard GB/T 7714-2015 (note, 中文)",
    "china-national-standard-gb-t-7714-2015-numeric": "China National Standard GB/T 7714-2015 (numeric, 中文)",
    "china-national-standard-gb-t-7714-2025-author-date": "China National Standard GB/T 7714-2025 (author-date, 中文)",
    "china-national-standard-gb-t-7714-2025-note": "China National Standard GB/T 7714-2025 (note, 中文)",
    "china-national-standard-gb-t-7714-2025-numeric": "China National Standard GB/T 7714-2025 (numeric, 中文)",
    "chinese-journal-of-aeronautics": "Chinese Journal of Aeronautics",
    "chinese-medical-journal": "Chinese Medical Journal",
    "chinese-science-bulletin": "Chinese Science Bulletin",
    "chroniques-des-activites-archeologiques-de-l-ecole-francaise-de-rome": "Chroniques des activités archéologiques de l'Ecole française de Rome",
    "chungara-revista-de-antropologia-chilena": "Chungara Revista de Antropología Chilena (Español - Chile)",
    "circulation-journal": "Circulation Journal",
    "cirugia-cardiovascular": "Cirugia Cardiovascular (Español)",
    "citation-compass-apa-note": "Citation Compass (Kildekompasset) - APA (note)",
    "harvard-cite-them-right-10th-edition": "Cite Them Right 10th edition (author-date/Harvard)",
    "harvard-cite-them-right-11th-edition": "Cite Them Right 11th edition (author-date/Harvard)",
    "harvard-cite-them-right": "Cite Them Right 12th edition (author-date/Harvard)",
    "harvard-cite-them-right-no-et-al": "Cite Them Right 12th edition (author-date/Harvard, no \"et al.\")",
    "citizen-science-theory-and-practice": "Citizen Science: Theory and Practice",
    "civil-engineering-journal": "Civil Engineering Journal",
    "civilta-italiana": "Civiltà Italiana (Italiano)",
    "civitas-revista-de-ciencias-sociais": "Civitas: Revista de Ciências Sociais",
    "cladistics": "Cladistics",
    "clay-minerals": "Clay Minerals",
    "clays-and-clay-minerals": "Clays and Clay Minerals",
    "climate-change-economics": "Climate Change Economics",
    "clinical-anatomy": "Clinical Anatomy",
    "clinical-dysmorphology": "Clinical Dysmorphology",
    "clinical-gastroenterology-and-hepatology": "Clinical Gastroenterology and Hepatology",
    "clinical-hemorheology-and-microcirculation": "Clinical Hemorheology and Microcirculation",
    "clinical-infectious-diseases": "Clinical Infectious Diseases",
    "clinical-journal-of-sport-medicine": "Clinical Journal of Sport Medicine",
    "clinical-journal-of-the-american-society-of-nephrology": "Clinical Journal of the American Society of Nephrology",
    "clinical-management-issues": "Clinical Management Issues",
    "clinical-nuclear-medicine": "Clinical Nuclear Medicine",
    "clinical-oral-implants-research": "Clinical Oral Implants Research",
    "clinical-orthopaedics-and-related-research": "Clinical Orthopaedics and Related Research",
    "clinical-otolaryngology": "Clinical Otolaryngology",
    "clinical-pharmacology-and-therapeutics": "Clinical Pharmacology & Therapeutics",
    "clinical-physiology-and-functional-imaging": "Clinical Physiology and Functional Imaging",
    "clinical-radiology": "Clinical Radiology",
    "clinical-spine-surgery": "Clinical Spine Surgery",
    "clio-medica": "Clio Medica",
    "clinica-e-investigacion-en-arteriosclerosis": "Clínica e Investigación en Arteriosclerosis (Español)",
    "cold-spring-harbor-laboratory-press": "Cold Spring Harbor Laboratory Press",
    "collection-de-l-ecole-francaise-de-rome-full-note": "Collection de l'Ecole française de Rome (full note, Français)",
    "collection-de-l-ecole-francaise-de-rome-note": "Collection de l'Ecole française de Rome (note, Français)",
    "collection-du-centre-jean-berard": "Collection du Centre Jean-Bérard (Français)",
    "collections-electroniques-de-l-inha-author-date": "Collections électroniques de l'INHA (author-date, Français)",
    "collections-electroniques-de-l-inha-full-note": "Collections électroniques de l'INHA (full note, Français)",
    "college-of-naturopathic-medicine": "College of Naturopathic Medicine",
    "college-montmorency": "Collège Montmorency (note, Français - Canada)",
    "colombian-journal-of-anesthesiology": "Colombian Journal of Anesthesiology",
    "colorado-state-university-school-of-biomedical-engineering": "Colorado State University - School of Biomedical Engineering",
    "comision-economica-para-america-latina-y-el-caribe": "Comisión Económica para América Latina y el Caribe (Español)",
    "common-market-law-review": "Common Market Law Review",
    "communication-et-langages": "Communication et Langages",
    "comparativ": "Comparativ",
    "comparative-parasitology": "Comparative Parasitology",
    "comparative-politics": "Comparative Politics",
    "comparative-population-studies": "Comparative Population Studies",
    "comptes-rendus-author-date": "Comptes Rendus (author-date)",
    "comptes-rendus-numeric": "Comptes Rendus (numeric)",
    "computer-supported-cooperative-work": "Computer Supported Cooperative Work",
    "computer-und-recht": "Computer und Recht (Deutsch)",
    "conservation-and-society": "Conservation & Society",
    "conservation-biology": "Conservation Biology",
    "conservation-letters": "Conservation Letters",
    "conservation-physiology": "Conservation Physiology",
    "constructivist-foundations": "Constructivist Foundations",
    "contemporary-accounting-research": "Contemporary Accounting Research",
    "continuity-and-change": "Continuity and Change",
    "contributions-to-the-archaeology-of-egypt-nubia-and-the-levant": "Contributions to the Archaeology of Egypt, Nubia and the Levant",
    "copeia": "Copeia",
    "copenhagen-university-legal-proper-attribution": "Copenhagen University Legal Proper Attribution (Dansk)",
    "copernicus-publications": "Copernicus Publications",
    "coral-reefs": "Coral Reefs",
    "cornea": "Cornea",
    "corrosion": "Corrosion",
    "harvard-coventry-university": "Coventry University (author-date/Harvard)",
    "harvard-cranfield-university": "Cranfield University (author-date/Harvard)",
    "cranfield-university-numeric": "Cranfield University (numeric)",
    "creativity-and-innovation-management": "Creativity and Innovation Management",
    "critical-care-medicine": "Critical Care Medicine",
    "critical-reviews-in-plant-sciences": "Critical Reviews in Plant Sciences",
    "critical-reviews-in-solid-state-and-materials-sciences": "Critical Reviews in Solid State and Materials Sciences",
    "cronache-di-archeologia": "Cronache di Archeologia (Italiano)",
    "crop-breeding-and-applied-biotechnology": "Crop Breeding and Applied Biotechnology",
    "crustaceana": "Crustaceana",
    "cuadernos-de-filologia-clasica": "Cuadernos de Filología Clásica. Estudios Griegos e Indoeuropeos (autor-año, Español)",
    "cultivos-tropicales": "Cultivos Tropicales (Español)",
    "cultural-studies-of-science-education": "Cultural Studies of Science Education",
    "culture-medicine-and-psychiatry": "Culture, Medicine, and Psychiatry",
    "cumhuriyet-universitesi-fen-bilimleri-enstitusu": "Cumhuriyet Üniversitesi - Fen Bilimleri Enstitüsü (Türkçe)",
    "cureus": "Cureus",
    "current-alzheimer-research": "Current Alzheimer Research",
    "current-gene-therapy": "Current Gene Therapy",
    "current-neurology-aktualnosci-neurologiczne": "Current Neurology - Aktualności Neurologiczne",
    "current-opinion-in-endocrinology-diabetes-and-obesity": "Current Opinion in Endocrinology, Diabetes and Obesity",
    "current-opinion": "Current Opinion journals",
    "current-organic-synthesis": "Current Organic Synthesis",
    "current-pharmaceutical-design": "Current Pharmaceutical Design",
    "current-proteomics": "Current Proteomics",
    "current-protocols": "Current Protocols journals",
    "current-science": "Current Science",
    "current-topics-in-medicinal-chemistry": "Current Topics in Medicinal Chemistry",
    "currents-in-biblical-research": "Currents in Biblical Research",
    "cybium": "Cybium",
    "cytometry": "Cytometry",
    "czech-journal-of-international-relations": "Czech Journal of International Relations",
    "din-1505-2-alphanumeric": "DIN 1505-2 (alphanumeric, Deutsch) - standard superseded by ISO-690",
    "din-1505-2": "DIN 1505-2 (author-date, Deutsch) - standard superseded by ISO-690",
    "din-1505-2-numeric": "DIN 1505-2 (numeric, Deutsch) - standard superseded by ISO-690",
    "din-1505-2-numeric-alphabetical": "DIN 1505-2 (numeric, sorted alphabetically, Deutsch) - standard superseded by ISO-690",
    "data-science-journal": "Data Science Journal",
    "database": "Database",
    "de-buck": "De Buck (Nederlands)",
    "degruyter-american-chemical-society": "De Gruyter - American Chemical Society",
    "harvard-deakin-university": "Deakin University (author-date/Harvard)",
    "decision-sciences": "Decision Sciences",
    "demographic-research": "Demographic Research",
    "dermatology-online-journal": "Dermatology Online Journal",
    "deutsche-gesellschaft-fur-psychologie": "Deutsche Gesellschaft für Psychologie 5. Auflage (Deutsch)",
    "deutsche-sprache": "Deutsche Sprache (Deutsch)",
    "deutsche-zeitschrift-fur-sportmedizin": "Deutsche Zeitschrift für Sportmedizin",
    "deutsches-archaologisches-institut": "Deutsches Archäologisches Institut",
    "deutsches-archaologisches-institut-romisch-germanische-kommission-author-date": "Deutsches Archäologisches Institut - Römisch-Germanische Kommission (author-date, Deutsch)",
    "deutsches-arzteblatt": "Deutsches Ärzteblatt",
    "developing-world-bioethics": "Developing World Bioethics",
    "development-policy-review": "Development Policy Review",
    "development-and-change": "Development and Change",
    "developmental-dynamics": "Developmental Dynamics",
    "developmental-medicine-and-child-neurology": "Developmental Medicine & Child Neurology",
    "developmental-neurobiology": "Developmental Neurobiology",
    "diabetologia": "Diabetologia",
    "diagnostico-prenatal": "Diagnóstico Prenatal (Español)",
    "dialisis-y-trasplante": "Dialisis y Trasplante (Español)",
    "diatom-research": "Diatom Research",
    "die-bachelorarbeit-samac-et-al-in-text": "Die Bachelorarbeit (Samac et al.) (in-text, Deutsch)",
    "die-bachelorarbeit-samac-et-al-note": "Die Bachelorarbeit (Samac et al.) (note, Deutsch)",
    "digestive-and-liver-disease": "Digestive and Liver Disease",
    "digital-humanities-im-deutschsprachigen-raum": "Digital Humanities im deutschsprachigen Raum (Deutsch)",
    "diplo": "Diplo",
    "disability-and-rehabilitation": "Disability and Rehabilitation",
    "discover-food": "Discover Food",
    "discovery-medicine": "Discovery Medicine",
    "documents-d-archeologie-francaise": "Documents d'archéologie française (Français)",
    "donau-universitat-krems-department-fur-e-governance-in-wirthschaft-und-verwaltung": "Donau-Universität Krems - Department für E-Governance in Wirtschaft und Verwaltung (Deutsch - Österreich)",
    "drug-development-research": "Drug Development Research",
    "drug-testing-and-analysis": "Drug Testing and Analysis",
    "drugs-of-today": "Drugs of Today",
    "duale-hochschule-baden-wurttemberg-department-of-international-business": "Duale Hochschule Baden-Württemberg - Department of International Business",
    "duale-hochschule-baden-wurttemberg-villingen-schwenningen-roter-grubert-mattern": "Duale Hochschule Baden-Württemberg Villingen-Schwenningen - Roter Grubert/Mattern (Deutsch)",
    "harvard-dundalk-institute-of-technology": "Dundalk Institute of Technology (author-date/Harvard)",
    "durban-university-of-technology-harvard": "Durban University of Technology (author-date/Harvard)",
    "harvard-durham-university-business-school": "Durham University Business School (author-date/Harvard)",
    "e3s-web-of-conferences": "E3S Web of Conferences",
    "em-normandie-business-school-harvard-english": "EM Normandie Business School (author-date/Harvard, English)",
    "embo-press": "EMBO Press",
    "embnet-journal": "EMBnet.journal",
    "ens-de-lyon-centre-d-ingenierie-documentaire": "ENS de Lyon - Centre d'ingénierie documentaire (Français)",
    "entecho": "ENTECHO (Čeština)",
    "etri-journal": "ETRI Journal",
    "eu-interinstitutional-style": "EU Interinstitutional Style (author-date)",
    "eunomia-revista-en-cultura-de-la-legalidad": "EUNOMÍA. Revista en Cultura de la Legalidad (Español)",
    "eva-berlin-konferenz": "EVA Berlin Konferenz (Deutsch)",
    "excli-journal": "EXCLI Journal",
    "ear-and-hearing": "Ear and Hearing",
    "early-christianity": "Early Christianity",
    "early-medieval-europe": "Early Medieval Europe",
    "earth-surface-processes-and-landforms": "Earth Surface Processes and Landforms",
    "earthquake-engineering-and-structural-dynamics": "Earthquake Engineering & Structural Dynamics",
    "earthquake-spectra": "Earthquake Spectra",
    "ecclesial-practices": "Ecclesial Practices",
    "ecological-entomology": "Ecological Entomology",
    "ecological-restoration": "Ecological Restoration",
    "ecology": "Ecology",
    "ecology-letters": "Ecology Letters",
    "ecology-and-society": "Ecology and Society",
    "ecology-of-freshwater-fish": "Ecology of Freshwater Fish",
    "econometrica": "Econometrica",
    "economic-commission-for-latin-america-and-the-caribbean": "Economic Commission for Latin America and the Caribbean",
    "economic-geology": "Economic Geology",
    "economia-y-politica": "Economía y Política (Español - Chile)",
    "ecosistemas": "Ecosistemas (Español)",
    "ecosystems": "Ecosystems",
    "harvard-edge-hill-university": "Edge Hill University (author-date/Harvard)",
    "edward-elgar-business-and-social-sciences": "Edward Elgar Publishing - Business and Social Sciences",
    "effective-altruism-wiki": "Effective Altruism Wiki",
    "egretta": "Egretta (Deutsch - Österreich)",
    "einaudi": "Einaudi (Italiano)",
    "eksploatacja-i-niezawodnosc": "Eksploatacja i Niezawodnosc - Maintenance and Reliability",
    "electrophoresis": "Electrophoresis",
    "elementa": "Elementa",
    "elsevier-harvard2": "Elsevier (author-date/Harvard, capitalized In)",
    "elsevier-harvard": "Elsevier (author-date/Harvard, with titles)",
    "elsevier-harvard-without-titles": "Elsevier (author-date/Harvard, without titles)",
    "elsevier-with-titles": "Elsevier (numeric, with titles)",
    "elsevier-with-titles-alphabetical": "Elsevier (numeric, with titles, sorted alphabetically)",
    "elsevier-without-titles": "Elsevier (numeric, without titles)",
    "elsevier-american-chemical-society": "Elsevier - American Chemical Society",
    "elsevier-vancouver": "Elsevier - NLM/Vancouver (citation-sequence)",
    "elsevier-vancouver-short-author-list": "Elsevier - NLM/Vancouver (citation-sequence, \"et al.\" for 3+ authors)",
    "elsevier-vancouver-no-et-al": "Elsevier - NLM/Vancouver (citation-sequence, no \"et al.\")",
    "elsevier-vancouver-author-date": "Elsevier - NLM/Vancouver (name-year)",
    "elsevier-vancouver-author-date-alphabetical": "Elsevier - NLM/Vancouver (name-year; sorted alphabetically)",
    "emerald-harvard": "Emerald (author-date/Harvard)",
    "emu-austral-ornithology": "Emu - Austral Ornithology",
    "endocrine-connections": "Endocrine Connections",
    "endocrine-journal": "Endocrine Journal",
    "endocrine-press": "Endocrine Press",
    "endoscopia": "Endoscopia (Español)",
    "energy-research-and-social-science": "Energy Research & Social Science",
    "enfances-familles-generations": "Enfances Familles Générations (Français)",
    "enfermeria-clinica": "Enfermería Clínica (Español)",
    "enfermeria-intensiva": "Enfermería Intensiva (Español)",
    "engineered-regeneration": "Engineered Regeneration",
    "engineering-in-life-sciences": "Engineering in Life Sciences",
    "engineering-technology-and-applied-science-research": "Engineering, Technology & Applied Science Research",
    "entomologia-experimentalis-et-applicata": "Entomologia Experimentalis et Applicata",
    "entomological-review": "Entomological Review",
    "entomological-society-of-america": "Entomological Society of America",
    "environment-and-planning": "Environment and Planning",
    "environment-and-urbanization": "Environment and Urbanization",
    "environmental-and-engineering-geoscience": "Environmental & Engineering Geoscience",
    "environmental-chemistry": "Environmental Chemistry",
    "environmental-conservation": "Environmental Conservation",
    "environmental-health-perspectives": "Environmental Health Perspectives",
    "environmental-microbiology": "Environmental Microbiology",
    "environmental-values": "Environmental Values",
    "environnement-risques-et-sante": "Environnement, Risques & Santé",
    "ephemerides-theologicae-lovanienses": "Ephemerides Theologicae Lovanienses",
    "epidemiology-and-infection": "Epidemiology & Infection",
    "epidemiology-psychiatric-sciences": "Epidemiology & Psychiatric Sciences",
    "epilepsia": "Epilepsia",
    "equine-veterinary-education": "Equine Veterinary Education",
    "equine-veterinary-journal": "Equine Veterinary Journal",
    "ergo": "Ergo",
    "errata": "Errata: Publicação sobre processos editoriais (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-eceme": "Escola de Comando e Estado-Maior do Exército - ABNT (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-instituto-meira-mattos": "Escola de Comando e Estado-Maior do Exército - Instituto Meira Mattos - ABNT (Português - Brasil)",
    "escuela-nacional-de-antropologia-e-historia-author-date": "Escuela Nacional de Antropología e Historia (autor-fecha, Español - México)",
    "escuela-nacional-de-antropologia-e-historia-full-note": "Escuela Nacional de Antropología e Historia (nota completa, Español - México)",
    "escuela-nacional-de-antropologia-e-historia-short-note": "Escuela Nacional de Antropología e Historia (nota corta, Español - México)",
    "estonian-journal-of-archaeology": "Estonian Journal of Archaeology",
    "estonian-journal-of-earth-sciences": "Estonian Journal of Earth Sciences",
    "estudios-hispanicos": "Estudios Hispánicos (Español)",
    "estudios-de-cultura-maya": "Estudios de Cultura Maya (Español - México)",
    "estudios-de-fonetica-experimental": "Estudios de Fonética Experimental",
    "ethics-book-reviews": "Ethics (for book reviews)",
    "ethnobiology-letters": "Ethnobiology Letters",
    "ethnobiology-and-conservation": "Ethnobiology and Conservation",
    "ethnologie-francaise": "Ethnologie française (Français)",
    "ethnomusicology": "Ethnomusicology",
    "eurasian-journal-of-medical-investigation": "Eurasian Journal of Medical Investigation",
    "eurasian-journal-of-medicine-and-oncology": "Eurasian Journal of Medicine and Oncology",
    "eurointervention": "EuroIntervention",
    "europace": "Europace",
    "harvard-european-archaeology": "European Archaeology (author-date/Harvard)",
    "european-cells-and-materials": "European Cells & Materials",
    "european-environment-agency": "European Environment Agency",
    "european-environment-agency-numeric": "European Environment Agency (numeric)",
    "european-journal-physical-medicine-and-rehabilitation": "European Journal Physical Medicine and Rehabilitation",
    "european-journal-for-philosophy-of-religion": "European Journal for Philosophy of Religion",
    "european-journal-of-anaesthesiology": "European Journal of Anaesthesiology",
    "european-journal-of-clinical-microbiology-and-infectious-diseases": "European Journal of Clinical Microbiology & Infectious Diseases",
    "european-journal-of-emergency-medicine": "European Journal of Emergency Medicine",
    "european-journal-of-endocrinology": "European Journal of Endocrinology",
    "european-journal-of-entomology": "European Journal of Entomology",
    "european-journal-of-human-genetics": "European Journal of Human Genetics",
    "european-journal-of-immunology": "European Journal of Immunology",
    "european-journal-of-information-systems": "European Journal of Information Systems",
    "european-journal-of-international-law": "European Journal of International Law",
    "european-journal-of-lipid-science-and-technology": "European Journal of Lipid Science and Technology",
    "european-journal-of-microbiology-and-immunology": "European Journal of Microbiology & Immunology",
    "european-journal-of-neuroscience": "European Journal of Neuroscience",
    "european-journal-of-ophthalmology": "European Journal of Ophthalmology",
    "european-journal-of-paediatric-neurology": "European Journal of Paediatric Neurology",
    "european-journal-of-pain": "European Journal of Pain",
    "european-journal-of-political-research": "European Journal of Political Research",
    "european-journal-of-public-health": "European Journal of Public Health",
    "european-journal-of-soil-science": "European Journal of Soil Science",
    "european-journal-of-taxonomy": "European Journal of Taxonomy",
    "european-journal-of-theology": "European Journal of Theology",
    "european-journal-of-ultrasound": "European Journal of Ultrasound (Ultraschall in der Medizin)",
    "european-journal-of-vascular-and-endovascular-surgery": "European Journal of Vascular and Endovascular Surgery",
    "european-respiratory-journal": "European Respiratory Journal",
    "european-retail-research": "European Retail Research",
    "european-review-of-agricultural-economics": "European Review of Agricultural Economics",
    "european-review-of-international-studies": "European Review of International Studies",
    "european-society-of-cardiology": "European Society of Cardiology",
    "european-union-interinstitutional-style-guide-author-date": "European Union - Interinstitutional Style Guide (author-date)",
    "european-union-interinstitutional-style-guide": "European Union - Interinstitutional Style Guide (note)",
    "evangelikus-hittudomanyi-egyetem": "Evangélikus Hittudományi Egyetem (Magyar)",
    "evidence-based-complementary-and-alternative-medicine": "Evidence-Based Complementary and Alternative Medicine",
    "evolution": "Evolution",
    "evolution-and-development": "Evolution & Development",
    "evolution-letters": "Evolution Letters",
    "evolutionary-anthropology": "Evolutionary Anthropology",
    "evolutionary-ecology-research": "Evolutionary Ecology Research",
    "experimental-biology-and-medicine": "Experimental Biology and Medicine",
    "experimental-biomedical-research": "Experimental Biomedical Research",
    "expert-reviews-in-molecular-medicine": "Expert Reviews in Molecular Medicine",
    "exploration-of-targeted-anti-tumor-therapy": "Exploration of Targeted Anti-tumor Therapy",
    "extracellular-vesicles-and-circulating-nucleic-acids": "Extracellular Vesicles and Circulating Nucleic Acids",
    "eye": "Eye",
    "facets": "FACETS",
    "fh-joanneum-institute-of-software-design-and-security": "FH JOANNEUM - Institute of Software Design and Security",
    "fold-and-r": "FOLD&R (Fasti On Line Documents & Research)",
    "fachhochschule-kiel-fachbereich-medien": "Fachhochschule Kiel - Fachbereich Medien (Deutsch)",
    "harvard-fachhochschule-salzburg": "Fachhochschule Salzburg (author-date/Harvard)",
    "fachhochschule-sudwestfalen": "Fachhochschule Südwestfalen (Deutsch)",
    "fachhochschule-vorarlberg-author-date": "Fachhochschule Vorarlberg (author-date)",
    "fachhochschule-vorarlberg-note": "Fachhochschule Vorarlberg (note)",
    "facial-plastic-surgery-clinics-of-north-america": "Facial Plastic Surgery Clinics of North America",
    "facolta-teologica-dell-italia-settentrionale-milano": "Facoltà Teologica dell'Italia Settentrionale - Milano (titoli di riviste non abbreviati, Italiano)",
    "harvard-falmouth-university": "Falmouth University (author-date/Harvard)",
    "family-business-review": "Family Business Review",
    "farmeconomia": "Farmeconomia. Health Economics and Therapeutic Pathways",
    "fatigue-and-fracture-of-engineering-materials-and-structures": "Fatigue & Fracture of Engineering Materials & Structures",
    "feminist-economics": "Feminist Economics",
    "feminist-theory": "Feminist Theory",
    "ferdinand-porsche-fernfh-betriebswirtschaft-und-wirtschaftspsychologie-dgps": "Ferdinand Porsche FERNFH - Betriebswirtschaft und Wirtschaftspsychologie - DGPS (Deutsch)",
    "ferdinand-porsche-fern-fachhochschule": "Ferdinand Porsche Fernfachhochschule (Deutsch - Österreich)",
    "fertility-and-sterility": "Fertility and Sterility",
    "finance-and-society": "Finance and Society",
    "finanzarchiv": "FinanzArchiv - Public Finance Analysis",
    "fine-focus": "Fine Focus",
    "firephyschem": "FirePhysChem",
    "first-break": "First Break",
    "first-monday": "First Monday",
    "fishery-bulletin": "Fishery Bulletin",
    "fizyoloji-medical-journal": "Fizyoloji Medical Journal",
    "flavour-and-fragrance-journal": "Flavour and Fragrance Journal",
    "florida-entomologist": "Florida Entomologist",
    "flux": "Flux (Français)",
    "focaal-journal-of-global-and-historical-anthropology": "Focaal—Journal of Global and Historical Anthropology",
    "folia-amazonica": "Folia Amazonica",
    "folia-biologica": "Folia Biologica",
    "folia-malacologica": "Folia Malacologica",
    "folia-morphologia": "Folia Morphologia",
    "food-science-and-biotechnology": "Food Science and Biotechnology",
    "food-and-agriculture-organization-of-the-united-nations": "Food and Agriculture Organization of the United Nations",
    "food-and-agriculture-organization-of-the-united-nations-numeric": "Food and Agriculture Organization of the United Nations (numeric)",
    "forensic-anthropology": "Forensic Anthropology",
    "forensic-science-review": "Forensic Science Review",
    "forest-science": "Forest Science",
    "forestry": "Forestry",
    "forschungsjournal-soziale-bewegungen-fjsb": "Forschungsjournal Soziale Bewegungen FJSB(German)",
    "forum-qualitative-social-research": "Forum: Qualitative Social Research (English)",
    "forum-qualitative-sozialforschung": "Forum: Qualitative Sozialforschung (Deutsch)",
    "french4": "France (auteurs et al., auteur-date, Français)",
    "french2": "France (auteurs et al., numérotation, Français)",
    "french3": "France (tous les auteurs, auteur-date, Français)",
    "french1": "France (tous les auteurs, numérotation, Français)",
    "frattura-ed-integrita-strutturale-fracture-and-structural-integrity": "Frattura ed Integrità Strutturale - Fracture and Structural Integrity",
    "free-radical-research": "Free Radical Research",
    "freie-hochschule-stuttgart": "Freie Hochschule Stuttgart (Deutsch)",
    "freie-universitat-berlin-geographische-wissenschaften": "Freie Universität Berlin - Geographische Wissenschaften (Deutsch)",
    "french-politics": "French Politics",
    "freshwater-biology": "Freshwater Biology",
    "freshwater-crayfish": "Freshwater Crayfish",
    "freshwater-science": "Freshwater Science",
    "friedrich-schiller-universitat-jena-medizinische-fakultat": "Friedrich-Schiller-Universität Jena - Medizinische Fakultät (Deutsch)",
    "frontiers-in-bioscience": "Frontiers in Bioscience",
    "frontiers-in-ecology-and-the-environment": "Frontiers in Ecology and the Environment",
    "frontiers-in-optics": "Frontiers in Optics",
    "frontiers-in-physics": "Frontiers in Physics",
    "frontiers": "Frontiers journals",
    "frontiers-medical-journals": "Frontiers medical journals",
    "fundamental-and-applied-limnology": "Fundamental and Applied Limnology",
    "future-medicine": "Future Medicine journals",
    "future-science-group": "Future Science Group",
    "g-giappichelli-editore": "G. Giappichelli Editore (Italiano)",
    "gaia": "GAIA",
    "gender-zeitschrift-fur-geschlecht-kultur-und-gesellschaft": "GENDER. Zeitschrift für Geschlecht, Kultur und Gesellschaft (Deutsch)",
    "gaceta-sanitaria": "Gaceta Sanitaria",
    "gait-and-posture": "Gait & Posture",
    "galatasaray-universitesi-sosyal-bilimler-enstitusu": "Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Türkçe)",
    "gallia": "Gallia (Français)",
    "gallia-prehistoire": "Gallia Préhistoire (Français)",
    "gastroenterology": "Gastroenterology",
    "gastrointestinal-endoscopy-clinics-of-north-america": "Gastrointestinal Endoscopy Clinics of North America",
    "gastrointestinal-intervention": "Gastrointestinal Intervention",
    "gayana": "Gayana",
    "gayana-botanica": "Gayana Botánica",
    "gazeta-medica": "Gazeta Médica",
    "geistes-und-kulturwissenschaften-heilmann": "Geistes- und Kulturwissenschaften (Heilmann) (Deutsch)",
    "gender-and-society": "Gender & Society",
    "generic-style-rules-for-linguistics": "Generic Style Rules for Linguistics",
    "genes-to-cells": "Genes to Cells",
    "genes-brain-and-behavior": "Genes, Brain and Behavior",
    "genetics-and-molecular-biology": "Genetics and Molecular Biology",
    "gengo-kenkyu-journal-of-the-linguistic-society-of-japan": "Gengo Kenkyu, Journal of the Linguistic Society of Japan",
    "genomics-and-informatics": "Genomics & Informatics",
    "geneses": "Genèses: Sciences sociales et histoire (Français)",
    "geoarchaeology": "Geoarchaeology",
    "geobiology": "Geobiology",
    "geochemical-perspectives-letters": "Geochemical Perspectives Letters",
    "geochimica-et-cosmochimica-acta": "Geochimica et Cosmochimica Acta",
    "geochronometria": "Geochronometria",
    "geografia-fisica-e-dinamica-quaternaria": "Geografia Fisica e Dinamica Quaternaria",
    "geografie-sbornik-cgs": "Geografie Sborník ČGS",
    "geographical-analysis": "Geographical Analysis",
    "geographische-zeitschrift": "Geographische Zeitschrift",
    "geological-magazine": "Geological Magazine",
    "geophysical-journal-international": "Geophysical Journal International",
    "geophysics": "Geophysics",
    "geopolitics": "Geopolitics",
    "georg-august-universitat-gottingen-institut-fur-ethnologie-und-ethnologische-sammlung": "Georg-August-Universität Göttingen - Institut für Ethnologie und Ethnologische Sammlung (Deutsch)",
    "geriatrics-and-gerontology-international": "Geriatrics & Gerontology International",
    "german-council-of-economic-experts": "German Council of Economic Experts",
    "german-journal-of-agricultural-economics": "German Journal of Agricultural Economics",
    "german-yearbook-of-international-law": "German Yearbook of International Law",
    "geschichte-und-gesellschaft": "Geschichte und Gesellschaft",
    "gesellschaft-fur-popularmusikforschung": "Gesellschaft fur Popularmusikforschung (Deutsch)",
    "harvard-gesellschaft-fur-bildung-und-forschung-in-europa": "Gesellschaft für Bildung und Forschung in Europa (author-date/Harvard, Deutsch)",
    "gewerblicher-rechtsschutz-und-urheberrecht": "Gewerblicher Rechtsschutz und Urheberrecht (Deutsch)",
    "gigascience": "GigaScience",
    "global-ecology-and-biogeography": "Global Ecology and Biogeography",
    "glossa": "Glossa",
    "gnosis-journal-of-gnostic-studies": "Gnosis: Journal of Gnostic Studies",
    "government-and-opposition": "Government and Opposition",
    "grasas-y-aceites": "Grasas y Aceites",
    "greek-and-roman-musical-studies": "Greek and Roman Musical Studies",
    "griffith-college-harvard": "Griffith College (author-date/Harvard)",
    "groundwater": "Groundwater",
    "groupe-danthropologie-et-darcheologie-funeraire": "Groupe d'anthropologie et d'archéologie funéraire (Français)",
    "guide-des-citations-references-et-abreviations-juridiques": "Guide des citations, références et abréviations juridiques 6e édition (Français)",
    "lluelles": "Guide des références pour la rédaction juridique 7e édition (Guide Lluelles, Français - Canada)",
    "lluelles-no-ibid": "Guide des références pour la rédaction juridique 7e édition (Notes complètes) (Guide Lluelles, no Ibid., Français - Canada)",
    "guide-pour-la-redaction-et-la-presentation-des-theses-a-lusage-des-doctorants": "Guide pour la rédaction et la présentation des thèses à l'usage des doctorants (Français)",
    "geographie-et-cultures": "Géographie et cultures (Français)",
    "geriatrie-et-psychologie-neuropsychiatrie-du-vieillissement": "Gériatrie et Psychologie Neuropsychiatrie du Vieillissement",
    "hand": "HAND",
    "hpb": "HPB",
    "haaga-helia-university-of-applied-sciences-harvard": "Haaga-Helia ammattikorkeakoulu (author-date/Harvard)",
    "haematologica": "Haematologica",
    "haemophilia": "Haemophilia",
    "haffner-style-manual": "Haffner Style Manual",
    "hainan-medical-university-journal-publisher": "Hainan Medical University Journal Publisher",
    "hamburg-school-of-food-science": "Hamburg School of Food Science (diploma, Deutsch)",
    "handbook-of-clinical-neurology": "Handbook of Clinical Neurology",
    "harvard-review-of-psychiatry": "Harvard Review of Psychiatry",
    "haute-ecole-pedagogique-fribourg": "Haute Ecole pédagogique Fribourg (Français)",
    "haute-ecole-de-gestion-de-geneve-iso-690": "Haute école de gestion de Genève (ISO 690)",
    "hawaii-international-conference-on-system-sciences-proceedings": "Hawaii International Conference on System Sciences Proceedings",
    "health-and-social-care-in-the-community": "Health & Social Care in the Community",
    "health-economics": "Health Economics",
    "health-economics-policy-and-law": "Health Economics, Policy and Law",
    "health-education-england-harvard": "Health Education England (author-date/Harvard)",
    "health-education-research": "Health Education Research",
    "health-physics": "Health Physics",
    "health-reform-observer-observatoire-des-reformes-de-sante": "Health Reform Observer - Observatoire des Réformes de Santé",
    "health-sciences-university-uco-school-of-osteopathy": "Health Sciences University - UCO School of Osteopathy",
    "health-and-human-rights-journal": "Health and Human Rights Journal",
    "health-sports-and-rehabilitation-medicine": "Health, Sports & Rehabilitation Medicine",
    "heart-failure-clinics": "Heart Failure Clinics",
    "heart-rhythm": "Heart Rhythm",
    "heidelberg-university-faculty-of-medicine": "Heidelberg University - Faculty of Medicine (Universität Heidelberg - Medizinische Fakultät Heidelberg)",
    "heiliger-dienst": "Heiliger Dienst (Deutsch)",
    "university-of-helsinki-faculty-of-theology": "Helsingin yliopisto - Teologinen tiedekunta (Suomi)",
    "helvetica-chimica-acta": "Helvetica Chimica Acta",
    "hematology-oncology-clinics-of-north-america": "Hematology/Oncology Clinics of North America",
    "hemijska-industrija": "Hemijska industrija",
    "henoch": "Henoch",
    "hepatology": "Hepatology",
    "heredity": "Heredity",
    "herpetologica": "Herpetologica",
    "hiob-ludolf-centre-for-ethiopian-studies": "Hiob Ludolf Centre for Ethiopian Studies",
    "hiob-ludolf-centre-for-ethiopian-studies-long-names": "Hiob Ludolf Centre for Ethiopian Studies (long names)",
    "hiob-ludolf-centre-for-ethiopian-studies-with-url-doi": "Hiob Ludolf Centre for Ethiopian Studies (with URL/DOI)",
    "hipertension-y-riesgo-vascular": "Hipertensión y Riesgo Vascular (Español)",
    "histoire-et-mesure": "Histoire & Mesure (Français)",
    "histoire-at-politique": "Histoire@Politique. Politique, culture, société (Français)",
    "histopathology": "Histopathology",
    "historical-materialism": "Historical Materialism",
    "history-and-theory": "History and Theory",
    "history-of-the-human-sciences": "History of the Human Sciences",
    "hochschule-bonn-rhein-sieg": "Hochschule Bonn-Rhein-Sieg - Fachbereich Wirtschaftswissenschaften (Harvard, Deutsch)",
    "hochschule-hannover-soziale-arbeit": "Hochschule Hannover - Soziale Arbeit (Deutsch)",
    "hochschule-munchen-fakultat-fur-angewandte-sozialwissenschaften": "Hochschule München - Fakultät für Angewandte Sozialwissenschaften (Deutsch)",
    "hochschule-osnabruck-fakultat-agrarwissenschaften-und-landschaftsarchitektur": "Hochschule Osnabrück - Fakultät Agrarwissenschaften und Landschaftsarchitektur (Deutsch)",
    "hochschule-pforzheim-fakultat-fur-wirtschaft-und-recht": "Hochschule Pforzheim - Fakultät für Wirtschaft und Recht (Deutsch)",
    "hochschule-rheinmain-wiesbaden-business-school-gesundheitsokonomie": "Hochschule RheinMain - Wiesbaden Business School - Gesundheitsökonomie (Deutsch)",
    "hochschule-der-kunste-bern-musikforschung": "Hochschule der Künste Bern - Musikforschung",
    "stuttgart-media-university": "Hochschule der Medien Stuttgart (Deutsch)",
    "hochschule-fur-soziale-arbeit-fhnw": "Hochschule für Soziale Arbeit FHNW (Deutsch - Schweiz)",
    "hochschule-fur-wirtschaft-und-recht-berlin": "Hochschule für Wirtschaft und Recht Berlin (Deutsch)",
    "homeopathy-thieme": "Homeopathy Thieme",
    "hong-kong-journal-of-radiology": "Hong Kong Journal of Radiology",
    "hospital-a-domicilio": "Hospital a Domicilio",
    "housing-studies": "Housing Studies",
    "howard-hughes-medical-institute": "Howard Hughes Medical Institute",
    "hue-university-of-medicine-and-pharmacy": "Hue University of Medicine and Pharmacy",
    "human-brain-mapping": "Human Brain Mapping",
    "human-ecology": "Human Ecology",
    "human-molecular-genetics": "Human Molecular Genetics",
    "human-mutation": "Human Mutation",
    "human-reproduction": "Human Reproduction",
    "human-reproduction-update": "Human Reproduction Update",
    "human-resource-management-journal": "Human Resource Management Journal",
    "human-rights-law-review": "Human Rights Law Review",
    "human-wildlife-interactions": "Human-Wildlife Interactions",
    "humboldt-state-university-environmental-resources-engineering": "Humboldt State University - Environmental Resources Engineering",
    "hydrobiologia": "Hydrobiologia",
    "hydrological-processes": "Hydrological Processes",
    "hydrological-sciences-journal": "Hydrological Sciences Journal",
    "hypertension-research": "Hypertension Research",
    "hypotheses-in-the-life-sciences": "Hypotheses in the Life Sciences",
    "hystrix-the-italian-journal-of-mammalogy": "Hystrix, the Italian Journal of Mammalogy",
    "ib-tauris-note": "I.B. Tauris (note)",
    "iainutuban": "IAINU Tuban (Bahasa Indonesia)",
    "iawa-journal": "IAWA Journal",
    "ie-comunicaciones": "IE Comunicaciones",
    "ieee": "IEEE Reference Guide version 11.29.2023",
    "ieee-transactions-on-medical-imaging": "IEEE Transactions on Medical Imaging",
    "iica-catie": "IICA-CATIE (Español)",
    "incontext-studies-in-translation-and-interculturalism": "INContext: Studies in Translation and Interculturalism",
    "indiana": "INDIANA",
    "instap-academic-press": "INSTAP Academic Press",
    "inter-ro": "INTER: Romanian Review for Theological and Religious Studies",
    "ios-press-books": "IOS Press (books)",
    "ipag-business-school-apa": "IPAG Business School - APA",
    "iso690-author-date-cat": "ISO-690 (author-date, Catalan)",
    "iso690-author-date-de": "ISO-690 (author-date, Deutsch)",
    "iso690-author-date-en": "ISO-690 (author-date, English)",
    "iso690-author-date-es": "ISO-690 (author-date, Español)",
    "iso690-author-date-fr": "ISO-690 (author-date, Français)",
    "iso690-author-date-pt-br": "ISO-690 (author-date, Português - Brasil)",
    "iso690-author-date-sk": "ISO-690 (author-date, Slovenčina)",
    "iso690-author-date-fr-no-abstract": "ISO-690 (author-date, no abstract, Français)",
    "iso690-author-date-cs": "ISO-690 (author-date, Čeština)",
    "iso690-full-note-en": "ISO-690 (full note, English)",
    "iso690-full-note-es": "ISO-690 (full note, Español)",
    "iso690-full-note-sk": "ISO-690 (full note, Slovenčina)",
    "iso690-full-note-with-ibid-ro": "ISO-690 (full note, with Ibid., Română)",
    "iso690-full-note-cs": "ISO-690 (full note, Čeština)",
    "iso690-note-fr": "ISO-690 (note, no abstract, Français)",
    "iso690-note-cs": "ISO-690 (note, without bibliography, Čeština)",
    "iso690-numeric-cat": "ISO-690 (numeric, Catalan)",
    "iso690-numeric-en": "ISO-690 (numeric, English)",
    "iso690-numeric-fr": "ISO-690 (numeric, Français)",
    "iso690-numeric-lt": "ISO-690 (numeric, Lietuvių kalba)",
    "iso690-numeric-sk": "ISO-690 (numeric, Slovenčina)",
    "iso690-numeric-brackets-cs": "ISO-690 (numeric, brackets, Čeština)",
    "iso690-numeric-cs": "ISO-690 (numeric, parentheses, Čeština)",
    "iubmb-life": "IUBMB Life",
    "ibis": "Ibis",
    "idojaras-quarterly-journal-of-the-hungarian-meteorological-service": "Időjárás - Quarterly Journal of the Hungarian Meteorological Service",
    "igaku-toshokan": "Igaku Toshokan (日本語)",
    "ilahiyat-studies": "Ilahiyat Studies (full note)",
    "im-gesprach": "Im Gespräch - Hefte der Martin Buber-Gesellschaft (Deutsch)",
    "imperial-college-london-author-date": "Imperial College London (author-date/Harvard)",
    "imperial-college-london-numerical": "Imperial College London (numerical/Vancouver)",
    "invisu": "InVisu",
    "indian-dermatology-online-journal": "Indian Dermatology Online Journal",
    "indian-journal-of-agricultural-sciences": "Indian Journal of Agricultural Sciences",
    "indian-journal-of-medical-research": "Indian Journal of Medical Research",
    "indian-journal-of-orthopaedics": "Indian Journal of Orthopaedics",
    "indian-journal-of-physics": "Indian Journal of Physics",
    "indian-journal-of-traditional-knowledge": "Indian Journal of Traditional Knowledge",
    "indian-journal-of-veterinary-and-animal-sciences-research": "Indian Journal of Veterinary and Animal Sciences Research",
    "indoor-air": "Indoor Air",
    "infectio": "Infectio (Español)",
    "infectious-disease-clinics-of-north-america": "Infectious Disease Clinics of North America",
    "inflammatory-bowel-diseases": "Inflammatory Bowel Diseases",
    "influenza-and-other-respiratory-viruses": "Influenza and Other Respiratory Viruses",
    "infomin": "Infomin",
    "informal-logic": "Informal Logic",
    "informationswissenschaft-theorie-methode-praxis": "Informationswissenschaft: Theorie, Methode und Praxis / Sciences de l’information: théorie, méthode et pratique",
    "ingenieria-agricola": "Ingeniería Agrícola (Español)",
    "innovations-therapeutiques-en-oncologie": "Innovations & Thérapeutiques en Oncologie",
    "institut-pertanian-bogor": "Institut Pertanian Bogor: Pedoman Penulisan Karya Ilmiah Edisi ke-3 (Bahasa Indonesia)",
    "institut-teknologi-bandung-sekolah-pascasarjana": "Institut Teknologi Bandung - Sekolah Pascasarjana",
    "institut-francais-darcheologie-orientale-arab-studies": "Institut français d'archéologie orientale - Arab Studies (English)",
    "institut-francais-darcheologie-orientale-en": "Institut français d'archéologie orientale - Egyptology (English)",
    "institut-francais-darcheologie-orientale": "Institut français d'archéologie orientale - archéologie et égyptologie (Français)",
    "institut-francais-darcheologie-orientale-etudes-arabes": "Institut français d'archéologie orientale - études arabes (Français)",
    "institut-fur-geschichte-des-landlichen-raums": "Institut für Geschichte des ländlichen Raums (Deutsch)",
    "harvard-institut-fur-praxisforschung-de": "Institut für Praxisforschung (author-date/Harvard, Bahr & Frackmann) (Deutsch)",
    "institut-national-de-la-recherche-scientifique-sciences-sociales": "Institut national de la recherche scientifique - Sciences sociales (author-date, Français)",
    "institut-national-de-recherches-archeologiques-preventives": "Institut national de recherches archéologiques préventives (Français)",
    "institut-national-de-sante-publique-du-quebec-napp": "Institut national de santé publique du Québec - NAPP (Français - Canada)",
    "institut-national-de-sante-publique-du-quebec-topo": "Institut national de santé publique du Québec - TOPO (Français - Canada)",
    "institute-for-operations-research-and-the-management-sciences": "Institute for Operations Research and the Management Sciences",
    "institute-of-mathematical-statistics": "Institute of Mathematical Statistics journals",
    "institute-of-mathematics-and-its-applications": "Institute of Mathematics and its Applications",
    "institute-of-physics-harvard": "Institute of Physics (author-date/Harvard)",
    "institute-of-physics-numeric": "Institute of Physics (numeric)",
    "instituto-brasileiro-de-informacao-em-ciencia-e-tecnologia-abnt-initials": "Instituto Brasileiro de Informação em Ciência e Tecnologia - ABNT (autoria abreviada)",
    "instituto-brasileiro-de-informacao-em-ciencia-e-tecnologia-abnt": "Instituto Brasileiro de Informação em Ciência e Tecnologia - ABNT (autoria completa)",
    "instituto-superior-de-teologia-de-las-islas-canarias": "Instituto Superior de Teología de las Islas Canarias (Español)",
    "instituto-universitario-militar": "Instituto Universitário Militar",
    "instituto-de-investigaciones-sobre-la-universidad-y-la-educacion-moderno": "Instituto de Investigaciones sobre la Universidad y la Educación - Moderno (autor-fecha, Español)",
    "associacao-brasileira-de-normas-tecnicas-ipea": "Instituto de Pesquisa Econômica Aplicada - ABNT (Português - Brasil)",
    "instituto-de-pesquisas-energeticas-e-nucleares": "Instituto de Pesquisas Energéticas e Nucleares (Português - Brasil)",
    "instituto-de-pesquisas-tecnologicas": "Instituto de Pesquisas Tecnológicas (Português - Brasil)",
    "instrumenta-patristica-et-mediaevalia": "Instrumenta Patristica et Mediaevalia",
    "integrated-science-publishing-journals": "Integrated Science Publishing journals",
    "integrative-and-comparative-biology": "Integrative & Comparative Biology",
    "intellect-newgen-books": "Intellect Newgen Books",
    "inter-research-science-center": "Inter-Research Science Center",
    "interaction-design-and-architectures": "Interaction Design & Architecture(s)",
    "interactive-cardiovascular-and-thoracic-surgery": "Interactive CardioVascular and Thoracic Surgery",
    "interdisziplinare-anthropologie": "Interdisziplinäre Anthropologie (Deutsch)",
    "interdisziplinare-zeitschrift-fur-technologie-und-lernen": "Interdisziplinäre Zeitschrift für Technologie und Lernen (Deutsch)",
    "interkulturelle-germanistik-gottingen": "Interkulturelle Germanistik Göttingen (Deutsch)",
    "international-affairs": "International Affairs",
    "international-atomic-energy-agency": "International Atomic Energy Agency",
    "international-biodeterioration-and-biodegradation": "International Biodeterioration & Biodegradation",
    "international-brazilian-journal-of-urology": "International Brazilian Journal Of Urology",
    "international-conference-on-information-systems-development": "International Conference on Information Systems Development",
    "international-development-policy": "International Development Policy",
    "international-energy-agency-organisation-for-economic-co-operation-and-development": "International Energy Agency - Organisation for Economic Co-operation and Development",
    "international-islamic-university-malaysia-ahmad-ibrahim-kulliyyah-of-laws": "International Islamic University Malaysia - Ahmad Ibrahim Kulliyyah of Laws",
    "international-journal-for-numerical-methods-in-biomedical-engineering": "International Journal for Numerical Methods in Biomedical Engineering",
    "international-journal-of-audiology": "International Journal of Audiology",
    "international-journal-of-automotive-technology": "International Journal of Automotive Technology",
    "international-journal-of-cancer": "International Journal of Cancer",
    "international-journal-of-circuit-theory-and-applications": "International Journal of Circuit Theory and Applications",
    "international-journal-of-climatology": "International Journal of Climatology",
    "international-journal-of-clinical-research": "International Journal of Clinical Research",
    "international-journal-of-cosmetic-science": "International Journal of Cosmetic Science",
    "international-journal-of-electrochemical-science": "International Journal of Electrochemical Science",
    "international-journal-of-electronic-commerce": "International Journal of Electronic Commerce",
    "international-journal-of-epidemiology": "International Journal of Epidemiology",
    "international-journal-of-exercise-science": "International Journal of Exercise Science",
    "international-journal-of-food-science-and-technology": "International Journal of Food Science & Technology",
    "international-journal-of-geriatric-psychiatry": "International Journal of Geriatric Psychiatry",
    "international-journal-of-humanoid-robotics": "International Journal of Humanoid Robotics",
    "international-journal-of-language-and-communication-disorders": "International Journal of Language & Communication Disorders",
    "international-journal-of-management-reviews": "International Journal of Management Reviews",
    "international-journal-of-nuclear-security": "International Journal of Nuclear Security",
    "international-journal-of-obstetric-anesthesia": "International Journal of Obstetric Anesthesia",
    "international-journal-of-occupational-medicine-and-environmental-health": "International Journal of Occupational Medicine and Environmental Health",
    "international-journal-of-oral-and-maxillofacial-surgery": "International Journal of Oral and Maxillofacial Surgery",
    "international-journal-of-osteoarchaeology": "International Journal of Osteoarchaeology",
    "international-journal-of-plant-sciences": "International Journal of Plant Sciences",
    "international-journal-of-polymer-analysis-and-characterization": "International Journal of Polymer Analysis and Characterization",
    "international-journal-of-polymeric-materials-and-polymeric-biomaterials": "International Journal of Polymeric Materials and Polymeric Biomaterials",
    "international-journal-of-population-data-science": "International Journal of Population Data Science",
    "international-journal-of-quantum-chemistry": "International Journal of Quantum Chemistry",
    "international-journal-of-radiation-oncology-biology-physics": "International Journal of Radiation Oncology, Biology, Physics",
    "international-journal-of-research-in-exercise-physiology": "International Journal of Research in Exercise Physiology",
    "international-journal-of-simulation-modelling": "International Journal of Simulation Modelling",
    "international-journal-of-spatial-data-infrastructures-research": "International Journal of Spatial Data Infrastructures Research",
    "international-journal-of-sports-medicine": "International Journal of Sport Medicine",
    "international-journal-of-urban-and-regional-research": "International Journal of Urban and Regional Research",
    "international-journal-of-wildland-fire": "International Journal of Wildland Fire",
    "international-microbiology": "International Microbiology",
    "international-organization": "International Organization",
    "international-pig-veterinary-society-congress-proceedings": "International Pig Veterinary Society Congress Proceedings",
    "international-relations": "International Relations",
    "international-review-of-the-red-cross": "International Review of the Red Cross",
    "international-security": "International Security",
    "international-studies-association": "International Studies Association",
    "international-union-of-crystallography": "International Union of Crystallography journals",
    "international-union-of-forest-research-organizations-headquarters": "International Union of Forest Research Organizations - Headquarters",
    "internet-archaeology": "Internet Archaeology",
    "interpreting": "Interpreting",
    "inventaire-general-du-patrimoine-culturel-iso-690-full-note": "Inventaire général du patrimoine culturel - ISO-690 (full note, Français)",
    "inventaire-general-du-patrimoine-culturel-iso-690-full-note-with-ibid": "Inventaire général du patrimoine culturel - ISO-690 (full note, with Ibid., Français)",
    "inventaire-general-du-patrimoine-culturel-iso-690-note": "Inventaire général du patrimoine culturel - ISO-690 (note, Français)",
    "invertebrate-biology": "Invertebrate Biology",
    "investigative-radiology": "Investigative Radiology",
    "iran-manual-of-style": "Iran Manual of Style - شیوه‌نامه ایران (فارسی)",
    "iranian-journal-of-basic-medical-sciences": "Iranian Journal of Basic Medical Sciences",
    "iranian-journal-of-pharmaceutical-research": "Iranian Journal of Pharmaceutical Research",
    "irish-historical-studies": "Irish Historical Studies",
    "isabella-stewart-gardner-museum": "Isabella Stewart Gardner Museum",
    "isara-iso-690": "Isara - ISO-690 (auteur-date, français)",
    "israel-medical-association-journal": "Israel Medical Association Journal",
    "istanus-journal-on-applied-and-biological-sciences": "Istanus Journal on Applied and Biological Sciences",
    "italian-journal-of-agronomy": "Italian Journal of Agronomy",
    "italus-hortus": "Italus Hortus",
    "ithaque": "Ithaque (Français - Canada)",
    "ius-ecclesiae": "Ius Ecclesiae",
    "jacc-cardiovascular-imaging": "JACC: Cardiovascular Imaging",
    "jacc-cardiovascular-interventions": "JACC: Cardiovascular Interventions",
    "jbi-evidence-synthesis": "JBI Evidence Synthesis",
    "jcom-journal-of-science-communication": "JCOM: Journal of Science Communication",
    "jahrbuch-der-osterreichischen-byzantinischen-gesellschaft": "Jahrbuch der Österreichischen Byzantinischen Gesellschaft",
    "jahrbuch-fur-evangelikale-theologie": "Jahrbuch für evangelikale Theologie (Deutsch)",
    "japanese-journal-of-applied-physics": "Japanese Journal of Applied Physics",
    "javnost-the-public": "Javnost - The Public",
    "john-benjamins-publishing-company-iconicity-in-language-and-literature": "John Benjamins Publishing Company - Iconicity in Language and Literature",
    "john-benjamins-publishing-company-linguistik-aktuell-linguistics-today": "John Benjamins Publishing Company - Linguistik Aktuell/Linguistics Today",
    "johnson-matthey-technology-review": "Johnson Matthey Technology Review",
    "journal-of-magnetic-resonance-imaging": "Journal Of Magnetic Resonance Imaging",
    "journal-and-proceedings-of-the-royal-society-of-new-south-wales": "Journal and Proceedings of the Royal Society of New South Wales",
    "journal-de-la-societe-des-oceanistes": "Journal de la Société des Océanistes",
    "journal-de-la-societe-des-americanistes": "Journal de la Société des américanistes",
    "journal-der-deutschen-dermatologischen-gesellschaft": "Journal der Deutschen Dermatologischen Gesellschaft",
    "journal-for-veterinary-medicine-biotechnology-and-biosafety": "Journal for Veterinary Medicine, Biotechnology and Biosafety",
    "journal-for-the-history-of-astronomy": "Journal for the History of Astronomy",
    "journal-for-the-study-of-the-new-testament": "Journal for the Study of the New Testament",
    "journal-fur-kulturpflanzen-journal-of-cultivated-plants": "Journal für Kulturpflanzen - Journal of Cultivated Plants",
    "journal-fur-kunstgeschichte": "Journal für Kunstgeschichte",
    "journal-fur-medienlinguistik": "Journal für Medienlinguistik (Deutsch)",
    "journal-of-aoac-international": "Journal of AOAC International",
    "journal-of-accounting-research": "Journal of Accounting Research",
    "journal-of-acoustics": "Journal of Acoustics",
    "journal-of-adolescent-health": "Journal of Adolescent Health",
    "journal-of-advanced-ceramics": "Journal of Advanced Ceramics",
    "journal-of-applied-engineering-sciences-technology": "Journal of Advanced Engineering & Science Technology",
    "journal-of-advertising-research": "Journal of Advertising Research",
    "journal-of-agricultural-and-applied-economics": "Journal of Agricultural and Applied Economics",
    "journal-of-agricultural-and-resource-economics": "Journal of Agricultural and Resource Economics",
    "journal-of-alzheimers-disease": "Journal of Alzheimer's Disease",
    "journal-of-anatomy": "Journal of Anatomy",
    "journal-of-animal-physiology-and-animal-nutrition": "Journal of Animal Physiology and Animal Nutrition",
    "journal-of-animal-science": "Journal of Animal Science",
    "journal-of-animal-and-feed-sciences": "Journal of Animal and Feed Sciences",
    "journal-of-antimicrobial-chemotherapy": "Journal of Antimicrobial Chemotherapy",
    "journal-of-applied-animal-science": "Journal of Applied Animal Science",
    "journal-of-applied-clinical-medical-physics": "Journal of Applied Clinical Medical Physics",
    "journal-of-applied-entomology": "Journal of Applied Entomology",
    "journal-of-applied-glycoscience": "Journal of Applied Glycoscience",
    "journal-of-applied-pharmaceutical-research": "Journal of Applied Pharmaceutical Research",
    "journal-of-applied-philosophy": "Journal of Applied Philosophy",
    "journal-of-applied-polymer-science": "Journal of Applied Polymer Science",
    "journal-of-archaeological-research": "Journal of Archaeological Research",
    "journal-of-atrial-fibrillation": "Journal of Atrial Fibrillation",
    "journal-of-australian-strength-and-conditioning": "Journal of Australian Strength & Conditioning",
    "journal-of-avian-biology": "Journal of Avian Biology",
    "journal-of-basic-microbiology": "Journal of Basic Microbiology",
    "journal-of-behavioral-health-and-psychology": "Journal of Behavioral Health and Psychology",
    "journal-of-biological-regulators-and-homeostatic-agents": "Journal of Biological Regulators & Homeostatic Agents",
    "journal-of-biomedical-materials-research-part-a": "Journal of Biomedical Materials Research Part A",
    "journal-of-bioscience-and-bioengineering": "Journal of Bioscience and Bioengineering",
    "journal-of-biosciences": "Journal of Biosciences",
    "journal-of-bone-and-mineral-research": "Journal of Bone and Mineral Research",
    "journal-of-brachial-plexus-and-peripheral-nerve-injury": "Journal of Brachial Plexus and Peripheral Nerve Injury",
    "journal-of-breast-cancer": "Journal of Breast Cancer",
    "journal-of-burn-care-and-research": "Journal of Burn Care & Research",
    "journal-of-business-logistics": "Journal of Business Logistics",
    "journal-of-cachexia-sarcopenia-and-muscle": "Journal of Cachexia, Sarcopenia and Muscle",
    "journal-of-cardiothoracic-and-vascular-anesthesia": "Journal of Cardiothoracic and Vascular Anesthesia",
    "journal-of-cellular-biochemistry": "Journal of Cellular Biochemistry",
    "journal-of-cellular-and-molecular-medicine": "Journal of Cellular and Molecular Medicine",
    "journal-of-chemistry-and-chemical-engineering": "Journal of Chemistry and Chemical Engineering",
    "journal-of-chemometrics": "Journal of Chemometrics",
    "journal-of-clinical-neurology": "Journal of Clinical Neurology",
    "journal-of-clinical-neurophysiology": "Journal of Clinical Neurophysiology",
    "journal-of-clinical-oncology": "Journal of Clinical Oncology",
    "journal-of-clinical-rheumatology": "Journal of Clinical Rheumatology",
    "journal-of-clinical-sleep-medicine": "Journal of Clinical Sleep Medicine",
    "journal-of-clinical-and-translational-science": "Journal of Clinical and Translational Science",
    "journal-of-combinatorics": "Journal of Combinatorics",
    "journal-of-common-market-studies": "Journal of Common Market Studies",
    "journal-of-comparative-pathology": "Journal of Comparative Pathology",
    "journal-of-computational-chemistry": "Journal of Computational Chemistry",
    "journal-of-computer-applications-in-archaeology": "Journal of Computer Applications in Archaeology",
    "journal-of-computer-assisted-tomography": "Journal of Computer Assisted Tomography",
    "journal-of-computer-information-systems": "Journal of Computer Information Systems",
    "journal-of-conchology": "Journal of Conchology",
    "journal-of-consumer-research": "Journal of Consumer Research",
    "journal-of-contemporary-medicine": "Journal of Contemporary Medicine",
    "journal-of-contemporary-water-research-and-education": "Journal of Contemporary Water Research and Education",
    "journal-of-crohns-and-colitis": "Journal of Crohn's and Colitis",
    "journal-of-crohns-and-colitis-supplements": "Journal of Crohn's and Colitis Supplements",
    "journal-of-dairy-research": "Journal of Dairy Research",
    "journal-of-dairy-science": "Journal of Dairy Science",
    "journal-of-demographic-economics": "Journal of Demographic Economics",
    "journal-of-dental-research": "Journal of Dental Research",
    "journal-of-dental-traumatology": "Journal of Dental Traumatology",
    "journal-of-early-christian-studies": "Journal of Early Christian Studies",
    "journal-of-economic-impact": "Journal of Economic Impact",
    "journal-of-egyptian-history": "Journal of Egyptian History",
    "journal-of-elections-public-opinion-and-parties": "Journal of Elections, Public Opinion & Parties",
    "journal-of-emerging-investigators": "Journal of Emerging Investigators",
    "journal-of-endodontics": "Journal of Endodontics",
    "journal-of-environmental-science-and-health-part-b": "Journal of Environmental Science and Health, Part B",
    "journal-of-ethnobiology": "Journal of Ethnobiology",
    "journal-of-european-public-policy": "Journal of European Public Policy",
    "journal-of-evolution-and-health": "Journal of Evolution and Health",
    "journal-of-evolutionary-biology": "Journal of Evolutionary Biology",
    "journal-of-experimental-botany": "Journal of Experimental Botany",
    "journal-of-field-ornithology": "Journal of Field Ornithology",
    "journal-of-finance": "Journal of Finance",
    "journal-of-financial-and-quantitative-analysis": "Journal of Financial and Quantitative Analysis",
    "journal-of-fish-biology": "Journal of Fish Biology",
    "journal-of-food-protection": "Journal of Food Protection",
    "journal-of-foraminiferal-research": "Journal of Foraminiferal Research",
    "journal-of-forensic-sciences": "Journal of Forensic Sciences",
    "journal-of-frailty-and-aging": "Journal of Frailty & Aging",
    "journal-of-geriatric-psychiatry-and-neurology": "Journal of Geriatric Psychiatry and Neurology",
    "journal-of-glaciology": "Journal of Glaciology",
    "journal-of-global-health": "Journal of Global Health",
    "journal-of-hazardous-materials": "Journal of Hazardous Materials",
    "journal-of-health-care-for-the-poor-and-underserved": "Journal of Health Care for the Poor and Underserved",
    "journal-of-hearing-science": "Journal of Hearing Science",
    "journal-of-historical-linguistics": "Journal of Historical Linguistics",
    "journal-of-human-evolution": "Journal of Human Evolution",
    "journal-of-human-nutrition-and-dietetics": "Journal of Human Nutrition and Dietetics",
    "journal-of-human-rights": "Journal of Human Rights",
    "journal-of-hypertension": "Journal of Hypertension",
    "journal-of-industrial-ecology": "Journal of Industrial Ecology",
    "journal-of-industrial-and-engineering-chemistry": "Journal of Industrial and Engineering Chemistry",
    "journal-of-infection": "Journal of Infection",
    "journal-of-infectious-diseases": "Journal of Infectious Diseases",
    "journal-of-information-technology": "Journal of Information Technology",
    "journal-of-innovation-economics-and-management": "Journal of Innovation Economics and Management",
    "journal-of-institutional-and-theoretical-economics": "Journal of Institutional and Theoretical Economics",
    "journal-of-instrumentation": "Journal of Instrumentation",
    "journal-of-integrated-omics": "Journal of Integrated OMICS",
    "journal-of-interactive-marketing": "Journal of Interactive Marketing",
    "journal-of-interactive-media-in-education-harvard": "Journal of Interactive Media in Education (author-date/Harvard)",
    "journal-of-intercultural-studies": "Journal of Intercultural Studies",
    "journal-of-internal-medicine": "Journal of Internal Medicine",
    "journal-of-international-business-studies": "Journal of International Business Studies",
    "journal-of-international-peacekeeping": "Journal of International Peacekeeping",
    "journal-of-international-relations-and-development": "Journal of International Relations and Development",
    "journal-of-investigative-dermatology": "Journal of Investigative Dermatology",
    "journal-of-jewish-studies": "Journal of Jewish Studies",
    "journal-of-juridical-sciences": "Journal of Juridical Sciences",
    "journal-of-korean-neurosurgical-society": "Journal of Korean Neurosurgical Society",
    "journal-of-law-medicine-ethics": "Journal of Law, Medicine & Ethics",
    "journal-of-leukocyte-biology": "Journal of Leukocyte Biology",
    "journal-of-limnology": "Journal of Limnology",
    "journal-of-linguistics": "Journal of Linguistics",
    "journal-of-lipid-research": "Journal of Lipid Research",
    "journal-of-lithic-studies": "Journal of Lithic Studies",
    "journal-of-mammalogy": "Journal of Mammalogy",
    "journal-of-management": "Journal of Management",
    "journal-of-management-information-systems": "Journal of Management Information Systems",
    "journal-of-management-studies": "Journal of Management Studies",
    "journal-of-materials-research": "Journal of Materials Research",
    "journal-of-mechanical-science-and-technology": "Journal of Mechanical Science and Technology",
    "journal-of-medical-genetics": "Journal of Medical Genetics",
    "journal-of-medical-internet-research": "Journal of Medical Internet Research",
    "journal-of-microbiology": "Journal of Microbiology",
    "journal-of-microbiology-and-biotechnology": "Journal of Microbiology and Biotechnology",
    "journal-of-microscopy": "Journal of Microscopy",
    "journal-of-midwifery-science": "Journal of Midwifery Science",
    "journal-of-minimally-invasive-gynecology": "Journal of Minimally Invasive Gynecology",
    "journal-of-molecular-cell-biology": "Journal of Molecular Cell Biology",
    "journal-of-molecular-endocrinology": "Journal of Molecular Endocrinology",
    "journal-of-molecular-recognition": "Journal of Molecular Recognition",
    "journal-of-molecular-signaling": "Journal of Molecular Signaling",
    "journal-of-move-and-therapeutic-science": "Journal of Move and Therapeutic Science",
    "journal-of-multidisciplinary-applied-natural-science": "Journal of Multidisciplinary Applied Natural Science",
    "journal-of-musculoskeletal-research": "Journal of Musculoskeletal Research",
    "journal-of-music-technology-and-education": "Journal of Music Technology and Education",
    "journal-of-nanoscience-and-nanotechnology": "Journal of Nanoscience and Nanotechnology",
    "journal-of-natural-history": "Journal of Natural History",
    "journal-of-neolithic-archaeology": "Journal of Neolithic Archaeology",
    "journal-of-neurochemistry": "Journal of Neurochemistry",
    "journal-of-neuroendocrinology": "Journal of Neuroendocrinology",
    "journal-of-neuroimaging": "Journal of Neuroimaging",
    "journal-of-neurological-disorders": "Journal of Neurological Disorders",
    "journal-of-neurophysiology": "Journal of Neurophysiology",
    "journal-of-neuroscience-and-neuroengineering": "Journal of Neuroscience and Neuroengineering",
    "journal-of-new-zealand-grasslands": "Journal of New Zealand Grasslands",
    "journal-of-nutrition": "Journal of Nutrition",
    "journal-of-obstetrics-and-gynaecology-canada": "Journal of Obstetrics and Gynaecology Canada",
    "journal-of-occupational-and-environmental-medicine": "Journal of Occupational and Environmental Medicine",
    "journal-of-oil-palm-research": "Journal of Oil Palm Research",
    "journal-of-open-research-software": "Journal of Open Research Software",
    "journal-of-oral-and-maxillofacial-surgery": "Journal of Oral and Maxillofacial Surgery",
    "journal-of-orthopaedic-research": "Journal of Orthopaedic Research",
    "journal-of-orthopaedic-trauma": "Journal of Orthopaedic Trauma",
    "journal-of-orthopaedics-trauma-and-rehabilitation": "Journal of Orthopaedics, Trauma and Rehabilitation",
    "journal-of-pain-and-symptom-management": "Journal of Pain and Symptom Management",
    "journal-of-paleontology": "Journal of Paleontology",
    "journal-of-peace-research": "Journal of Peace Research",
    "journal-of-pediatric-gastroenterology-and-nutrition": "Journal of Pediatric Gastroenterology and Nutrition",
    "journal-of-pediatric-surgery": "Journal of Pediatric Surgery",
    "journal-of-peptide-science": "Journal of Peptide Science",
    "journal-of-perinatal-medicine": "Journal of Perinatal Medicine",
    "journal-of-periodontal-research": "Journal of Periodontal Research",
    "journal-of-pharmacy-and-pharmacology": "Journal of Pharmacy and Pharmacology",
    "journal-of-phycology": "Journal of Phycology",
    "journal-of-physical-therapy-science": "Journal of Physical Therapy Science",
    "journal-of-plankton-research": "Journal of Plankton Research",
    "journal-of-plant-ecology": "Journal of Plant Ecology",
    "journal-of-plant-nutrition-and-soil-science": "Journal of Plant Nutrition and Soil Science",
    "journal-of-plant-protection-research": "Journal of Plant Protection Research",
    "journal-of-political-ideologies": "Journal of Political Ideologies",
    "journal-of-political-philosophy": "Journal of Political Philosophy",
    "journal-of-pollination-ecology": "Journal of Pollination Ecology",
    "journal-of-polymer-science-part-a-polymer-chemistry": "Journal of Polymer Science Part A: Polymer Chemistry",
    "journal-of-porphyrins-and-phthalocyanines": "Journal of Porphyrins and Phthalocyanines",
    "journal-of-product-innovation-management": "Journal of Product Innovation Management",
    "journal-of-prosthodontics": "Journal of Prosthodontics",
    "journal-of-psychiatric-and-mental-health-nursing": "Journal of Psychiatric and Mental Health Nursing",
    "journal-of-psychiatry-and-neuroscience": "Journal of Psychiatry & Neuroscience",
    "journal-of-raman-spectroscopy": "Journal of Raman Spectroscopy",
    "journal-of-reconstructive-microsurgery": "Journal of Reconstructive Microsurgery",
    "journal-of-refugee-studies": "Journal of Refugee Studies",
    "journal-of-rehabilitation-medicine": "Journal of Rehabilitation Medicine",
    "journal-of-remote-sensing": "Journal of Remote Sensing",
    "journal-of-retailing": "Journal of Retailing",
    "journal-of-rheumatology": "Journal of Rheumatology",
    "journal-of-roman-archaeology-a": "Journal of Roman Archaeology (A)",
    "journal-of-roman-archaeology-b": "Journal of Roman Archaeology (B)",
    "journal-of-science-and-medicine-in-sport": "Journal of Science and Medicine in Sport",
    "journal-of-separation-science": "Journal of Separation Science",
    "journal-of-shoulder-and-elbow-surgery": "Journal of Shoulder and Elbow Surgery",
    "journal-of-simulation": "Journal of Simulation",
    "journal-of-sleep-research": "Journal of Sleep Research",
    "journal-of-small-animal-practice": "Journal of Small Animal Practice",
    "journal-of-small-business-management": "Journal of Small Business Management",
    "journal-of-social-archaeology": "Journal of Social Archaeology",
    "journal-of-social-philosophy": "Journal of Social Philosophy",
    "journal-of-soil-science-and-plant-nutrition": "Journal of Soil Science and Plant Nutrition",
    "journal-of-soil-and-water-conservation": "Journal of Soil and Water Conservation",
    "journal-of-sport-and-health-science": "Journal of Sport and Health Science",
    "journal-of-sports-science-and-medicine": "Journal of Sports Science & Medicine",
    "journal-of-strength-and-conditioning-research": "Journal of Strength and Conditioning Research",
    "journal-of-stroke": "Journal of Stroke",
    "journal-of-structural-geology": "Journal of Structural Geology",
    "journal-of-studies-on-alcohol-and-drugs": "Journal of Studies on Alcohol and Drugs",
    "journal-of-surgery-and-medicine": "Journal of Surgery and Medicine",
    "journal-of-surgical-oncology": "Journal of Surgical Oncology",
    "journal-of-systematic-palaeontology": "Journal of Systematic Palaeontology",
    "journal-of-systematics-and-evolution": "Journal of Systematics and Evolution",
    "journal-of-the-electrochemical-society": "Journal of The Electrochemical Society",
    "journal-of-thermal-spray-technology": "Journal of Thermal Spray Technology",
    "journal-of-threatened-taxa": "Journal of Threatened Taxa",
    "journal-of-thrombosis-and-haemostasis": "Journal of Thrombosis and Haemostasis",
    "journal-of-tropical-ecology": "Journal of Tropical Ecology",
    "journal-of-tropical-life-science": "Journal of Tropical Life Science",
    "journal-of-universal-computer-science": "Journal of Universal Computer Science",
    "journal-of-urban-technology": "Journal of Urban Technology",
    "journal-of-urban-and-environmental-engineering": "Journal of Urban and Environmental Engineering",
    "journal-of-vegetation-science": "Journal of Vegetation Science",
    "journal-of-vertebrate-biology": "Journal of Vertebrate Biology",
    "journal-of-vertebrate-paleontology": "Journal of Vertebrate Paleontology",
    "journal-of-vestibular-research": "Journal of Vestibular Research",
    "journal-of-veterinary-diagnostic-investigation": "Journal of Veterinary Diagnostic Investigation",
    "journal-of-visualized-experiments": "Journal of Visualized Experiments",
    "journal-of-water-sanitation-and-hygiene-for-development": "Journal of Water Sanitation and Hygiene for Development",
    "journal-of-wildlife-diseases": "Journal of Wildlife Diseases",
    "journal-of-zoo-biology": "Journal of Zoo Biology",
    "journal-of-zoo-and-wildlife-medicine": "Journal of Zoo and Wildlife Medicine",
    "journal-of-zoology": "Journal of Zoology",
    "journal-of-the-air-and-waste-management-association": "Journal of the Air & Waste Management Association",
    "journal-of-the-american-academy-of-audiology": "Journal of the American Academy of Audiology",
    "journal-of-the-american-academy-of-orthopaedic-surgeons": "Journal of the American Academy of Orthopaedic Surgeons",
    "journal-of-the-american-animal-hospital-association": "Journal of the American Animal Hospital Association",
    "journal-of-the-american-association-of-laboratory-animal-science": "Journal of the American Association of Laboratory Animal Science",
    "journal-of-the-american-ceramic-society": "Journal of the American Ceramic Society",
    "journal-of-the-american-college-of-cardiology": "Journal of the American College of Cardiology",
    "journal-of-the-american-college-of-surgeons": "Journal of the American College of Surgeons",
    "journal-of-the-american-heart-association": "Journal of the American Heart Association",
    "journal-of-the-american-philosophical-association": "Journal of the American Philosophical Association",
    "journal-of-the-american-society-of-brewing-chemists": "Journal of the American Society of Brewing Chemists",
    "journal-of-the-american-society-of-nephrology": "Journal of the American Society of Nephrology",
    "journal-of-the-american-water-resources-association": "Journal of the American Water Resources Association",
    "journal-of-the-association-for-information-systems": "Journal of the Association for Information Systems",
    "journal-of-the-association-of-environmental-and-resource-economists": "Journal of the Association of Environmental and Resource Economists",
    "journal-of-the-botanical-research-institute-of-texas": "Journal of the Botanical Research Institute of Texas",
    "journal-of-the-brazilian-chemical-society": "Journal of the Brazilian Chemical Society",
    "journal-of-the-european-academy-of-dermatology-and-venereology": "Journal of the European Academy of Dermatology and Venereology",
    "journal-of-the-history-of-collections": "Journal of the History of Collections",
    "journal-of-the-indian-law-institute": "Journal of the Indian Law Institute",
    "journal-of-the-korean-society-of-civil-engineers": "Journal of the Korean Society of Civil Engineers",
    "journal-of-the-marine-biological-association-of-the-united-kingdom": "Journal of the Marine Biological Association of the United Kingdom",
    "journal-of-the-royal-anthropological-institute": "Journal of the Royal Anthropological Institute",
    "journal-of-the-royal-society-of-western-australia": "Journal of the Royal Society of Western Australia",
    "journal-of-the-royal-statistical-society": "Journal of the Royal Statistical Society",
    "journal-of-the-science-of-food-and-agriculture": "Journal of the Science of Food and Agriculture",
    "journal-of-the-serbian-chemical-society": "Journal of the Serbian Chemical Society",
    "journal-of-the-warburg-and-courtauld-institutes": "Journal of the Warburg and Courtauld Institutes",
    "journal-on-efficiency-and-responsibility-in-education-and-science": "Journal on Efficiency and Responsibility in Education and Science",
    "journalistica": "Journalistica (Dansk)",
    "jurisprudence": "Jurisprudence (Čeština)",
    "juristische-schulung": "Juristische Schulung (Deutsch)",
    "juristische-zitierweise": "Juristische Zitierweise (Stüber) (Deutsch)",
    "juristische-zitierweise-offentliches-recht": "Juristische Zitierweise - Öffentliches Recht (Deutsch)",
    "juristische-zitierweise-schweizer": "Juristische Zitierweise Schweizer (Ryser Büschi et al.) (Deutsch - Schweiz)",
    "jurnal-ilmu-dan-teknologi-hasil-ternak": "Jurnal Ilmu dan Teknologi Hasil Ternak",
    "jurnal-pangan-dan-agroindustri": "Jurnal Pangan dan Agroindustri (Bahasa Indonesia)",
    "jurnal-sains-farmasi-dan-klinis": "Jurnal Sains Farmasi & Klinis",
    "jurnal-teknik-mesin-indonesia": "Jurnal Teknik Mesin Indonesia (Bahasa Indonesia)",
    "jyvaskylan-yliopisto-kemian-laitos": "Jyväskylän yliopisto - Kemian laitos (Suomi)",
    "kit-karlsruher-institut-fur-technologie-germanistik-ndl-neuere-deutsche-literaturwissenschaft": "KIT Karlsruher Institut für Technologie Germanistik NDL Neuere Deutsche Literaturwissenschaft (German)",
    "kona-powder-and-particle-journal": "KONA Powder and Particle Journal",
    "ksce-journal-of-civil-engineering": "KSCE Journal of Civil Engineering",
    "kth-royal-institute-of-technology-school-of-computer-science-and-communication": "KTH Royal Institute of Technology - School of Computer Science and Communication",
    "kth-royal-institute-of-technology-school-of-computer-science-and-communication-sv": "KTH Royal Institute of Technology - School of Computer Science and Communication (Svenska)",
    "karabuk-university-graduate-school-of-natural-and-applied-sciences": "Karabuk University - Graduate School of Natural and Applied Sciences",
    "karger-journals": "Karger journals",
    "karger-journals-author-date": "Karger journals (author-date)",
    "karlstad-universitet-harvard": "Karlstad Universitet (author-date/Harvard, Svenska)",
    "karstenia": "Karstenia",
    "keel-ja-kirjandus": "Keel ja Kirjandus (Eesti keel)",
    "keele-university-school-of-allied-health-professions": "Keele University - School of Allied Health Professions",
    "kidney-research-and-clinical-practice": "Kidney Research and Clinical Practice",
    "kindheit-und-entwicklung": "Kindheit und Entwicklung",
    "harvard-kings-college-london": "King's College London (author-date/Harvard)",
    "klinische-padiatrie": "Klinische Pädiatrie",
    "knee-surgery-and-related-research": "Knee Surgery & Related Research",
    "knee-surgery-sports-traumatology-arthroscopy": "Knee Surgery, Sports Traumatology, Arthroscopy",
    "knowledge-and-management-of-aquatic-ecosystems": "Knowledge & Management of Aquatic Ecosystems",
    "kommunikation-und-recht": "Kommunikation und Recht (Deutsch)",
    "korean-journal-of-anesthesiology": "Korean Journal of Anesthesiology",
    "korean-journal-of-radiology": "Korean Journal of Radiology",
    "kritische-ausgabe": "Kritische Ausgabe (Deutsch)",
    "kunstakademie-munster": "Kunstakademie Münster (Deutsch)",
    "kolner-zeitschrift-fur-soziologie-und-sozialpsychologie": "Kölner Zeitschrift für Soziologie und Sozialpsychologie (Deutsch)",
    "l-homme-english": "L'homme – Revue française d'anthropologie (English)",
    "l-homme": "L'homme – Revue française d'anthropologie (Français)",
    "lcgc": "LCGC",
    "la-revue-des-sciences-de-gestion": "La Revue des Sciences de Gestion (Français)",
    "la-trobe-university-harvard": "La Trobe University (author-date/Harvard)",
    "la-trobe-university-apa": "La Trobe University - APA 6th edition",
    "laboratory-animal-science-professional": "Laboratory Animal Science Professional",
    "lancaster-university-harvard": "Lancaster University (author-date/Harvard)",
    "land-degradation-and-development": "Land Degradation & Development",
    "landes-bioscience-journals": "Landes Bioscience Journals",
    "language": "Language",
    "language-in-society": "Language in Society",
    "latin-american-perspectives": "Latin American Perspectives",
    "latin-american-research-review": "Latin American Research Review",
    "lauterbornia": "Lauterbornia - Internationale Zeitschrift für Faunistik und Floristik des Süßwassers (Deutsch)",
    "law-and-society-review": "Law & Society Review",
    "law-technology-and-humans": "Law, Technology and Humans",
    "le-mouvement-social": "Le Mouvement Social (Français)",
    "le-tapuscrit-author-date": "Le tapuscrit (École des hautes études en sciences sociales) (author-date, Français)",
    "le-tapuscrit-note": "Le tapuscrit (École des hautes études en sciences sociales) (note, Français)",
    "harvard-leeds-beckett-university": "Leeds Beckett University (author-date/Harvard)",
    "harvard-leeds-metropolitan-university": "Leeds Metropolitan University (author-date/Harvard)",
    "leiden-journal-of-international-law": "Leiden Journal of International Law",
    "leidraad-voor-juridische-auteurs": "Leidraad voor juridische auteurs 2019 (Nederlands)",
    "leonardo": "Leonardo",
    "les-cahiers-du-journalisme": "Les Cahiers du journalisme (Français)",
    "les-journees-de-la-recherche-avicole": "Les Journées de la Recherche Avicole (Français)",
    "les-journees-de-la-recherche-porcine": "Les Journées de la Recherche Porcine (Français)",
    "les-mondes-du-travail": "Les Mondes du travail (Français)",
    "les-nouvelles-de-l-archeologie": "Les nouvelles de l'archéologie (Français)",
    "lethaia": "Lethaia",
    "letters-in-applied-microbiology": "Letters in Applied Microbiology",
    "lettres-et-sciences-humaines-fr": "Lettres et Sciences Humaines (biblio et notes, Français)",
    "leuphana-universitaet-lueneburg-institut-fuer-produktionstechnik-und-systeme": "Leuphana Universität Lüneburg - Institut für Produktionstechnik und -systeme (Deutsch)",
    "leviathan": "Leviathan (Deutsch)",
    "lien-social-et-politiques": "Lien social et Politiques (Français)",
    "life-science-alliance": "Life Science Alliance",
    "limnetica": "Limnetica",
    "limnology-and-oceanography": "Limnology and Oceanography",
    "linguistica-uralica": "Linguistica Uralica",
    "literatura": "Literatūra",
    "liver-international": "Liver International",
    "liverpool-john-moores-university-harvard": "Liverpool John Moores University (author-date/Harvard)",
    "london-review-of-international-law": "London Review of International Law",
    "harvard-london-south-bank-university": "London South Bank University (author-date/Harvard)",
    "london-south-bank-university-numeric": "London South Bank University (numeric)",
    "lund-university-school-of-economics-and-management": "Lund University School of Economics and Management",
    "lannee-sociologique": "L’Année sociologique (Français)",
    "mhra-author-date": "MHRA Style Guide 4th edition (author-date)",
    "mhra-author-date-publisher-place": "MHRA Style Guide 4th edition (author-date, place of publication)",
    "mhra-author-date-publisher-place-no-url": "MHRA Style Guide 4th edition (author-date, place of publication, without URLs)",
    "mhra-author-date-no-url": "MHRA Style Guide 4th edition (author-date, without URLs)",
    "mhra-notes": "MHRA Style Guide 4th edition (notes)",
    "mhra-notes-publisher-place": "MHRA Style Guide 4th edition (notes, place of publication)",
    "mhra-notes-publisher-place-no-url": "MHRA Style Guide 4th edition (notes, place of publication, without URLs)",
    "mhra-notes-subsequent-ibid": "MHRA Style Guide 4th edition (notes, subsequent ibid.)",
    "mhra-notes-subsequent-ibid-no-url": "MHRA Style Guide 4th edition (notes, subsequent ibid., without URLs)",
    "mhra-notes-no-url": "MHRA Style Guide 4th edition (notes, without URLs)",
    "mhra-shortened-notes": "MHRA Style Guide 4th edition (shortened notes)",
    "mhra-shortened-notes-publisher-place": "MHRA Style Guide 4th edition (shortened notes, place of publication)",
    "mhra-shortened-notes-publisher-place-no-url": "MHRA Style Guide 4th edition (shortened notes, place of publication, without URLs)",
    "mhra-shortened-notes-no-url": "MHRA Style Guide 4th edition (shortened notes, without URLs)",
    "mis-quarterly": "MIS Quarterly",
    "modern-language-association": "MLA Handbook 9th edition (in-text citations)",
    "modern-language-association-annotated-bibliography": "MLA Handbook 9th edition (in-text citations, annotated bibliography)",
    "modern-language-association-no-url": "MLA Handbook 9th edition (in-text citations, without URLs)",
    "modern-language-association-notes": "MLA Handbook 9th edition (notes)",
    "modern-language-association-notes-no-url": "MLA Handbook 9th edition (notes, without URLs)",
    "mrs-bulletin": "MRS Bulletin",
    "macromolecular-reaction-engineering": "Macromolecular Reaction Engineering",
    "magnetic-resonance-materials-in-physics-biology-and-medicine": "Magnetic Resonance Materials in Physics, Biology and Medicine",
    "magnetic-resonance-in-medical-sciences": "Magnetic Resonance in Medical Sciences",
    "maison-de-l-orient-et-de-la-mediterranee-en": "Maison de l'Orient et de la Méditerranée (English)",
    "maison-de-l-orient-et-de-la-mediterranee": "Maison de l'Orient et de la Méditerranée (Français)",
    "malaysian-orthopaedic-journal": "Malaysian Orthopaedic Journal",
    "mammal-review": "Mammal Review",
    "mammalia": "Mammalia",
    "mammalogy-notes": "Mammalogy Notes",
    "management-et-avenir": "Management & Avenir (Français)",
    "management-international": "Management international",
    "management-of-biological-invasions": "Management of Biological Invasions",
    "harvard-manchester-business-school": "Manchester Business School (author-date/Harvard)",
    "harvard-manchester-metropolitan-university": "Manchester Metropolitan University (author-date/Harvard)",
    "manchester-university-press-author-date": "Manchester University Press monographs (author-date)",
    "manchester-university-press": "Manchester University Press monographs (note)",
    "law-citation-manual": "Manual of Legal Citation (法学注引手册, 中文)",
    "mcgill-fr": "Manuel canadien de la référence juridique 10e édition (Guide McGill, Français - Canada)",
    "marine-biology": "Marine Biology",
    "marine-mammal-science": "Marine Mammal Science",
    "marine-ornithology": "Marine Ornithology",
    "marine-turtle-newsletter": "Marine Turtle Newsletter",
    "marmara-universitesi-turkiyat-arastirmalari-enstitusu": "Marmara Üniversitesi - Türkiyat Araştırmaları Enstitüsü (Türkçe)",
    "mary-ann-liebert-harvard": "Mary Ann Liebert (author-date/Harvard)",
    "mary-ann-liebert-vancouver": "Mary Ann Liebert - NLM/Vancouver",
    "masarykova-univerzita-pravnicka-fakulta": "Masarykova univerzita - Právnická fakulta",
    "mastozoologia-neotropical": "Mastozoologia Neotropical",
    "materials-express": "Materials Express",
    "mathematical-geosciences": "Mathematical Geosciences",
    "mathematics-and-computers-in-simulation": "Mathematics and Computers in Simulation",
    "mcdonald-institute-monographs": "McDonald Institute Monographs",
    "media-culture-and-society": "Media, Culture & Society",
    "medical-dosimetry": "Medical Dosimetry",
    "medical-education-and-clinical-practice": "Medical Education & Clinical Practice",
    "medical-history": "Medical History",
    "medicina-clinica": "Medicina Clínica (Español)",
    "medicina-delle-dipendenze-italian-journal-of-the-addictions": "Medicina delle Dipendenze - Italian Journal of the Addictions (Italiano)",
    "medicinal-research-reviews": "Medicinal Research Reviews",
    "medicine-and-science-in-sports-and-exercise": "Medicine & Science in Sports & Exercise",
    "medicine-publishing": "Medicine Publishing",
    "medicinski-razgledi": "Medicinski razgledi",
    "medicinskiy-akademicheskiy-zhurnal": "Medicinskiy Akademicheskiy Zhurnal",
    "mediterranean-journal-of-chemistry": "Mediterranean Journal of Chemistry",
    "mediterranean-journal-of-infection-microbes-and-antimicrobials": "Mediterranean Journal of Infection, Microbes and Antimicrobials",
    "mediterranean-politics": "Mediterranean Politics",
    "medizinische-hochschule-hannover": "Medizinische Hochschule Hannover",
    "medizinische-universitat-innsbruck-vancouver": "Medizinische Universität Innsbruck - NLM/Vancouver (Deutsch)",
    "harvard-melbourne-polytechnic": "Melbourne Polytechnic (author-date/Harvard)",
    "melbourne-school-of-theology": "Melbourne School of Theology",
    "memorias-do-instituto-oswaldo-cruz": "Memórias do Instituto Oswaldo Cruz",
    "mercator-institut-fur-sprachforderung-und-deutsch-als-zweitsprache": "Mercator-Institut für Sprachförderung und Deutsch als Zweitsprache (Deutsch)",
    "mercatus-center": "Mercatus Center",
    "meta": "Meta",
    "metaaltijden": "Metaaltijden (Nederlands)",
    "metallurgical-and-materials-transactions": "Metallurgical and Materials Transactions",
    "metallurgical-and-materials-transactions-a": "Metallurgical and Materials Transactions A",
    "meteoritics-and-planetary-science": "Meteoritics & Planetary Science",
    "meteorological-applications": "Meteorological Applications",
    "method-and-theory-in-the-study-of-religion": "Method & Theory in the Study of Religion",
    "methods-of-information-in-medicine": "Methods of Information in Medicine",
    "metropol-verlag": "Metropol Verlag (German)",
    "metropolia-university-of-applied-sciences-harvard": "Metropolia Ammattikorkeakoulu (author-date/Harvard, Suomi)",
    "metropolia-university-of-applied-sciences-harvard-english": "Metropolia University of Applied Sciences (author-date/Harvard, English)",
    "mexicon": "Mexicon - The Journal of Mesoamerican Studies",
    "microbial-cell": "Microbial Cell",
    "microbiology-society": "Microbiology Society",
    "microbiome-research-reports": "Microbiome Research Reports",
    "microcirculation": "Microcirculation",
    "microscopy-and-microanalysis": "Microscopy and Microanalysis",
    "middle-east-critique": "Middle East Critique",
    "midwestern-baptist-theological-seminary": "Midwestern Baptist Theological Seminary",
    "mimbar-hukum": "Mimbar Hukum",
    "mimesis-edizioni": "Mimesis Edizioni (Italiano)",
    "mind-and-language": "Mind & Language",
    "mineralogical-magazine": "Mineralogical Magazine",
    "modern-chinese-literature-and-culture": "Modern Chinese Literature and Culture",
    "modern-pathology": "Modern Pathology",
    "modern-phytomorphology": "Modern Phytomorphology",
    "mohr-siebeck-recht": "Mohr Siebeck - Recht (Deutsch - Österreich)",
    "molecular-and-cellular-proteomics": "Molecular & Cellular Proteomics",
    "molecular-biology": "Molecular Biology",
    "molecular-biology-and-evolution": "Molecular Biology and Evolution",
    "molecular-biology-of-the-cell": "Molecular Biology of the Cell",
    "molecular-metabolism": "Molecular Metabolism",
    "molecular-microbiology": "Molecular Microbiology",
    "molecular-nutrition-and-food-research": "Molecular Nutrition & Food Research",
    "molecular-oncology": "Molecular Oncology",
    "molecular-plant": "Molecular Plant",
    "molecular-plant-pathology": "Molecular Plant Pathology",
    "molecular-plant-microbe-interactions": "Molecular Plant-Microbe Interactions",
    "molecular-psychiatry": "Molecular Psychiatry",
    "molecular-psychiatry-letters": "Molecular Psychiatry (letters to the editor)",
    "monash-university-csiro": "Monash University - CSIRO",
    "mondes-en-developpement": "Mondes en développement (Français)",
    "monographs-of-the-palaeontographical-society": "Monographs of the Palaeontographical Society",
    "moorlands-college": "Moorlands College",
    "mots": "Mots (French)",
    "movement-disorders": "Movement Disorders",
    "multidisciplinary-digital-publishing-institute": "Multidisciplinary Digital Publishing Institute",
    "multilingual-matters": "Multilingual Matters",
    "multimed": "Multimed (Español)",
    "multiple-sclerosis-journal": "Multiple Sclerosis Journal",
    "muscle-and-nerve": "Muscle & Nerve",
    "museum-national-dhistoire-naturelle": "Muséum national d'Histoire naturelle",
    "mutagenesis": "Mutagenesis",
    "mycobiology": "Mycobiology",
    "mycologia": "Mycologia",
    "myrmecological-news": "Myrmecological News",
    "medecine-intensive-reanimation": "Médecine Intensive Réanimation",
    "melanges-de-linstitut-dominicain-detudes-orientales-en": "Mélanges de l'Institut dominicain d'études orientales (English)",
    "melanges-de-linstitut-dominicain-detudes-orientales-fr": "Mélanges de l'Institut dominicain d'études orientales (Français)",
    "metropolitiques": "Métropolitiques (Français)",
    "nccr-mediality": "NCCR Mediality. Medienwandel - Medienwechsel - Medienwissen (Deutsch)",
    "nejm-catalyst-innovations-in-care-delivery": "NEJM Catalyst Innovations in Care Delivery",
    "nist-technical-publication-journal-of-research-of-nist": "NIST Technical Publications - Journal of Research of NIST",
    "nlm-citation-name": "NLM/Vancouver: Citing Medicine 2nd edition (citation-name)",
    "nlm-citation-sequence": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence)",
    "nlm-citation-sequence-brackets": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence, brackets)",
    "nlm-citation-sequence-brackets-no-et-al": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence, brackets, no \"et al.\")",
    "nlm-citation-sequence-brackets-year-only-no-issue": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence, brackets, year-only dates, no issue numbers)",
    "nlm-citation-sequence-superscript": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence, superscript)",
    "nlm-citation-sequence-superscript-brackets-year-only": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence, superscript, brackets, year-only dates)",
    "nlm-citation-sequence-superscript-year-only-no-issue": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence, superscript, year-only dates, no issue numbers)",
    "nlm-name-year": "NLM/Vancouver: Citing Medicine 2nd edition (name-year)",
    "nano-biomedicine-and-engineering": "Nano Biomedicine and Engineering",
    "national-archives-of-australia": "National Archives of Australia",
    "national-institute-of-health-research": "National Institute of Health Research",
    "national-institute-of-organisation-dynamics-australia-harvard": "National Institute of Organisation Dynamics Australia (author-date/Harvard)",
    "national-institute-of-technology-karnataka": "National Institute of Technology Karnataka",
    "national-institute-of-technology-tiruchirappalli": "National Institute of Technology, Tiruchirappalli",
    "national-marine-fisheries-service-national-environmental-policy-act": "National Marine Fisheries Service - National Environmental Policy Act",
    "national-natural-science-foundation-of-china": "National Natural Science Foundation of China (中文)",
    "national-science-foundation-grant-proposals": "National Science Foundation (grant proposals)",
    "national-university-of-singapore-department-of-geography-harvard": "National University of Singapore - Department of Geography (author-date/Harvard)",
    "nations-and-nationalism": "Nations and Nationalism",
    "natur-und-landschaft": "Natur und Landschaft (Deutsch)",
    "natura-croatica": "Natura Croatica",
    "nature": "Nature",
    "nature-brackets": "Nature (brackets, no superscript)",
    "nature-no-et-al": "Nature (no \"et al.\")",
    "nature-neuroscience-brief-communications": "Nature Neuroscience (brief communications)",
    "nature-publishing-group-vancouver": "Nature Publishing Group - NLM/Vancouver",
    "natures-sciences-societes": "Natures Sciences Sociétés",
    "nauplius": "Nauplius",
    "navigation": "Navigation",
    "nehet": "NeHeT (Français)",
    "necmettin-erbakan-universitesi-fen-ve-muhendislik-bilimleri-dergisi": "Necmettin Erbakan Üniversitesi Fen ve Mühendislik Bilimleri Dergisi (Türkçe)",
    "nephrology-dialysis-transplantation": "Nephrology Dialysis Transplantation",
    "netherlands-journal-of-geosciences-geologie-en-mijnbouw": "Netherlands Journal of Geosciences - Geologie en Mijnbouw",
    "neue-juristische-wochenschrift": "Neue Juristische Wochenschrift (Deutsch)",
    "neue-kriminalpolitik": "Neue Kriminalpolitik (Deutsch)",
    "neues-jahrbuch-fur-geologie-und-palaontologie": "Neues Jahrbuch für Geologie und Paläontologie",
    "neural-plasticity": "Neural Plasticity",
    "neuroreport": "NeuroReport",
    "neuroendocrinology-letters": "Neuroendocrinology Letters",
    "neuroimaging-clinics-of-north-america": "Neuroimaging Clinics of North America",
    "neurology": "Neurology",
    "neurology-india": "Neurology India",
    "neurologia": "Neurología (Español)",
    "neurologia-argentina": "Neurología Argentina (Español)",
    "neuropsychopharmacology": "Neuropsychopharmacology",
    "neurorehabilitation-and-neural-repair": "Neurorehabilitation and Neural Repair",
    "neurospine": "Neurospine",
    "neurosurgery-clinics-of-north-america": "Neurosurgery Clinics of North America",
    "new-harts-rules-author-date": "New Hart's Rules: The Oxford Style Guide 2nd edition (author-date, bracketed date with comma)",
    "new-harts-rules-author-date-space-publisher": "New Hart's Rules: The Oxford Style Guide 2nd edition (author-date, bracketed date with space, publisher)",
    "new-harts-rules-author-date-publisher": "New Hart's Rules: The Oxford Style Guide 2nd edition (author-date, publisher)",
    "new-harts-rules-notes": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes)",
    "new-harts-rules-notes-initials": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials)",
    "new-harts-rules-notes-initials-bracket-role-page-range": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, bracket roles, page range)",
    "new-harts-rules-notes-initials-bracket-role-page-range-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, bracket roles, page ranges, without URLs)",
    "new-harts-rules-notes-initials-label-page": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, page abbreviations)",
    "new-harts-rules-notes-initials-label-page-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, page abbreviations, without URLs)",
    "new-harts-rules-notes-initials-publisher": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, publisher)",
    "new-harts-rules-notes-initials-publisher-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, publisher, without URLs)",
    "new-harts-rules-notes-initials-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, without URLs)",
    "new-harts-rules-notes-label-page": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, page abbreviations)",
    "new-harts-rules-notes-label-page-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, page abbreviations, without URLs)",
    "new-harts-rules-notes-publisher": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, publisher)",
    "new-harts-rules-notes-publisher-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, publisher, without URLs)",
    "new-harts-rules-notes-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, without URLs)",
    "new-harts-rules-numbered": "New Hart's Rules: The Oxford Style Guide 2nd edition (numbered)",
    "new-harts-rules-short-notes": "New Hart's Rules: The Oxford Style Guide 2nd edition (shortened notes)",
    "new-harts-rules-short-notes-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (shortened notes, without URLs)",
    "new-phytologist": "New Phytologist",
    "new-solutions": "New Solutions",
    "new-testament-studies": "New Testament Studies",
    "new-zealand-dental-journal": "New Zealand Dental Journal",
    "new-zealand-journal-of-forestry-science": "New Zealand Journal of Forestry Science",
    "new-zealand-journal-of-history": "New Zealand Journal of History",
    "new-zealand-plant-protection": "New Zealand Plant Protection",
    "new-zealand-veterinary-journal": "New Zealand Veterinary Journal",
    "harvard-newcastle-university": "Newcastle University (author-date/Harvard)",
    "nordic-pulp-and-paper-research-journal": "Nordic Pulp & Paper Research Journal",
    "norma-portuguesa-405": "Norma Portuguesa 405 (Português)",
    "norois": "Norois (Français)",
    "norsk-apa-manual": "Norsk APA-manual - APA 7th edition (author-date)",
    "norsk-apa-manual-note": "Norsk APA-manual - APA 7th edition (note)",
    "norsk-henvisningsstandard-for-rettsvitenskapelige-tekster-full-firstnote": "Norsk henvisningsstandard for rettsvitenskapelige tekster – fullstendig førstenote (Norsk - Bokmål | Norsk - Nynorsk)",
    "norsk-henvisningsstandard-for-rettsvitenskapelige-tekster": "Norsk henvisningsstandard for rettsvitenskapelige tekster – kortnoter (Norsk - Bokmål | Norsk - Nynorsk)",
    "north-pacific-anadromous-fish-commission-bulletin": "North Pacific Anadromous Fish Commission Bulletin",
    "harvard-north-west-university": "North-West University (author-date/Harvard)",
    "northeastern-naturalist": "Northeastern Naturalist",
    "nottingham-trent-university-library-harvard": "Nottingham Trent University Library (author-date/Harvard)",
    "nouvelles-perspectives-en-sciences-sociales": "Nouvelles perspectives en sciences sociales (Français - Canada)",
    "nova-univerza": "Nova univerza (Slovenščina)",
    "novasinergia": "Novasinergia",
    "nowa-audiofonologia": "Nowa Audiofonologia (Polski)",
    "nuclear-receptor-signaling": "Nuclear Receptor Signaling",
    "nucleic-acids-research": "Nucleic Acids Research",
    "nucleic-acids-research-web-server-issue": "Nucleic Acids Research - Web Server Issue",
    "nueva-norma-estudios-de-la-humanidad": "Nueva Norma Estudios de la Humanidad (with titles)",
    "nutrition-research-reviews": "Nutrition Research Reviews",
    "nys-nydanske-sprogstudier": "NyS - Nydanske Sprogstudier (Dansk)",
    "owbarth-verlag": "O.W. Barth Verlag (Deutsch)",
    "oscola": "OSCOLA 4th edition",
    "oscola-journal-abbreviations": "OSCOLA 4th edition (journal abbreviations)",
    "oscola-no-ibid": "OSCOLA 4th edition (no ibid.)",
    "obafemi-awolowo-university-faculty-of-technology": "Obafemi Awolowo University - Faculty of Technology",
    "obesity": "Obesity",
    "obstetrics-and-gynecology-science": "Obstetrics & Gynecology Science",
    "occupational-medicine": "Occupational Medicine",
    "ocean-and-coastal-research": "Ocean and Coastal Research",
    "oceanography": "Oceanography",
    "oecologia-australis": "Oecologia Australis",
    "offa": "Offa - Berichte und Mitteilungen zur Archäologie",
    "oikos": "Oikos",
    "oil-shale": "Oil Shale",
    "oncoimmunology": "OncoImmunology",
    "oncotarget": "Oncotarget",
    "open-gender-journal": "Open Gender Journal",
    "open-theology": "Open Theology",
    "open-window": "Open Window (author-date/Harvard)",
    "operative-dentistry": "Operative Dentistry",
    "ophthalmic-genetics": "Ophthalmic Genetics",
    "ophthalmic-plastic-and-reconstructive-surgery": "Ophthalmic Plastic and Reconstructive Surgery",
    "ophthalmology": "Ophthalmology",
    "ophthalmology-retina": "Ophthalmology Retina",
    "optics-express": "Optics Express",
    "optics-letters": "Optics Letters",
    "opto-electronic-advances": "Opto-Electronic Advances",
    "optometry-and-vision-science": "Optometry & Vision Science",
    "opuscula": "Opuscula",
    "oral-diseases": "Oral Diseases",
    "organic-geochemistry": "Organic Geochemistry",
    "organised-sound": "Organised Sound",
    "organization": "Organization",
    "organization-studies": "Organization Studies",
    "organon": "Organon",
    "ornitologia-neotropical": "Ornitología Neotropical",
    "orthopedic-clinics-of-north-america": "Orthopedic Clinics of North America",
    "oryx": "Oryx",
    "otto-von-guricke-universitat-magdeburg-medizinische-fakultat-numeric": "Otto-von-Guericke-Universität Magdeburg - Medizinische Fakultät (numeric)",
    "oxford-art-journal": "Oxford Art Journal",
    "oxford-guide-to-style-notes": "Oxford Guide to Style (notes)",
    "oxford-guide-to-style-notes-roman-volume-archive-first": "Oxford Guide to Style (notes, Roman volume numbers, archival references with institution first)",
    "oxford-guide-to-style-notes-roman-volume-archive-first-no-url": "Oxford Guide to Style (notes, Roman volume numbers, archival references with institution first, without URLs)",
    "oxford-guide-to-style-notes-initials": "Oxford Guide to Style (notes, author initials)",
    "oxford-guide-to-style-notes-initials-article-sentence-case-roman-volume-label-page": "Oxford Guide to Style (notes, author initials, article titles in sentence case, Roman volume numbers, page abbreviations)",
    "oxford-guide-to-style-notes-initials-label-page": "Oxford Guide to Style (notes, author initials, page abbreviations)",
    "oxford-guide-to-style-notes-initials-label-page-no-url": "Oxford Guide to Style (notes, author initials, page abbreviations, without URLs)",
    "oxford-guide-to-style-notes-initials-no-url": "Oxford Guide to Style (notes, author initials, without URLs)",
    "oxford-guide-to-style-notes-no-url": "Oxford Guide to Style (notes, without URLs)",
    "oxford-studies-on-the-roman-economy": "Oxford Studies on the Roman Economy",
    "oxford-journals-scimed-author-date": "Oxford University Press - Science and Medicine Journals (author-date)",
    "oxford-journals-scimed-numeric-parentheses": "Oxford University Press - Science and Medicine Journals (numbered, parentheses)",
    "oxford-journals-scimed-numeric": "Oxford University Press - Science and Medicine Journals (numbered, square brackets)",
    "oxford-journals-scimed-numeric-superscript": "Oxford University Press - Science and Medicine Journals (numbered, superscript)",
    "oxidation-of-metals": "Oxidation of Metals",
    "pain": "PAIN",
    "proteomics": "PROTEOMICS",
    "pacific-conservation-biology": "Pacific Conservation Biology",
    "pacific-science": "Pacific Science",
    "paediatric-and-perinatal-epidemiology": "Paediatric and Perinatal Epidemiology",
    "pain-medicine": "Pain Medicine",
    "pain-physician": "Pain Physician",
    "pakistan-journal-of-agricultural-sciences": "Pakistan Journal of Agricultural Sciences",
    "pakistani-veterinary-journal": "Pakistan Veterinary Journal",
    "palaeodiversity": "Palaeodiversity",
    "palaeontographica-abteilung-b-palaeobotany-palaeophytology": "Palaeontographica Abteilung B: Palaeobotany - Palaeophytology",
    "palaeontologia-electronica": "Palaeontologia Electronica",
    "palaeontology": "Palaeontology",
    "palaeovertebrata": "Palaeovertebrata",
    "palaios": "Palaios",
    "paleobiology": "Paleobiology",
    "pallas": "Pallas (French)",
    "pamukkale-universitesi-fen-bilimleri-enstitusu": "Pamukkale Üniversitesi - Fen Bilimleri Enstitüsü (Türkçe)",
    "parasite": "Parasite",
    "parasitology": "Parasitology",
    "pathogens-and-immunity": "Pathogens and Immunity",
    "pediatric-allergy-and-immunology": "Pediatric Allergy and Immunology",
    "pediatric-anesthesia": "Pediatric Anesthesia",
    "pediatric-blood-and-cancer": "Pediatric Blood & Cancer",
    "pediatric-infectious-disease-journal": "Pediatric Infectious Disease Journal",
    "pediatric-physical-therapy": "Pediatric Physical Therapy",
    "pediatric-practice-and-research": "Pediatric Practice and Research",
    "pediatric-pulmonology": "Pediatric Pulmonology",
    "pediatric-research": "Pediatric Research",
    "pediatric-urology-case-reports": "Pediatric Urology Case Reports",
    "pedosphere": "Pedosphere",
    "peerj": "PeerJ",
    "pensoft-journals": "Pensoft Journals",
    "periodicum-biologorum": "Periodicum Biologorum",
    "periodontology-2000": "Periodontology 2000",
    "permafrost-and-periglacial-processes": "Permafrost and Periglacial Processes",
    "perspectives-on-sexual-and-reproductive-health": "Perspectives on Sexual and Reproductive Health",
    "pesquisa-agropecuaria-brasileira": "Pesquisa Agropecuária Brasileira (Português - Brasil)",
    "pest-management-science": "Pest Management Science",
    "peter-lang-social-sciences": "Peter Lang Social Sciences",
    "petit-chicago-author-date": "Petit Chicago (author-date, Français - Canada)",
    "pharmacoepidemiology-and-drug-safety": "Pharmacoepidemiology and Drug Safety",
    "philippika": "Philippika (Deutsch)",
    "philippine-journal-of-natural-sciences": "Philippine Journal of Natural Sciences",
    "philipps-universitat-marburg-note": "Philipps-Universität Marburg - Erziehungswissenschaften (note, Deutsch)",
    "philosophia-scientiae": "Philosophia Scientiæ (English)",
    "philosophiques": "Philosophiques (Français)",
    "philosophy-and-public-affairs": "Philosophy & Public Affairs",
    "photochemistry-and-photobiology": "Photochemistry and Photobiology",
    "photogrammetric-engineering-and-remote-sensing": "Photogrammetric Engineering and Remote Sensing",
    "photosynthetica": "Photosynthetica",
    "phycological-research": "Phycological Research",
    "phyllomedusa": "Phyllomedusa",
    "physiologia-plantarum": "Physiologia Plantarum",
    "physiological-and-biochemical-zoology": "Physiological and Biochemical Zoology",
    "physiotherapy-theory-and-practice": "Physiotherapy Theory and Practice",
    "phytopathologia-mediterranea": "Phytopathologia Mediterranea",
    "phytotaxa": "Phytotaxa",
    "pisa-university-press": "Pisa University Press",
    "planning-practice-and-research": "Planning Practice & Research",
    "plant-and-cell-physiology": "Plant & Cell Physiology",
    "plant-biology": "Plant Biology",
    "plant-biotechnology-journal": "Plant Biotechnology Journal",
    "plant-genetic-resources-characterization-and-utilization": "Plant Genetic Resources - Characterization and Utilization",
    "plant-pathology": "Plant Pathology",
    "plant-physiology": "Plant Physiology",
    "plant-species-biology": "Plant Species Biology",
    "plant-cell-and-environment": "Plant, Cell & Environment",
    "podzemna-voda": "Podzemná voda (Slovenčina)",
    "polar-research": "Polar Research",
    "polish-archives-of-internal-medicine": "Polish Archives of Internal Medicine",
    "polish-legal": "Polish Legal (Polski)",
    "politechnika-opolska-wydzial-wychowania-fizycznego-i-fizjoterapii": "Politechnika Opolska - Wydział Wychowania Fizycznego i Fizjoterapii (Polski)",
    "politeknik-negeri-manado-jurnal-p3m": "Politeknik Negeri Manado - Jurnal Pusat Penelitian dan Pengabdian Kepada Masyarakat (Bahasa Indonesia)",
    "politica-tidsskrift-for-politisk-videnskab": "Politica - Tidsskrift for politisk videnskab (Danish)",
    "political-studies": "Political Studies",
    "politique-europeenne": "Politique Européenne",
    "politische-vierteljahresschrift": "Politische Vierteljahresschrift",
    "politix": "Politix (Français)",
    "polygraphia": "Polygraphia (Italiano)",
    "polymer-reviews": "Polymer Reviews",
    "polytechnique-montreal-apa": "Polytechnique Montréal - APA 7th edition (Français - Canada)",
    "polytechnique-montreal-ieee": "Polytechnique Montréal - IEEE (Français)",
    "pontifical-athenaeum-regina-apostolorum": "Pontifical Athenaeum Regina Apostolorum",
    "pontifical-biblical-institute": "Pontifical Biblical Institute",
    "pontifical-gregorian-university": "Pontifical Gregorian University (Italiano)",
    "harvard-pontificia-universidad-catolica-del-ecuador": "Pontificia Universidad Católica del Ecuador (author-date/Harvard, Español)",
    "pontificia-universidade-catolica-do-parana-abnt": "Pontificia Universidade Catolica do Parana - ABNT (Portuguese - Brazil)",
    "population": "Population (Français)",
    "population-space-and-place": "Population, Space and Place",
    "postepy-higieny-i-medycyny-doswiadczalnej": "Postępy Higieny i Medycyny Doświadczalnej (Polski)",
    "poultry-science": "Poultry Science",
    "pour-reussir-note": "Pour Réussir de Dionne 6ème édition (note, Français - Canada)",
    "praxis": "Praxis (Deutsch - Schweiz)",
    "prehospital-emergency-care": "Prehospital Emergency Care",
    "prehospital-and-disaster-medicine": "Prehospital and Disaster Medicine",
    "preslia": "Preslia - The Journal of the Czech Botanical Society",
    "presses-universitaires-de-rennes": "Presses Universitaires de Rennes (Français)",
    "presses-universitaires-de-rennes-author-date": "Presses Universitaires de Rennes (author-date, Français)",
    "presses-universitaires-de-rennes-archeologie-et-culture": "Presses Universitaires de Rennes - Archéologie et Culture (Français)",
    "presses-universitaires-de-paris-nanterre": "Presses universitaires de Paris Nanterre (note, Français)",
    "presses-universitaires-de-strasbourg-note": "Presses universitaires de Strasbourg (note, Français)",
    "preventive-nutrition-and-food-science": "Preventive Nutrition and Food Science",
    "primary-care-clinics-in-office-practice": "Primary Care: Clinics in Office Practice",
    "proinflow": "ProInflow (note, Čeština)",
    "proceedings-of-the-estonian-academy-of-sciences-author-date": "Proceedings of the Estonian Academy of Sciences (author-date)",
    "proceedings-of-the-estonian-academy-of-sciences-numeric": "Proceedings of the Estonian Academy of Sciences (numeric)",
    "proceedings-of-the-joint-international-grassland-and-international-rangeland-congress-2021": "Proceedings of the Joint International Grassland & International Rangeland Congress 2021",
    "pnas": "Proceedings of the National Academy of Sciences of the United States of America",
    "proceedings-of-the-royal-society-b": "Proceedings of the Royal Society B",
    "processing-and-application-of-ceramics": "Processing and Application of Ceramics",
    "production-and-operations-management": "Production and Operations Management",
    "el-profesional-de-la-informacion": "Profesional de la información (Español)",
    "progress-on-chemistry-and-application-of-chitin-and-its-derivatives": "Progress on Chemistry and Application of Chitin and its Derivatives",
    "protein-engineering-design-and-selection": "Protein Engineering Design and Selection",
    "protein-science": "Protein Science",
    "pravny-obzor": "Právny obzor",
    "pravnik": "Právník (Čeština)",
    "prehistoires-mediterraneennes": "Préhistoires méditerranéennes",
    "psychiatric-clinics-of-north-america": "Psychiatric Clinics of North America",
    "psychiatric-services": "Psychiatric Services",
    "psychiatry-and-clinical-neurosciences": "Psychiatry and Clinical Neurosciences",
    "psychosomatic-medicine": "Psychosomatic Medicine",
    "psychosomatics": "Psychosomatics",
    "public-health-nutrition": "Public Health Nutrition",
    "plos": "Public Library of Science",
    "publicatiewijzer-voor-de-archeologie": "Publicatiewijzer voor de Archeologie (Nederlands)",
    "pure-and-applied-geophysics": "Pure and Applied Geophysics",
    "padagogische-hochschule-bern-institut-vorschulstufe-und-primarstufe": "Pädagogische Hochschule Bern - Institut Vorschulstufe und Primarstufe",
    "padagogische-hochschule-fachhochschule-nordwestschweiz": "Pädagogische Hochschule Fachhochschule Nordwestschweiz (Deutsch - Schweiz)",
    "padagogische-hochschule-heidelberg": "Pädagogische Hochschule Heidelberg (Deutsch)",
    "padagogische-hochschule-vorarlberg": "Pädagogische Hochschule Vorarlberg (Deutsch)",
    "qeios": "Qeios",
    "quaderni": "Quaderni (Italiano)",
    "quaderni-materialisti": "Quaderni Materialisti (Italiano)",
    "quaderni-degli-avogadro-colloquia": "Quaderni degli Avogadro Colloquia",
    "quaternaire": "Quaternaire (Français)",
    "quaternary-international": "Quaternary International",
    "queen-margaret-university-harvard": "Queen Margaret University (author-date/Harvard)",
    "r-and-d-management": "R&D Management",
    "rever-revista-de-estudos-da-religiao": "REVER - Revista de Estudos da Religião",
    "rmit-university-harvard": "RMIT University (author-date/Harvard)",
    "roots-monograph-series": "ROOTS monograph series",
    "rose-school": "ROSE School",
    "rtf-scan": "RTF Scan",
    "radiation-protection-dosimetry": "Radiation Protection Dosimetry",
    "radiation-research": "Radiation Research",
    "radiographics": "RadioGraphics",
    "radiochimica-acta": "Radiochimica Acta",
    "radiography": "Radiography",
    "radiologic-clinics-of-north-america": "Radiologic Clinics of North America",
    "radiology": "Radiology",
    "radiopaedia": "Radiopaedia.org",
    "raffles-bulletin-of-zoology": "Raffles Bulletin of Zoology",
    "raptor-journal": "Raptor Journal",
    "rassegna-degli-archivi-di-stato-bibliografia-generale": "Rassegna degli Archivi di Stato (bibliografia generale o ragionata commentata, sorted chronological, italiano)",
    "rassegna-degli-archivi-di-stato": "Rassegna degli Archivi di Stato (citazioni estese, italiano)",
    "recent-patents-on-drug-delivery-and-formulation": "Recent Patents on Drug Delivery & Formulation",
    "recherches-en-sciences-de-gestion": "Recherches en Sciences de Gestion (Français)",
    "refugee-survey-quarterly": "Refugee Survey Quarterly",
    "register-studies": "Register Studies",
    "religion-in-the-roman-empire": "Religion in the Roman Empire",
    "renewable-agriculture-and-food-systems": "Renewable Agriculture and Food Systems",
    "reports-of-practical-oncology-and-radiotherapy": "Reports of Practical Oncology and Radiotherapy",
    "representation": "Representation",
    "reproduction": "Reproduction",
    "reproduction-fertility-and-development": "Reproduction, Fertility and Development",
    "research-institute-for-nature-and-forest": "Research Institute for Nature and Forest (Instituut voor Natuur- en Bosonderzoek)",
    "research-and-education-promotion-association": "Research and Education Promotion Association",
    "research-in-plant-disease": "Research in Plant Disease",
    "research-on-biomedical-engineering": "Research on Biomedical Engineering",
    "respiratory-care-journal": "Respiratory Care Journal",
    "respirology": "Respirology",
    "restoration-ecology": "Restoration Ecology",
    "retina": "Retina",
    "review-of-international-studies": "Review of International Studies",
    "review-of-political-economy": "Review of Political Economy",
    "reviews-of-modern-physics-with-titles": "Reviews of Modern Physics (with titles)",
    "revista-argentina-de-antropologia-biologica": "Revista Argentina de Antropologia Biologica (Español)",
    "revista-brasileira-de-ciencia-do-solo": "Revista Brasileira de Ciência do Solo",
    "revista-biblica": "Revista Bíblica (Español)",
    "revista-chilena-de-derecho-y-tecnologia": "Revista Chilena de Derecho y Tecnología (Español - Chile)",
    "revista-ciencias-tecnicas-agropecuarias": "Revista Ciencias Técnicas Agropecuarias (Español)",
    "revista-cubana-de-meteorologia": "Revista Cubana de Meteorologia",
    "revista-espanola-de-nutricion-humana-y-dietetica": "Revista Espanola de Nutricion Humana y Dietetica (Español)",
    "revista-fave-seccion-ciencias-agrarias": "Revista FAVE - Sección Ciencias Agrarias (Español)",
    "revista-ladinia": "Revista Ladinia",
    "revista-latinoamericana-de-metalurgia-y-materiales": "Revista Latinoamericana de Metalurgia y Materiales",
    "revista-latinoamericana-de-recursos-naturales": "Revista Latinoamericana de Recursos Naturales",
    "revista-materia": "Revista Matéria",
    "revista-medica-del-instituto-mexicano-del-seguro-social": "Revista Médica del Instituto Mexicano del Seguro Social (Español)",
    "revista-noesis": "Revista Nóesis",
    "revista-peruana-de-medicina-experimental-y-salud-publica": "Revista Peruana de Medicina Experimental y Salud Pública (Español)",
    "revista-portuguesa-de-arqueologia": "Revista Portuguesa de Arqueologia",
    "revista-portuguesa-de-musicologia-author-date": "Revista Portuguesa de Musicologia (author-date)",
    "revista-virtual-de-quimica": "Revista Virtual de Química (Português - Brasil)",
    "revista-da-sociedade-brasileira-de-medicina-tropical": "Revista da Sociedade Brasileira de Medicina Tropical",
    "revista-de-biologia-marina-y-oceanografia": "Revista de Biología Marina y Oceanografía",
    "revista-de-biologia-tropical": "Revista de Biología Tropical (International Journal of Tropical Biology and Conservation)",
    "revista-de-derecho-de-la-universidad-austral-de-chile": "Revista de Derecho de la Universidad Austral de Chile (Español)",
    "revista-de-filologia-espanola": "Revista de Filología Española (Español)",
    "revista-do-instituto-de-medicina-tropical-de-sao-paulo": "Revista do Instituto de Medicina Tropical de São Paulo",
    "revue-archeologique": "Revue Archéologique (Français)",
    "revue-europeenne-des-migrations-internationales": "Revue Européenne des Migrations Internationales",
    "revue-internationale-durbanisme": "Revue Internationale d'Urbanisme (Français)",
    "revue-metis": "Revue Mètis (français)",
    "revue-archeologique-de-narbonnaise": "Revue archéologique de Narbonnaise (French)",
    "revue-archeologique-de-lest": "Revue archéologique de l’Est (Français)",
    "revue-archeologique-du-centre-de-la-france": "Revue archéologique du Centre de la France (Français)",
    "revue-d-anthropologie-des-connaissances": "Revue d'anthropologie des connaissances (Français)",
    "revue-dhistoire-des-sciences": "Revue d'histoire des sciences (Français)",
    "revue-dhistoire-des-sciences-humaines": "Revue d'histoire des sciences humaines (Français)",
    "revue-dhistoire-moderne-et-contemporaine": "Revue d'histoire moderne et contemporaine (Français)",
    "revue-d-elevage-et-de-medecine-veterinaire-des-pays-tropicaux": "Revue d'élevage et de médecine vétérinaire des pays tropicaux (Français)",
    "revue-de-medecine-veterinaire": "Revue de Médecine Vétérinaire (Français)",
    "revue-de-qumran": "Revue de Qumrân",
    "revue-des-nouvelles-technologies-de-l-information": "Revue des Nouvelles Technologies de l'Information (Français)",
    "revue-des-etudes-byzantines": "Revue des Études Byzantines",
    "revue-forestiere-francaise": "Revue forestière française (Français)",
    "revue-francaise-dhistotechnologie": "Revue francaise d'histotechnologie (Français)",
    "revue-francaise-d-administration-publique": "Revue française d'administration publique (Français)",
    "revue-francaise-de-gestion": "Revue française de gestion (Français)",
    "revue-francaise-de-pedagogie": "Revue française de pédagogie (Français)",
    "revue-francaise-de-sociologie": "Revue française de sociologie (Français)",
    "rhinology": "Rhinology",
    "rhodora": "Rhodora",
    "risk-analysis": "Risk Analysis",
    "ritid": "Ritið: tímarit Hugvísindastofnunar (Íslenska)",
    "rivista-italiana-di-paleontologia-e-stratigrafia": "Rivista Italiana di Paleontologia e Stratigrafia",
    "harvard-robert-gordon-university": "Robert Gordon University (author-date/Harvard)",
    "romanian-humanities": "Romanian Humanities (Română)",
    "royal-college-of-nursing-harvard": "Royal College of Nursing (author-date/Harvard)",
    "royal-college-of-surgeons-in-ireland-medical-university-of-bahrain-harvard": "Royal College of Surgeons in Ireland - Medical University of Bahrain (author-date/Harvard)",
    "royal-entomological-society": "Royal Entomological Society",
    "royal-society-of-chemistry": "Royal Society of Chemistry",
    "royal-society-of-chemistry-with-titles": "Royal Society of Chemistry (with titles)",
    "ruhr-universitat-bochum-lehrstuhl-fur-industrial-sales-and-service-engineering": "Ruhr-Universität Bochum - Lehrstuhl für Industrial Sales and Service Engineering",
    "ruhr-universitat-bochum-medizinische-fakultat-numeric": "Ruhr-Universität Bochum - Medizinische Fakultät (numerisch, Deutsch)",
    "gost-r-7-0-5-2008-numeric": "Russian GOST R 7.0.5-2008 (numeric)",
    "gost-r-7-0-5-2008-numeric-alphabetical": "Russian GOST R 7.0.5-2008 (numeric, sorted alphabetically, Ру́сский)",
    "gost-r-7-0-5-2008": "Russian GOST R 7.0.5-2008 (Ру́сский)",
    "rofo": "RöFo: Fortschritte auf dem Gebiet der Röntgenstrahlen und bildgebenden Verfahren",
    "sage-harvard": "SAGE (author-date/Harvard)",
    "sage-vancouver": "SAGE - NLM/Vancouver",
    "sage-vancouver-brackets": "SAGE - NLM/Vancouver (brackets)",
    "society-of-biblical-literature-author-date": "SBL Handbook of Style 2nd edition (author-date)",
    "society-of-biblical-literature-fullnote-bibliography": "SBL Handbook of Style 2nd edition (notes)",
    "science-china-earth-sciences": "SCIENCE CHINA Earth Sciences",
    "science-china-life-sciences": "SCIENCE CHINA Life Sciences",
    "science-china-materials": "SCIENCE CHINA Materials",
    "sist02": "SIST02 (日本語)",
    "skuast-journal-of-research": "SKUAST Journal of Research",
    "sn-computer-science": "SN Computer Science",
    "spie-bios": "SPIE BiOS",
    "spie-proceedings": "SPIE Conference Proceedings",
    "spie-journals": "SPIE journals",
    "spip-cite": "SPIP - Cite plugin",
    "spiritual-care": "SPIRITUAL CARE (Deutsch)",
    "saint-paul-university-faculty-of-canon-law": "Saint Paul University - Faculty of Canon Law",
    "san-francisco-estuary-and-watershed-science": "San Francisco Estuary & Watershed Science",
    "sanamed": "Sanamed",
    "foerster-geisteswissenschaft": "Sascha Foerster - Geisteswissenschaft (Deutsch)",
    "saglik-bilimleri-universitesi": "Sağlık Bilimleri Üniversitesi",
    "scandinavian-journal-of-infectious-diseases": "Scandinavian Journal of Infectious Diseases",
    "scandinavian-journal-of-information-systems": "Scandinavian Journal of Information Systems",
    "scandinavian-journal-of-medicine-and-science-in-sports": "Scandinavian Journal of Medicine & Science in Sports",
    "scandinavian-journal-of-rheumatology": "Scandinavian Journal of Rheumatology",
    "scandinavian-journal-of-work-environment-and-health": "Scandinavian Journal of Work, Environment & Health",
    "scandinavian-political-studies": "Scandinavian Political Studies",
    "schweizerische-zeitschrift-fur-geschichte": "Schweizerische Zeitschrift für Geschichte",
    "science": "Science",
    "science-without-titles": "Science (without titles)",
    "science-china-chemistry": "Science China Chemistry",
    "science-translational-medicine": "Science Translational Medicine",
    "science-and-technology-for-the-built-environment": "Science and Technology for the Built Environment",
    "scienceasia": "ScienceAsia",
    "sciences-po-ecole-doctorale-author-date": "Sciences Po - Ecole de la recherche (author-date, Français)",
    "sciences-po-ecole-doctorale-note-french": "Sciences Po - École de la recherche (note)",
    "scientia-agriculturae-bohemica": "Scientia Agriculturae Bohemica",
    "scientia-iranica": "Scientia Iranica",
    "scientific-online-letters-on-the-atmosphere": "Scientific Online Letters on the Atmosphere",
    "scientific-review-engineering-and-environmental-sciences": "Scientific Review Engineering and Environmental Sciences (Przegląd Naukowy Inżynieria i Kształtowanie Środowiska)",
    "scrinium": "Scrinium",
    "sedimentology": "Sedimentology",
    "seed-science-research": "Seed Science Research",
    "seed-science-and-technology": "Seed Science and Technology",
    "seismological-research-letters": "Seismological Research Letters",
    "sekolah-tinggi-meteorologi-klimatologi-dan-geofisika": "Sekolah Tinggi Meteorologi Klimatologi dan Geofisika (Bahasa Indonesia)",
    "seminars-in-pediatric-neurology": "Seminars in Pediatric Neurology",
    "serbian-archives-of-medicine": "Serbian Archives of Medicine",
    "serdica-journal-of-computing": "Serdica Journal of Computing",
    "service-medical-de-l-assurance-maladie": "Service Médical de l'Assurance Maladie (Français)",
    "sexual-development": "Sexual Development",
    "sexual-health": "Sexual Health",
    "sheffield-hallam-university-history": "Sheffield Hallam University - History",
    "shock": "Shock",
    "silva-fennica": "Silva Fennica",
    "sinergie-italian-journal-of-management": "Sinergie Italian Journal of Management",
    "skene-journal-of-theatre-and-drama-studies": "Skenè. Journal of Theatre and Drama Studies",
    "slovensko-drustvo-za-medicinsko-informatiko": "Slovensko društvo za medicinsko informatiko",
    "small": "Small",
    "smithsonian-institution-scholarly-press-author-date": "Smithsonian Institution Scholarly Press (author-date)",
    "smithsonian-institution-scholarly-press-note": "Smithsonian Institution Scholarly Press (note)",
    "smithsonian-institution-scholarly-press-botany": "Smithsonian Institution Scholarly Press - Botany (author-date)",
    "smyrna-tip-dergisi": "Smyrna Tıp Dergisi (Türkçe)",
    "social-anthropology": "Social Anthropology/Anthropologie Sociale",
    "social-cognitive-and-affective-neuroscience": "Social Cognitive and Affective Neuroscience",
    "social-history": "Social History",
    "social-history-of-medicine": "Social History of Medicine",
    "social-science-history": "Social Science History",
    "sociedade-brasileira-de-computacao": "Sociedade Brasileira de Computação",
    "society-for-american-archaeology": "Society for American Archaeology",
    "society-for-historical-archaeology": "Society for Historical Archaeology",
    "society-for-laboratory-automation-and-screening": "Society for Laboratory Automation and Screening",
    "society-of-automotive-engineers-technical-papers-numeric": "Society of Automotive Engineers Technical Papers (numeric)",
    "sociologia-ruralis": "Sociologia Ruralis",
    "sociologia-urbana-e-rurale": "Sociologia Urbana e Rurale (Italian)",
    "sociologie": "Sociologie (Français)",
    "sociology-of-health-and-illness": "Sociology of Health & Illness",
    "societe-archeologique-de-bordeaux": "Société Archéologique de Bordeaux (Français)",
    "societe-francaise-detude-de-la-ceramique-antique-en-gaule": "Société Française d’Étude de la Céramique Antique en Gaule (Français)",
    "societe-nationale-des-groupements-techniques-veterinaires": "Société Nationale des Groupements Techniques Vétérinaires (Français)",
    "societe-francaise-degyptologie": "Société française d'égyptologie",
    "societes-contemporaines": "Sociétés Contemporaines",
    "soil-biology-and-biochemistry": "Soil Biology and Biochemistry",
    "soil-science-and-plant-nutrition": "Soil Science and Plant Nutrition",
    "solent-university-harvard": "Solent University (author-date/Harvard)",
    "solutions": "Solutions",
    "sophiahemmet-hogskola": "Sophiahemmet Högskola (Swedish)",
    "sorbonne-student-law-review": "Sorbonne Student Law Review - Revue juridique des étudiants de la Sorbonne",
    "south-african-actuarial-journal": "South African Actuarial Journal",
    "south-african-journal-of-animal-science": "South African Journal of Animal Science",
    "south-african-journal-of-enology-and-viticulture": "South African Journal of Enology and Viticulture",
    "south-african-journal-of-geology": "South African Journal of Geology",
    "south-african-law-journal": "South African Law Journal",
    "south-african-medical-journal": "South African Medical Journal",
    "south-african-theological-seminary": "South African Theological Seminary",
    "southeastern-geographer": "Southeastern Geographer",
    "southern-african-journal-of-critical-care": "Southern African Journal of Critical Care",
    "soziale-welt": "Soziale Welt (Deutsch)",
    "sozialpadagogisches-institut-berlin-walter-may": "Sozialpädagogisches Institut Berlin - Walter May (Deutsch)",
    "sozialwissenschaften-heilmann": "Sozialwissenschaften (Heilmann) (Deutsch)",
    "soziologie": "Soziologie (Deutsch)",
    "soziologiemagazin": "Soziologiemagazin (Deutsch)",
    "spandidos-publications": "Spandidos Publications",
    "spanish-legal": "Spanish Legal (Español)",
    "spectroscopy-letters": "Spectroscopy Letters",
    "spine": "Spine",
    "sports-health": "Sports Health",
    "springer-basic-author-date": "Springer - Basic (author-date)",
    "springer-basic-author-date-no-et-al": "Springer - Basic (author-date, no \"et al.\")",
    "springer-basic-author-date-no-et-al-with-issue": "Springer - Basic (author-date, no \"et al.\", with issue numbers)",
    "springer-basic-note": "Springer - Basic (note)",
    "springer-basic-brackets": "Springer - Basic (numeric, brackets)",
    "springer-basic-brackets-no-et-al": "Springer - Basic (numeric, brackets, no \"et al.\")",
    "springer-basic-brackets-no-et-al-alphabetical": "Springer - Basic (numeric, brackets, no \"et al.\", alphabetical)",
    "springer-fachzeitschriften-medizin-psychologie": "Springer - Fachzeitschriften Medizin Psychologie (Deutsch)",
    "springer-humanities-author-date": "Springer - Humanities (author-date)",
    "springer-humanities-brackets": "Springer - Humanities (numeric, brackets)",
    "springer-imis-series-migrationsgesellschaften": "Springer - IMIS Series Migrationsgesellschaften",
    "springer-lecture-notes-in-computer-science": "Springer - Lecture Notes in Computer Science",
    "springer-lecture-notes-in-computer-science-alphabetical": "Springer - Lecture Notes in Computer Science (sorted alphabetically)",
    "springer-mathphys-author-date": "Springer - MathPhys (author-date)",
    "springer-mathphys-brackets": "Springer - MathPhys (numeric, brackets)",
    "springer-vancouver": "Springer - NLM/Vancouver (citation-sequence)",
    "springer-vancouver-brackets": "Springer - NLM/Vancouver (citation-sequence, brackets)",
    "springer-vancouver-author-date": "Springer - NLM/Vancouver (name-year)",
    "springer-physics-author-date": "Springer - Physics (author-date)",
    "springer-physics-brackets": "Springer - Physics (numeric, brackets)",
    "springer-socpsych-author-date": "Springer - SocPsych (author-date)",
    "springer-socpsych-brackets": "Springer - SocPsych (numeric, brackets)",
    "springer-vs-author-date": "Springer VS (author-date, Deutsch)",
    "springerprotocols": "SpringerProtocols",
    "st-patricks-college": "St Patrick's College",
    "harvard-staffordshire-university": "Staffordshire University (author-date/Harvard)",
    "stanovnistvo": "Stanovništvo",
    "statistika-statistics-and-economy-journal": "Statistika: Statistics and Economy Journal",
    "stavebni-obzor": "Stavební obzor (Čeština)",
    "steel-research-international": "Steel Research International",
    "steinbeis-hochschule-school-of-management-and-innovation": "Steinbeis-Hochschule - School of Management & Innovation (Deutsch)",
    "stellenbosch-law-review": "Stellenbosch Law Review",
    "harvard-stellenbosch-university": "Stellenbosch University (author-date/Harvard)",
    "stem-cell-reports": "Stem Cell Reports",
    "stem-cells": "Stem Cells",
    "strategic-design-research-journal": "Strategic Design Research Journal",
    "strategic-entrepreneurship-journal": "Strategic Entrepreneurship Journal",
    "strategic-management-journal": "Strategic Management Journal",
    "stroke": "Stroke",
    "structural-control-and-health-monitoring": "Structural Control and Health Monitoring",
    "studi-slavistici-rivista-dellassociazione-italiana-degli-slavisti": "Studi Slavistici Rivista dell’Associazione Italiana degli Slavisti",
    "studi-e-materiali-di-storia-delle-religioni": "Studi e materiali di storia delle religioni (Italiano)",
    "studia-bas": "Studia BAS (Polski)",
    "studia-historiae-scientiarum": "Studia Historiae Scientiarum",
    "studia-theologica": "Studia Theologica (Czech)",
    "studies-in-the-history-of-gardens-and-designed-landscapes": "Studies in the History of Gardens & Designed Landscapes",
    "studii-teologice": "Studii Teologice",
    "em-normandie-business-school-harvard-francais": "Style Harvard Ecole de Management de Normandie (Français)",
    "style-manual-australian-government": "Style Manual - Australian Government (author-date)",
    "style-manual-australian-government-note": "Style Manual - Australian Government (note)",
    "style-manual-for-authors-editors-and-printers-6th-edition-snooks-co": "Style manual for authors, editors and printers 6th edition (Snooks & Co.) (author-date)",
    "sunway-college-johor-bahru": "Sunway College Johor Bahru (author-date/Harvard)",
    "suomen-antropologi-journal-of-the-finnish-anthropological-society": "Suomen antropologi: Journal of the Finnish Anthropological Society",
    "surgical-clinics-of-north-america": "Surgical Clinics of North America",
    "surgical-neurology-international": "Surgical Neurology International",
    "surgical-pathology-clinics": "Surgical Pathology Clinics",
    "survey-of-ophthalmology": "Survey of Ophthalmology",
    "svensk-exegetisk-arsbok": "Svensk exegetisk årsbok (full note)",
    "swedish-legal": "Swedish Legal (Svenska)",
    "harvard-swinburne-university-of-technology": "Swinburne University of Technology (author-date/Harvard)",
    "swiss-political-science-review": "Swiss Political Science Review",
    "sylwan": "Sylwan (Polski)",
    "synthesis": "Synthesis",
    "system-dynamics-review": "System Dynamics Review",
    "systematic-biology": "Systematic Biology",
    "systematic-and-applied-microbiology": "Systematic and Applied Microbiology",
    "szociologiai-szemle": "Szociológiai Szemle (Magyar)",
    "seminaire-saint-sulpice-ecole-theologie": "Séminaire Saint-Sulpice - Ecole Théologie (Français)",
    "sodertorns-hogskola-harvard": "Södertörns högskola (author-date/Harvard)",
    "sodertorns-hogskola-harvard-ibid": "Södertörns högskola (author-date/Harvard, with Ibid.)",
    "sodertorns-hogskola-oxford": "Södertörns högskola - Oxford",
    "suleyman-demirel-universitesi-fen-bilimleri-enstitusu": "Süleyman Demirel Üniversitesi - Fen Bi̇li̇mleri̇ Ensti̇tüsü",
    "tatup-zeitschrift-fur-technikfolgenabschatzung-in-theorie-und-praxis": "TATuP - Zeitschrift für Technikfolgenabschätzung in Theorie und Praxis",
    "tgm-wien-diplom": "TGM Wien Diplomarbeit (Deutsch)",
    "tgm-wien-diplomarbeit-onorm": "TGM Wien Diplomarbeit ÖNORM (Deutsch - Österreich)",
    "tagungsberichte-der-historischen-kommission-fur-ost-und-westpreussische-landesforschung": "Tagungsberichte der Historischen Kommission für ost- und westpreußische Landesforschung (Deutsch)",
    "tapir-conservation": "Tapir Conservation",
    "targetome": "Targetome",
    "taxon": "Taxon",
    "taylor-and-francis-harvard-x": "Taylor & Francis (author-date/Harvard) X",
    "taylor-and-francis-ama": "Taylor & Francis - AMA",
    "taylor-and-francis-acs": "Taylor & Francis - American Chemical Society",
    "taylor-and-francis-aip": "Taylor & Francis - American Institute of Physics",
    "taylor-and-francis-chicago-f": "Taylor & Francis - Chicago F",
    "taylor-and-francis-council-of-science-editors-author-date": "Taylor & Francis - Council of Science Editors (author-date)",
    "taylor-and-francis-council-of-science-editors-numeric": "Taylor & Francis - Council of Science Editors (numeric)",
    "taylor-and-francis-national-library-of-medicine": "Taylor & Francis - NLM/Vancouver (citation-sequence, brackets)",
    "taylor-and-francis-vancouver-national-library-of-medicine": "Taylor & Francis - NLM/Vancouver (citation-sequence, parentheses)",
    "taylor-and-francis-numeric-q": "Taylor & Francis - Numeric Q",
    "taylor-and-francis-chicago-b-author-date": "Taylor & Francis - US Chicago Manual of Style B (author-date)",
    "taylor-and-francis-chicago-author-date": "Taylor & Francis Journals Standard Reference Style Guide: Chicago author-date version 2.0",
    "techniques-et-culture": "Techniques&Culture (Français)",
    "technische-universitat-dortmund-ag-virtual-machining": "Technische Universität Dortmund - AG Virtual Machining (Deutsch)",
    "technische-universitat-dresden-betriebswirtschaftslehre-logistik-author-date": "Technische Universität Dresden - Betriebswirtschaftslehre/Logistik (author-date)",
    "technische-universitat-dresden-betriebswirtschaftslehre-marketing": "Technische Universität Dresden - Betriebswirtschaftslehre/Marketing (author-date)",
    "technische-universitat-dresden-betriebswirtschaftslehre-rechnungswesen-controlling": "Technische Universität Dresden - Betriebswirtschaftslehre/Rechnungswesen/Controlling (Deutsch)",
    "technische-universitat-dresden-erziehungswissenschaften-author-date": "Technische Universität Dresden - Erziehungswissenschaften (author-date)",
    "technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-author-date": "Technische Universität Dresden - Finanzwirtschaft und Finanzdienstleistungen (author-date)",
    "technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-author-date-with-short-titles": "Technische Universität Dresden - Finanzwirtschaft und Finanzdienstleistungen (author-date, with short titles)",
    "technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-note": "Technische Universität Dresden - Finanzwirtschaft und Finanzdienstleistungen (note)",
    "technische-universitat-dresden-forstwissenschaft": "Technische Universität Dresden - Forstwissenschaft (author-date, Deutsch)",
    "technische-universitat-dresden-historische-musikwissenschaft-note": "Technische Universität Dresden - Historische Musikwissenschaft (note, Deutsch)",
    "technische-universitat-dresden-kunstgeschichte-note": "Technische Universität Dresden - Kunstgeschichte (note, Deutsch)",
    "technische-universitat-dresden-linguistik": "Technische Universität Dresden - Linguistik (Deutsch)",
    "technische-universitat-dresden-medienwissenschaft-und-neuere-deutsche-literatur-note": "Technische Universität Dresden - Medienwissenschaft und Neuere Deutsche Literatur (note, Deutsch)",
    "technische-universitat-dresden-wirtschaftswissenschaften": "Technische Universität Dresden - Wirtschaftswissenschaften (Deutsch)",
    "technische-universitat-hamburg-institut-fur-smarte-entwicklung-und-maschinenelemente": "Technische Universität Hamburg – Institut für Smarte Entwicklung und Maschinenelemente (Deutsch)",
    "technische-universitat-munchen-controlling": "Technische Universität München - Controlling (Deutsch)",
    "technische-universitat-munchen-unternehmensfuhrung": "Technische Universität München - Unternehmensführung (Deutsch)",
    "technische-universitat-wien": "Technische Universität Wien (dissertation) (Deutsch)",
    "teologia-catalunya": "Teologia Catalunya",
    "termedia-neuropsychiatria-i-neuropsychologia-neuropsychiatry-and-neuropsychology": "Termedia Neuropsychiatria i Neuropsychologia/Neuropsychiatry and Neuropsychology",
    "terra-nova": "Terra Nova",
    "tetrahedron-letters": "Tetrahedron Letters",
    "textual-cultures": "Textual Cultures",
    "textual-practice": "Textual Practice",
    "thai-endodontic-journal": "Thai Endodontic Journal",
    "the-accounting-review": "The Accounting Review",
    "african-journal-of-food-agriculture-nutrition-development": "The African Journal of Food, Agriculture, Nutrition and Development",
    "the-american-journal-of-bioethics": "The American Journal of Bioethics",
    "the-american-journal-of-cardiology": "The American Journal of Cardiology",
    "the-american-journal-of-dermatopathology": "The American Journal of Dermatopathology",
    "the-american-journal-of-gastroenterology": "The American Journal of Gastroenterology",
    "the-american-journal-of-geriatric-psychiatry": "The American Journal of Geriatric Psychiatry",
    "the-american-journal-of-pathology": "The American Journal of Pathology",
    "the-american-journal-of-psychiatry": "The American Journal of Psychiatry",
    "the-american-journal-of-tropical-medicine-and-hygiene": "The American Journal of Tropical Medicine and Hygiene",
    "the-american-midland-naturalist": "The American Midland Naturalist",
    "the-american-naturalist": "The American Naturalist",
    "the-angle-orthodontist": "The Angle Orthodontist",
    "the-astrophysical-journal": "The Astrophysical Journal",
    "the-auk": "The Auk",
    "the-australian-journal-of-agricultural-and-resource-economics": "The Australian Journal of Agricultural and Resource Economics",
    "the-biological-bulletin": "The Biological Bulletin",
    "the-bone-and-joint-journal": "The Bone & Joint Journal",
    "the-botanical-review": "The Botanical Review",
    "the-bovine-practitioner": "The Bovine Practitioner",
    "the-british-journal-for-the-history-of-science": "The British Journal for the History of Science",
    "the-british-journal-for-the-philosophy-of-science": "The British Journal for the Philosophy of Science",
    "the-british-journal-of-cardiology": "The British Journal of Cardiology",
    "the-british-journal-of-criminology": "The British Journal of Criminology",
    "the-british-journal-of-psychiatry": "The British Journal of Psychiatry",
    "the-british-journal-of-social-work": "The British Journal of Social Work",
    "the-british-journal-of-sociology": "The British Journal of Sociology",
    "the-canadian-geographer": "The Canadian Geographer (Le Géographe canadien)",
    "the-canadian-journal-of-chemical-engineering": "The Canadian Journal of Chemical Engineering",
    "the-canadian-journal-of-psychiatry": "The Canadian Journal of Psychiatry",
    "the-cancer-journal": "The Cancer Journal",
    "the-chemical-society-of-japan": "The Chemical Society of Japan",
    "the-chinese-journal-of-international-politics": "The Chinese Journal of International Politics",
    "the-coleopterists-bulletin": "The Coleopterists Bulletin",
    "the-company-of-biologists": "The Company of Biologists",
    "the-depositional-record": "The Depositional Record",
    "the-design-journal": "The Design Journal",
    "the-economic-history-review": "The Economic History Review",
    "the-european-research-journal": "The European Research Journal",
    "the-faseb-journal": "The FASEB Journal",
    "the-febs-journal": "The FEBS Journal",
    "the-geological-society-of-america": "The Geological Society of America",
    "the-geological-society-of-london": "The Geological Society of London",
    "the-hastings-center-report": "The Hastings Center Report",
    "the-historical-journal": "The Historical Journal",
    "the-holocene": "The Holocene",
    "the-horticulture-journal": "The Horticulture Journal",
    "the-isme-journal": "The ISME Journal",
    "the-institute-of-electronics-information-and-communication-engineers": "The Institute of Electronics, Information and Communication Engineers (電子情報通信学会)",
    "the-institution-of-engineering-and-technology": "The Institution of Engineering and Technology",
    "the-international-journal-of-developmental-biology": "The International Journal of Developmental Biology",
    "the-international-journal-of-psychoanalysis": "The International Journal of Psychoanalysis",
    "the-international-journal-of-tuberculosis-and-lung-disease": "The International Journal of Tuberculosis and Lung Disease",
    "the-international-spectator": "The International Spectator",
    "the-journal-of-adhesive-dentistry": "The Journal of Adhesive Dentistry",
    "the-journal-of-agricultural-science": "The Journal of Agricultural Science",
    "journal-of-biological-chemistry": "The Journal of Biological Chemistry",
    "the-journal-of-bone-and-joint-surgery": "The Journal of Bone & Joint Surgery",
    "the-journal-of-clinical-ethics": "The Journal of Clinical Ethics",
    "the-journal-of-clinical-investigation": "The Journal of Clinical Investigation",
    "the-journal-of-comparative-law": "The Journal of Comparative Law",
    "the-journal-of-comparative-neurology": "The Journal of Comparative Neurology",
    "the-journal-of-ecclesiastical-history": "The Journal of Ecclesiastical History",
    "the-journal-of-egyptian-archaeology": "The Journal of Egyptian Archaeology",
    "the-journal-of-eukaryotic-microbiology": "The Journal of Eukaryotic Microbiology",
    "the-journal-of-foot-and-ankle-surgery": "The Journal of Foot & Ankle Surgery",
    "the-journal-of-hand-surgery-european-volume": "The Journal of Hand Surgery (European Volume)",
    "the-journal-of-hand-surgery-asian-pacific-volume": "The Journal of Hand Surgery Asian-Pacific Volume",
    "the-journal-of-hellenic-studies": "The Journal of Hellenic Studies",
    "the-journal-of-immunology": "The Journal of Immunology",
    "the-journal-of-infection-in-developing-countries": "The Journal of Infection in Developing Countries",
    "the-journal-of-juristic-papyrology": "The Journal of Juristic Papyrology",
    "the-journal-of-laryngology-and-otology": "The Journal of Laryngology and Otology",
    "the-journal-of-molecular-diagnostics": "The Journal of Molecular Diagnostics",
    "the-journal-of-nervous-and-mental-disease": "The Journal of Nervous and Mental Disease",
    "the-journal-of-neuropsychiatry-and-clinical-neurosciences": "The Journal of Neuropsychiatry and Clinical Neurosciences",
    "the-journal-of-neuroscience": "The Journal of Neuroscience",
    "the-journal-of-nuclear-medicine": "The Journal of Nuclear Medicine",
    "the-journal-of-nutrition-health-and-aging": "The Journal of Nutrition, Health & Aging",
    "the-journal-of-pain": "The Journal of Pain",
    "the-journal-of-parasitology": "The Journal of Parasitology",
    "the-journal-of-pathology": "The Journal of Pathology",
    "the-journal-of-peasant-studies": "The Journal of Peasant Studies",
    "the-journal-of-physiology": "The Journal of Physiology",
    "the-journal-of-pure-and-applied-chemistry-research": "The Journal of Pure and Applied Chemistry Research",
    "the-journal-of-roman-studies": "The Journal of Roman Studies",
    "the-journal-of-transport-history": "The Journal of Transport History",
    "the-journal-of-trauma-and-acute-care-surgery": "The Journal of Trauma and Acute Care Surgery",
    "the-journal-of-urology": "The Journal of Urology",
    "journal-of-value-inquiry": "The Journal of Value Inquiry",
    "the-journal-of-veterinary-medical-science": "The Journal of Veterinary Medical Science",
    "the-journal-of-wildlife-management": "The Journal of Wildlife Management",
    "the-journal-of-the-acoustical-society-of-america": "The Journal of the Acoustical Society of America (author-date)",
    "the-journal-of-the-acoustical-society-of-america-numeric": "The Journal of the Acoustical Society of America (numeric)",
    "the-journal-of-the-torrey-botanical-society": "The Journal of the Torrey Botanical Society",
    "the-korean-journal-of-gastroenterology": "The Korean Journal of Gastroenterology",
    "the-korean-journal-of-internal-medicine": "The Korean Journal of Internal Medicine",
    "the-korean-journal-of-mycology": "The Korean Journal of Mycology",
    "the-lancet": "The Lancet",
    "the-lichenologist": "The Lichenologist",
    "the-national-medical-journal-of-india": "The National Medical Journal of India",
    "the-neuroscientist": "The Neuroscientist",
    "the-new-england-journal-of-medicine": "The New England Journal of Medicine",
    "the-oncologist": "The Oncologist",
    "the-open-university-harvard": "The Open University (author-date/Harvard)",
    "the-open-university-numeric": "The Open University (numeric)",
    "the-open-university-numeric-superscript": "The Open University (numeric, superscript)",
    "the-open-university-a251": "The Open University - A251 - Arts Course",
    "the-open-university-m801": "The Open University - M801 - Research Project and Dissertation",
    "the-open-university-s390": "The Open University - S390",
    "the-optical-society": "The Optical Society",
    "the-pan-african-medical-journal": "The Pan African Medical Journal",
    "the-plant-cell": "The Plant Cell",
    "the-plant-genome": "The Plant Genome",
    "the-plant-journal": "The Plant Journal",
    "the-quarterly-journal-of-economics": "The Quarterly Journal of Economics",
    "the-rockefeller-university-press": "The Rockefeller University Press",
    "the-saudi-journal-for-dental-research": "The Saudi Journal for Dental Research",
    "the-scandinavian-journal-of-clinical-and-laboratory-investigation": "The Scandinavian Journal of Clinical & Laboratory Investigation",
    "harvard-the-university-of-northampton": "The University of Northampton (author-date/Harvard)",
    "harvard-the-university-of-sheffield-school-of-east-asian-studies": "The University of Sheffield - School of East Asian Studies (author-date/Harvard)",
    "harvard-the-university-of-sheffield-town-and-regional-planning": "The University of Sheffield - Town and Regional Planning (author-date/Harvard)",
    "the-university-of-western-australia-harvard": "The University of Western Australia (author-date/Harvard)",
    "the-university-of-winchester-harvard": "The University of Winchester (author-date/Harvard)",
    "the-world-journal-of-biological-psychiatry": "The World Journal of Biological Psychiatry",
    "theologie-und-philosophie": "Theologie und Philosophie (Deutsch)",
    "harvard-theologisches-seminar-adelshofen": "Theologisches Seminar Adelshofen (author-date/Harvard, Deutsch)",
    "theory-culture-and-society": "Theory, Culture & Society",
    "theranostics": "Theranostics",
    "thieme-german": "Thieme-German (Deutsch)",
    "thomson-reuters-legal-tax-and-accounting-australia": "Thomson Reuters - Legal, Tax & Accounting Australia",
    "thrombosis-and-haemostasis": "Thrombosis and Haemostasis",
    "theses-de-sorbonne-universite": "Thèse de Sorbonne Université (Sciences Humaines et Sociales, Français)",
    "tijdschrift-voor-geneeskunde": "Tijdschrift voor Geneeskunde en Gezondheidszorg (Nederlands)",
    "tijdschrift-voor-economische-en-sociale-geografie": "Tijdschrift voor economische en sociale geografie",
    "topoi-orient-occident-auteur-date": "Topoi Orient-Occident (auteur-date, Français)",
    "topoi-orient-occident-classique": "Topoi Orient-Occident (classique, Français)",
    "trabajos-de-prehistoria": "Trabajos de Prehistoria (Español)",
    "traces": "Tracés: Revue de Sciences Humaines (Français)",
    "traffic": "Traffic",
    "traffic-injury-prevention": "Traffic Injury Prevention",
    "tramas-y-redes-revista-del-consejo-latinoamericano-de-ciencias-sociales": "Tramas y Redes - Revista del Consejo Latinoamericano de Ciencias Sociales (Español)",
    "trames": "Trames",
    "transactions-of-the-american-philological-association": "Transactions of the American Philological Association",
    "transactions-of-the-materials-research-society-of-japan": "Transactions of the Materials Research Society of Japan",
    "transactions-of-the-philological-society": "Transactions of the Philological Society",
    "transactions-on-maritime-science": "Transactions on Maritime Science",
    "transboundary-and-emerging-diseases": "Transboundary and Emerging Diseases",
    "transnational-environmental-law": "Transnational Environmental Law",
    "transplantation": "Transplantation",
    "transport": "Transport",
    "transportation-research-record": "Transportation Research Record: Journal of the Transportation Research Board",
    "transposition": "Transposition. Musique et sciences sociales",
    "transversalites": "Transversalités (Français)",
    "travail-et-emploi": "Travail et Emploi (Français)",
    "trends-in-glycoscience-and-glycotechnology": "Trends in Glycoscience and Glycotechnology",
    "trends-journals": "Trends journals",
    "triangle": "Triangle (Français)",
    "trinity-college-dublin-zoology-botany-environmental-sciences-harvard": "Trinity College Dublin - Zoology Botany Environmental Sciences (author-date/Harvard)",
    "tropical-animal-health-and-production": "Tropical Animal Health and Production",
    "tsaqafah": "Tsaqafah",
    "turcica": "Turcica",
    "tyndale-bulletin": "Tyndale Bulletin",
    "turkiye-bilimsel-ve-teknolojik-arastirma-kurumu": "TÜBİTAK (Türkiye Bilimsel ve Teknolojik Araştırma Kurumu) (Türkçe)",
    "tabula": "Tábula (Español)",
    "u-schylku-starozytnosci": "U Schyłku Starożytności (Polski)",
    "us-geological-survey": "U.S. Geological Survey",
    "ucl-institute-of-education-harvard": "UCL Institute of Education (author-date/Harvard)",
    "ucl-press-note": "UCL Press (note)",
    "ucl-university-college-harvard": "UCL University College (author-date/Harvard, Dansk)",
    "ucl-university-college-apa": "UCL University College - APA (Dansk)",
    "ucl-university-college-vancouver": "UCL University College - NLM/Vancouver",
    "uclouvain-centre-charles-de-visscher-pour-le-droit-international-et-europeen": "UCLouvain - Centre Charles De Visscher pour le droit international et européen (French)",
    "unesco-international-institute-for-educational-planning": "UNESCO International Institute for Educational Planning",
    "associacao-brasileira-de-normas-tecnicas-unirio-eipp": "UNIRIO - Educação Infantil e Políticas Públicas - ABNT (Português - Brasil)",
    "usda-forest-service-pacific-northwest-research-station": "USDA Forest Service - Pacific Northwest Research Station",
    "ugeskrift-for-laeger": "Ugeskrift for Læger (Dansk)",
    "ultrasound-in-medicine-and-biology": "Ultrasound in Medicine and Biology",
    "uludag-universitesi-sosyal-bilimler-enstitusu-author-date": "Uludağ Üniversitesi - Sosyal Bilimler Enstitüsü (author-date, Türkçe)",
    "uludag-universitesi-sosyal-bilimler-enstitusu-full-note": "Uludağ Üniversitesi - Sosyal Bilimler Enstitüsü (full note, Türkçe)",
    "uludag-universitesi-sosyal-bilimler-enstitusu-full-note-with-ibid": "Uludağ Üniversitesi - Sosyal Bilimler Enstitüsü (full note, with Ibid., Türkçe)",
    "uludag-universitesi-sosyal-bilimler-enstitusu-ilahiyat-fakultesi-full-note": "Uludağ Üniversitesi - Sosyal Bilimler Enstitüsü - İlahiyat Fakültesi (full note, Türkçe)",
    "uludag-universitesi-sosyal-bilimler-enstitusu-ilahiyat-fakultesi-full-note-with-ibid": "Uludağ Üniversitesi - Sosyal Bilimler Enstitüsü - İlahiyat Fakültesi (full note, with Ibid., Türkçe)",
    "ulua-revista-de-historia-sociedad-y-cultura": "Ulúa. Revista de Historia, Sociedad y Cultura",
    "umea-university-harvard": "Umeå University (author-date/Harvard)",
    "umea-university-oxford": "Umeå University - Oxford",
    "undergraduate-journal-of-experimental-microbiology-and-immunology": "Undergraduate Journal of Experimental Microbiology and Immunology",
    "uni-fribourg-theologie": "Uni Fribourg Theologie (Deutsch)",
    "unified-style-sheet-for-linguistics-de-gruyter-literature": "Unified Stylesheet for Linguistics (de Gruyter Literature)",
    "unified-style-sheet-for-linguistics": "Unified style sheet for linguistics",
    "united-nations-conference-on-trade-and-development": "United Nations Conference on Trade and Development",
    "united-nations-development-programme-icca-legal-review": "United Nations Development Programme ICCA Legal Review",
    "united-nations-framework-convention-on-climate-change": "United Nations Framework Convention on Climate Change",
    "united-states-international-trade-commission": "United States International Trade Commission",
    "universidad-autonoma-cidudad-juarez-estilo-latino-humanistico": "Universidad Autónoma de Ciudad Juárez - Estilo Latino Humanístico",
    "universidad-evangelica-del-paraguay": "Universidad Evangélica del Paraguay (Español)",
    "universidad-nacional-autonoma-de-mexico-instituto-de-investigaciones-juridicas": "Universidad Nacional Autónoma de México - Instituto de Investigaciones Jurídicas (Español)",
    "universidad-de-leon-harvard": "Universidad de León (España) (author-date/Harvard)",
    "universidade-estadual-paulista-campus-de-dracena-abnt": "Universidade Estadual Paulista - Campus de Dracena - ABNT (autoria abreviada) (Português - Brasil)",
    "universidade-estadual-paulista-faculdade-de-engenharia-de-guaratingueta-abnt": "Universidade Estadual Paulista - Faculdade de Engenharia de Guaratingueta - ABNT (Português - Brasil)",
    "universidade-estadual-de-alagoas-abnt": "Universidade Estadual de Alagoas - UNEAL [ABNT] (Portuguese - Brazil)",
    "universidade-estadual-do-oeste-do-parana-programa-institucional-de-bolsas-de-iniciacao-cientifica": "Universidade Estadual do Oeste do Paraná - Programa Institucional de Bolsas de Iniciação Científica (Português - Brasil)",
    "universidade-federal-de-goias-escola-de-veterinaria-e-zootecnia": "Universidade Federal de Goiás - Escola de Veterinária e Zootecnia (Português - Brasil)",
    "universidade-federal-de-juiz-de-fora": "Universidade Federal de Juiz de Fora (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufmg-face-initials": "Universidade Federal de Minas Gerais - Faculdade de Ciências Econômicas - ABNT (autoria abreviada) (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufmg-face-full": "Universidade Federal de Minas Gerais - Faculdade de Ciências Econômicas - ABNT (autoria completa) (Português - Brasil)",
    "universidade-federal-de-pernambuco-abnt": "Universidade Federal de Pernambuco - ABNT (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufs": "Universidade Federal de Sergipe - ABNT (Português - Brasil)",
    "universidade-federal-de-sergipe-departamento-de-engenharia-de-producao-abnt": "Universidade Federal de Sergipe - Departamento de Engenharia de Produção - ABNT (Português - Brasil)",
    "universidade-federal-do-espirito-santo-abnt-initials": "Universidade Federal do Espírito Santo - ABNT (autoria abreviada) (Português - Brasil)",
    "universidade-federal-do-espirito-santo-abnt": "Universidade Federal do Espírito Santo - ABNT (autoria completa) (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufpr": "Universidade Federal do Paraná - ABNT (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufrgs-initials": "Universidade Federal do Rio Grande do Sul - ABNT (autoria abreviada) (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufrgs-note-initials-with-ibid": "Universidade Federal do Rio Grande do Sul - ABNT (autoria abreviada, nota, com Ibid.) (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufrgs": "Universidade Federal do Rio Grande do Sul - ABNT (autoria completa) (Português - Brasil)",
    "universidade-federal-do-rio-de-janeiro-instituto-alberto-luiz-coimbra-de-pos-graduacao-e-pesquisa-de-engenharia-abnt": "Universidade Federal do Rio de Janeiro - Instituto Alberto Luiz Coimbra de Pós-Graduação e Pesquisa de Engenharia - ABNT (Português - Brasil)",
    "universidade-de-sao-paulo-escola-de-comunicacoes-e-artes-abnt": "Universidade de São Paulo - Escola de Comunicações e Artes - ABNT (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-usp-fmvz": "Universidade de São Paulo - Faculdade de Medicina Veterinária e Zootecnia - ABNT (Português - Brasil)",
    "universidade-de-sao-paulo-instituto-de-matematica-e-estatistica": "Universidade de São Paulo - Instituto de Matemática e Estatística",
    "universidade-do-estado-do-rio-de-janeiro-abnt": "Universidade do Estado do Rio de Janeiro - ABNT (Português - Brasil)",
    "universidade-do-porto-faculdade-de-engenharia-chicago": "Universidade do Porto - Faculdade de Engenharia - Chicago Manual of Style 17th (author-date)",
    "universidade-do-porto-faculdade-de-engenharia-chicago-pt": "Universidade do Porto - Faculdade de Engenharia - Chicago Manual of Style 17th (author-date) (Português - Portugal)",
    "universidade-do-porto-faculdade-de-psicologia-e-de-ciencias-da-educacao": "Universidade do Porto - Faculdade de Psicologia e de Ciências da Educação - APA",
    "universitas-brawijaya-fakultas-teknologi-pertanian": "Universitas Brawijaya - Fakultas Teknologi Pertanian (Bahasa Indonesia)",
    "universitas-gadjah-mada-departemen-sejarah": "Universitas Gadjah Mada - Departemen Sejarah (Bahasa Indonesia)",
    "universitas-gadjah-mada-doctoral-program-in-pharmaceutical-sciences": "Universitas Gadjah Mada - Doctoral Program in Pharmaceutical Sciences (Bahasa Indonesia)",
    "universitas-negeri-semarang-fakultas-matematika-dan-ilmu-pengetahuan-alam": "Universitas Negeri Semarang - Fakultas Matematika dan Ilmu Pengetahuan Alam (Bahasa Indonesia)",
    "universitas-negeri-yogyakarta-program-pascasarjana": "Universitas Negeri Yogyakarta - Program Pascasarjana (Bahasa Indonesia)",
    "ugent-geschiedenis-nederlands": "Universiteit Gent Geschiedenis (Nederlands)",
    "universiteit-utrecht-onderzoeksgids-geschiedenis": "Universiteit Utrecht - Onderzoeksgids Geschiedenis",
    "universitetet-i-oslo-rettsvitenskap": "Universitetet i Oslo - Rettsvitenskap (Norsk - Bokmål)",
    "universiti-kebangsaan-malaysia": "Universiti Kebangsaan Malaysia (Malay)",
    "harvard-universiti-teknologi-malaysia": "Universiti Teknologi Malaysia (author-date/Harvard)",
    "harvard-universiti-tunku-abdul-rahman": "Universiti Tunku Abdul Rahman (author-date/Harvard)",
    "university-college-dublin-school-of-history-and-archives": "University College Dublin - School of History & Archives",
    "university-college-lillebaelt-apa": "University College Lillebælt - APA (Dansk)",
    "harvard-university-for-the-creative-arts": "University for the Creative Arts (author-date/Harvard)",
    "university-of-aberdeen-school-of-education-harvard": "University of Aberdeen - School of Education (author-date/Harvard)",
    "harvard-university-of-abertay-dundee": "University of Abertay Dundee (author-date/Harvard)",
    "university-of-aleppo-faculty-of-medicine": "University of Aleppo - Faculty of Medicine",
    "university-of-auckland-history": "University of Auckland - History",
    "harvard-university-of-bath": "University of Bath (author-date/Harvard)",
    "harvard-university-of-birmingham": "University of Birmingham (author-date/Harvard)",
    "universita-di-bologna-lettere": "University of Bologna - Liberal Arts College (Università di Bologna - Facoltà di Lettere e Filosofia) (Italiano)",
    "university-of-bradford-harvard": "University of Bradford (author-date/Harvard)",
    "harvard-university-of-brighton-school-of-environment-and-technology": "University of Brighton School of Environment & Technology (author-date/Harvard)",
    "university-of-bucharest-faculty-of-law": "University of Bucharest - Faculty of Law (Română)",
    "university-of-cambridge-faculty-of-history": "University of Cambridge - Faculty of History",
    "harvard-university-of-cape-town": "University of Cape Town (author-date/Harvard)",
    "harvard-university-of-exeter-geography": "University of Exeter - Geography (author-date/Harvard)",
    "university-of-gothenburg-apa-swedish-legislations": "University of Gothenburg - APA 6th edition (Swedish legislations)",
    "university-of-gothenburg-apa-7th-edition-swedish-legislations": "University of Gothenburg - APA 7th edition (Swedish legislations)",
    "harvard-university-of-greenwich": "University of Greenwich (author-date/Harvard)",
    "university-of-hull-harvard": "University of Hull Harvard",
    "harvard-university-of-kent": "University of Kent (author-date/Harvard)",
    "harvard-university-of-leeds": "University of Leeds (author-date/Harvard)",
    "harvard-limerick": "University of Limerick (Cite it Right) (author-date/Harvard)",
    "university-of-lincoln-harvard": "University of Lincoln (author-date/Harvard)",
    "university-of-new-england-australia-note": "University of New England, Australia (note)",
    "university-of-new-south-wales-notes": "University of New South Wales (notes and bibliography)",
    "university-of-pretoria-harvard-theology-religion": "University of Pretoria (author-date/Harvard, Theology and Religion)",
    "university-of-roehampton-harvard": "University of Roehampton (author-date/Harvard)",
    "university-of-south-africa-harvard": "University of South Africa (author-date/Harvard)",
    "university-of-south-australia-harvard-2011": "University of South Australia 2011 (author-date/Harvard)",
    "university-of-south-australia-harvard-2013": "University of South Australia 2013 (author-date/Harvard)",
    "university-of-south-australia-2017-harvard": "University of South Australia 2017 (author-date/Harvard)",
    "university-of-south-wales-harvard": "University of South Wales (author-date/Harvard)",
    "university-of-tasmania-simplified-author-date": "University of Tasmania - Simplified Author-date",
    "harvard-university-of-technology-sydney": "University of Technology Sydney (author-date/Harvard)",
    "harvard-university-of-westminster": "University of Westminster (author-date/Harvard)",
    "harvard-university-of-wolverhampton": "University of Wolverhampton (author-date/Harvard)",
    "university-of-york-harvard": "University of York (author-date/Harvard)",
    "university-of-york-harvard-archaeology": "University of York - Department of Archaeology (author-date/Harvard)",
    "university-of-york-harvard-environment": "University of York - Department of Environment and Geography (author-date/Harvard)",
    "university-of-zabol": "University of Zabol (English)",
    "university-of-zabol-fa": "University of Zabol (فارسی)",
    "harvard-university-of-the-west-of-england": "University of the West of England (Bristol) (author-date/Harvard)",
    "harvard-university-of-the-west-of-scotland": "University of the West of Scotland (author-date/Harvard)",
    "universita-cattolica-del-sacro-cuore": "Università Cattolica del Sacro Cuore (note, Italiano)",
    "universita-pontificia-salesiana": "Università Pontificia Salesiana",
    "universita-pontificia-salesiana-it": "Università Pontificia Salesiana (Italiano)",
    "universitat-basel-deutsche-sprachwissenschaft": "Universität Basel - Deutsche Sprachwissenschaft",
    "universitat-basel-iberoromanistik": "Universität Basel - Iberoromanistik (Español)",
    "universitat-bern-institut-fur-musikwissenschaft-note": "Universität Bern - Institut für Musikwissenschaft (note, Deutsch)",
    "universitat-bern-institut-fur-sozialanthropologie": "Universität Bern - Institut für Sozialanthropologie (Deutsch - Schweiz)",
    "universitat-bern-institut-fur-theaterwissenschaft": "Universität Bern - Institut für Theaterwissenschaft (note, Deutsch)",
    "universitat-bremen-frankoromanistik-literaturwissenschaft": "Universität Bremen - Frankoromanistik - Literaturwissenschaft",
    "universitat-bremen-institut-fur-politikwissenschaft": "Universität Bremen - Institut für Politikwissenschaft (Deutsch)",
    "universitat-bremen-lehrstuhl-fur-innovatives-markenmanagement": "Universität Bremen - Lehrstuhl für innovatives Markenmanagement (Deutsch)",
    "universitat-graz-geographie": "Universität Graz - Geographie",
    "universitat-heidelberg-historisches-seminar": "Universität Heidelberg - Historisches Seminar (Deutsch)",
    "universitat-heidelberg-medizinische-fakultat-mannheim-numeric": "Universität Heidelberg - Medizinische Fakultät Mannheim (numerisch, Deutsch)",
    "universitat-mainz-geographisches-institut": "Universität Mainz - Geographisches Institut (Deutsch)",
    "universitat-mannheim-germanistische-linguistik": "Universität Mannheim - Germanistische Linguistik (Deutsch)",
    "universitat-stuttgart-planung-und-partizipation": "Universität Stuttgart - Planung und Partizipation (Deutsch)",
    "universitat-vechta-katholische-theologie": "Universität Vechta - Katholische Theologie (Deutsch)",
    "universitat-wien-institut-fur-geschichte": "Universität Wien - Institut für Geschichte",
    "universitat-wurzburg-institut-fur-deutsche-philologie-museologie": "Universität Würzburg - Institut für deutsche Philologie - Museologie (Deutsch)",
    "universitat-zu-koln-seminar-fur-abwl-und-finanzierungslehre": "Universität zu Köln - Seminar für ABWL und Finanzierungslehre (Deutsch)",
    "universitatsmedizin-gottingen": "Universitätsmedizin Göttingen (Deutsch)",
    "universite-catholique-de-louvain-histoire": "Université Catholique de Louvain - Histoire (Français)",
    "universite-cheikh-anta-diop-faculte-de-medecine-de-pharmacie-et-dodontologie": "Université Cheikh Anta Diop - Faculté de Médecine de Pharmacie et d'Odontologie (Français)",
    "universite-gustave-eiffel-arts-numeriques-et-cultures-visuelles": "Université Gustave Eiffel - Arts Numériques et Cultures Visuelles (Français)",
    "universite-laval-departement-dinformation-et-de-communication": "Université Laval - Département d'information et de communication (Français - Canada)",
    "universite-laval-departement-des-sciences-historiques": "Université Laval - Département des sciences historiques (Français - Canada)",
    "universite-laval-faculte-de-theologie-et-de-sciences-religieuses": "Université Laval - Faculté de théologie et de sciences religieuses (Français - Canada)",
    "universite-nangui-abrogoua-sciences-de-la-nature-apa": "Université Nangui Abrogoua - Sciences de la Nature - APA (Français)",
    "universite-catholique-de-louvain-fial": "Université catholique de Louvain - FIAL (Français)",
    "universite-de-bordeaux-ecole-doctorale-de-droit": "Université de Bordeaux - École doctorale de droit (Français)",
    "universite-de-geneve-departement-de-langue-et-de-litterature-francaises-modernes": "Université de Genève - Département de langue et de littérature françaises modernes (Français)",
    "universite-de-lausanne-histoire": "Université de Lausanne - Histoire (Français)",
    "universite-de-lausanne-institut-d-archeologie-et-des-sciences-de-l-antiquite": "Université de Lausanne - Institut d'archéologie et des sciences de l'antiquité (Français)",
    "universite-de-liege-droit": "Université de Liège - Droit (Français)",
    "universite-de-liege-droit-par-categorie": "Université de Liège - Droit (classement par catégorie, Français)",
    "universite-de-liege-histoire": "Université de Liège - Histoire (Français)",
    "universite-de-montreal-apa": "Université de Montréal - APA (Français - Canada)",
    "universite-de-montreal-faculte-de-musique": "Université de Montréal - Faculté de musique (Français - Canada)",
    "universite-de-montreal-nlm-fr-ca": "Université de Montréal - NLM/Vancouver (Français - Canada)",
    "universite-de-picardie-jules-verne-ufr-de-medecine": "Université de Picardie Jules Verne (Amiens) - Thèse de UFR de Médecine",
    "universite-de-sherbrooke-departement-de-geomatique": "Université de Sherbrooke - Département de géomatique (Français - Canada)",
    "universite-de-sherbrooke-faculte-d-education": "Université de Sherbrooke - Faculté d'éducation (Français - Canada)",
    "universite-de-sherbrooke-histoire": "Université de Sherbrooke - Histoire (Français - Canada)",
    "universite-du-quebec-a-montreal": "Université du Québec à Montréal - APA (Français - Canada)",
    "universite-du-quebec-a-montreal-prenoms": "Université du Québec à Montréal - APA - prénoms (Français - Canada)",
    "universite-du-quebec-a-montreal-departement-dhistoire": "Université du Québec à Montréal - Département d’histoire (Français - Canada)",
    "universite-du-quebec-a-montreal-etudes-litteraires-et-semiologie": "Université du Québec à Montréal - Études littéraires et sémiologie (Français - Canada)",
    "universite-libre-de-bruxelles-histoire": "Université libre de Bruxelles - Histoire (Français)",
    "univerza-na-primorskem-fakulteta-za-vede-o-zdravju-apa": "Univerza na Primorskem - Fakulteta za vede o zdravju - APA 7 (Slovenščina)",
    "univerza-v-ljubljani-fakulteta-za-gradbenistvo-in-geodezijo-apa-7": "Univerza v Ljubljani - Fakulteta za gradbeništvo in geodezijo - APA 7 (Slovenščina)",
    "univerza-v-ljubljani-fakulteta-za-kemijo-in-kemijsko-tehnologijo": "Univerza v Ljubljani - Fakulteta za kemijo in kemijsko tehnologijo (Slovenščina)",
    "uniwersytet-gdanski-kulturoznawstwo-autor-rok": "Uniwersytet Gdański - Kulturoznawstwo - autor, rok (Polski)",
    "uniwersytet-gdanski-kulturoznawstwo-przypis": "Uniwersytet Gdański - Kulturoznawstwo - przypis (Polski)",
    "uniwersytet-kardynala-stefana-wyszynskiego-w-warszawie-autor-rok": "Uniwersytet Kardynała Stefana Wyszyńskiego w Warszawie (autor-rok, Polski)",
    "uniwersytet-kardynala-stefana-wyszynskiego-w-warszawie-przypis": "Uniwersytet Kardynała Stefana Wyszyńskiego w Warszawie (przypis, Polski)",
    "uniwersytet-im-adama-mickiewicza-w-poznaniu-wydzial-anglistyki": "Uniwersytet im. Adama Mickiewicza w Poznaniu - Wydział Anglistyki (English)",
    "uppsala-university-library-harvard": "Uppsala University Library (author-date/Harvard)",
    "uppsala-universitet-historia": "Uppsala universitet - Historia",
    "uppsala-universitet-institutionen-for-biologisk-grundutbildning": "Uppsala universitet, Institutionen för biologisk grundutbildning",
    "urad-rs-za-makroekonomske-analize-in-razvoj": "Urad RS za makroekonomske analize in razvoj (Slovenščina)",
    "urban-geography": "Urban Geography",
    "urban-habitats": "Urban Habitats",
    "urban-studies": "Urban Studies",
    "urbani-izziv-en": "Urbani izziv (Urban Challenge) (English)",
    "urbani-izziv": "Urbani izziv (Urban Challenge) (Slovenščina)",
    "urological-science": "Urological Science",
    "user-modeling-and-user-adapted-interaction": "User Modeling and User-Adapted Interaction",
    "utah-geological-survey": "Utah Geological Survey",
    "vitis-journal-of-grapevine-research": "VITIS - Journal of Grapevine Research",
    "van-yuzuncu-yil-universitesi-fen-bilimleri-enstitusu": "Van Yüzüncü Yıl Üniversitesi Fen Bilimleri Enstitüsü - Tez Yazım Stili (Türkçe)",
    "veterinaria-italiana": "Veterinaria Italiana",
    "veterinary-anaesthesia-analgesia": "Veterinary Anaesthesia Analgesia",
    "veterinary-clinical-pathology": "Veterinary Clinical Pathology",
    "veterinary-medicine-austria": "Veterinary Medicine Austria (Wiener Tierärztliche Monatsschrift)",
    "veterinary-microbiology": "Veterinary Microbiology",
    "veterinary-pathology": "Veterinary Pathology",
    "veterinary-radiology-and-ultrasound": "Veterinary Radiology & Ultrasound",
    "veterinary-record": "Veterinary Record",
    "veterinary-record-open": "Veterinary Record Open",
    "victoria-university-harvard": "Victoria University (author-date/Harvard)",
    "vienna-legal": "Vienna Legal",
    "vietnam-journal-of-science-and-technology": "Vietnam Journal of Science and Technology",
    "vietnam-ministry-of-education-and-training-en": "Vietnam Ministry of Education and Training (English)",
    "vietnam-ministry-of-education-and-training-vi": "Vietnam Ministry of Education and Training (Tiếng Việt)",
    "vigiliae-christianae": "Vigiliae Christianae",
    "vingtieme-siecle": "Vingtième Siècle. Revue d'histoire (Français)",
    "vita-latina": "Vita Latina (Français)",
    "vita-latina-auteurs-anciens": "Vita Latina (auteurs anciens, Français)",
    "vodohospodarske-technicko-ekonomicke-informace-en": "Vodohospodářské technicko-ekonomické informace (English)",
    "vodohospodarske-technicko-ekonomicke-informace": "Vodohospodářské technicko-ekonomické informace (Čeština)",
    "vox-sanguinis": "Vox Sanguinis",
    "who-europe-harvard": "WHO Regional Office for Europe (author-date/Harvard)",
    "who-europe-numeric": "WHO Regional Office for Europe (numeric)",
    "wader-study": "Wader Study",
    "water-alternatives": "Water Alternatives",
    "water-environment-research": "Water Environment Research",
    "water-sa": "Water SA",
    "water-science-and-technology": "Water Science & Technology",
    "waterbirds": "Waterbirds",
    "weed-research": "Weed Research",
    "weed-science-society-of-america": "Weed Science Society of America",
    "west-european-politics": "West European Politics",
    "western-journal-of-emergency-medicine": "Western Journal of Emergency Medicine",
    "westfalische-wilhelms-universitat-munster-medizinische-fakultat": "Westfälische Wilhelms-Universität Münster - Medizinische Fakultät (Deutsch)",
    "wetlands": "Wetlands",
    "wheaton-college-phd-in-biblical-and-theological-studies": "Wheaton College - Ph.D. in Biblical and Theological Studies",
    "wiener-digitale-revue": "Wiener digitale Revue (Deutsch)",
    "wiesbaden-business-school": "Wiesbaden Business School",
    "wikipedia-templates": "Wikipedia Templates",
    "wikipedia-fr-templates": "Wikipedia-fr templates (français)",
    "wiley-was": "Wiley Analytical Science",
    "wiley-vch-books": "Wiley-VCH books",
    "wireless-communications-and-mobile-computing": "Wireless Communications and Mobile Computing",
    "wirtschaftsuniversitat-wien-author-date": "Wirtschaftsuniversität Wien (author-date)",
    "wirtschaftsuniversitat-wien-abteilung-fur-bildungswissenschaft": "Wirtschaftsuniversität Wien - Abteilung für Bildungswissenschaft (Deutsch - Österreich)",
    "wirtschaftsuniversitat-wien-handel-und-marketing": "Wirtschaftsuniversität Wien - Handel und Marketing (Deutsch - Österreich)",
    "wirtschaftsuniversitat-wien-health-care-management": "Wirtschaftsuniversität Wien - Health Care Management",
    "wirtschaftsuniversitat-wien-institut-fur-bwl-des-aussenhandels": "Wirtschaftsuniversität Wien - Institut für BWL des Außenhandels (Deutsch - Österreich)",
    "wirtschaftsuniversitat-wien-institut-fur-transportwirtschaft-und-logistik": "Wirtschaftsuniversität Wien - Institut für Transportwirtschaft und Logistik (Deutsch - Österreich)",
    "wirtschaftsuniversitat-wien-unternehmensrechnung-und-controlling": "Wirtschaftsuniversität Wien - Unternehmensrechnung und Controlling",
    "wirtschaftsuniversitat-wien-wirtschaftspadagogik": "Wirtschaftsuniversität Wien - Wirtschaftspädagogik (Deutsch - Österreich)",
    "wissenschaftlicher-industrielogistik-dialog": "Wissenschaftlicher Industrielogistik-Dialog (Deutsch - Österreich)",
    "wolters-kluwerbrede-schrijfwijzer-author-date": "Wolters Kluwerbrede Schrijfwijzer (author-date, Nederlands)",
    "world-applied-sciences-journal": "World Applied Sciences Journal",
    "world-congress-on-engineering-asset-management": "World Congress on Engineering Asset Management 2010",
    "world-mycotoxin-journal": "World Mycotoxin Journal",
    "world-organisation-for-animal-health-scientific-and-technical-review": "World Organisation for Animal Health - Scientific and Technical Review",
    "world-politics": "World Politics",
    "worlds-poultry-science-journal": "World's Poultry Science Journal",
    "worlds-veterinary-journal": "World's Veterinary Journal",
    "xenotransplantation": "Xenotransplantation",
    "harvard-xi-an-jiaotong-liverpool-university": "Xi'an Jiaotong-Liverpool University (XJTLU) (author-date/Harvard)",
    "yeast": "Yeast",
    "harvard-york-st-john-university": "York St John University (author-date/Harvard, pre September 2019 entry)",
    "yozgat-bozok-universitesi-fen-bilimleri-enstitusu": "Yozgat Bozok Üniversitesi - Fen Bilimleri Enstitüsü (Türkçe)",
    "zdfm-zeitschrift-fur-diversitatsforschung-und-management": "ZDfm – Zeitschrift für Diversitätsforschung und -management (Deutsch - Österreich)",
    "zastosowania-komputerow-w-elektrotechnice": "Zastosowania Komputerów w Elektrotechnice",
    "zdravniski-vestnik": "Zdravniški Vestnik (Slovenian Medical Journal)",
    "zeitgeschichte": "Zeitgeschichte (Deutsch)",
    "zeithistorische-forschungen": "Zeithistorische Forschungen/Studies in Contemporary History",
    "zeitschrift-fur-allgemeinmedizin": "Zeitschrift für Allgemeinmedizin",
    "zeitschrift-fur-antikes-christentum": "Zeitschrift für Antikes Christentum (Journal of Ancient Christianity) (English)",
    "zeitschrift-fur-fantastikforschung": "Zeitschrift für Fantastikforschung (Deutsch)",
    "zeitschrift-fur-geschichtsdidaktik": "Zeitschrift für Geschichtsdidaktik (Deutsch)",
    "zeitschrift-fur-internationale-beziehungen": "Zeitschrift für Internationale Beziehungen (Deutsch)",
    "zeitschrift-fur-kunstgeschichte": "Zeitschrift für Kunstgeschichte",
    "zeitschrift-fur-medien-und-kulturforschung": "Zeitschrift für Medien- und Kulturforschung (Deutsch)",
    "zeitschrift-fur-medienwissenschaft": "Zeitschrift für Medienwissenschaft (Deutsch)",
    "zeitschrift-fur-ostmitteleuropa-forschung": "Zeitschrift für Ostmitteleuropa-Forschung (Deutsch)",
    "zeitschrift-fur-papyrologie-und-epigraphik": "Zeitschrift für Papyrologie und Epigraphik",
    "zeitschrift-fur-parlamentsfragen": "Zeitschrift für Parlamentsfragen (Deutsch)",
    "zeitschrift-fur-politik": "Zeitschrift für Politik (German)",
    "zeitschrift-fur-padagogik": "Zeitschrift für Pädagogik (Deutsch)",
    "zeitschrift-fur-qualitative-forschung": "Zeitschrift für Qualitative Forschung (Deutsch)",
    "zeitschrift-fur-religionswissenschaft-author-date": "Zeitschrift für Religionswissenschaft (author-date)",
    "zeitschrift-fur-religionswissenschaft-note": "Zeitschrift für Religionswissenschaft (note)",
    "zeitschrift-fur-soziologie": "Zeitschrift für Soziologie (Deutsch)",
    "zeitschrift-fur-theologie-und-kirche": "Zeitschrift für Theologie und Kirche (Deutsch)",
    "zeitschrift-fur-theologie-und-philosophie": "Zeitschrift für Theologie und Philosophie",
    "zeitschrift-fur-zahnarztliche-implantologie": "Zeitschrift für Zahnärztliche Implantologie (Deutsch)",
    "zeitschrift-fur-deutsche-philologie": "Zeitschrift für deutsche Philologie (Deutsch)",
    "zeitschrift-fur-die-geschichte-des-oberrheins": "Zeitschrift für die Geschichte des Oberrheins (Deutsch)",
    "zeitschrift-fur-digitale-geisteswissenschaften": "Zeitschrift für digitale Geisteswissenschaften (Deutsch)",
    "zeszyty-prawnicze-bas": "Zeszyty Prawnicze BAS (Polski)",
    "zilsel": "Zilsel (Français)",
    "zitierguide-leitfaden-zum-fachgerechten-zitieren-in-rechtswissenschaftlichen-arbeiten": "ZitierGuide: Leitfaden zum fachgerechten Zitieren in rechtswissenschaftlichen Arbeiten (Roger Müller) (Deutsch - Schweiz)",
    "zoological-journal-of-the-linnean-society": "Zoological Journal of the Linnean Society",
    "zoological-science": "Zoological Science",
    "zootaxa": "Zootaxa",
    "zwitscher-maschine": "Zwitscher-Maschine",
    "zurcher-hochschule-fur-angewandte-wissenschaften-soziale-arbeit": "Zürcher Hochschule für Angewandte Wissenschaften - Soziale Arbeit (Deutsch - Schweiz)",
    "animal": "animal",
    "bitonline": "b.i.t.online (note, Deutsch)",
    "carolinea": "carolinea",
    "cultural-geographies": "cultural geographies",
    "der-moderne-staat": "der moderne staat (Deutsch)",
    "elife": "eLife",
    "eneuro": "eNeuro",
    "express-polymer-letters": "eXPRESS Polymer Letters",
    "ergoscience": "ergoscience",
    "ethnographiques-org": "ethnographiques.org (Français)",
    "exercer": "exercer (Français)",
    "historia-scribere": "historia-scribere (Deutsch)",
    "historio-plus": "historioPLUS (Deutsch - Österreich)",
    "iforest": "iForest",
    "infoclio-de": "infoclio.ch (Deutsch - Schweiz)",
    "infoclio-de-kurzbelege": "infoclio.ch (Kurzbelege, Deutsch - Schweiz)",
    "infoclio-fr-smallcaps": "infoclio.ch (petites majuscules, Français)",
    "infoclio-fr-nocaps": "infoclio.ch (sans majuscules, Français)",
    "la-nouvelle-revue-du-travail": "la Nouvelle Revue du Travail (Français)",
    "medecine-sciences": "médecine/sciences",
    "natbib-plainnat-author-date": "natbib - plainnat (author-date)",
    "suburban-zeitschrift-fur-kritische-stadtforschung": "sub\\urban - Zeitschrift für kritische Stadtforschung (Deutsch)",
    "arbok-hins-islenzka-fornleifafelags": "Árbók Hins íslenzka fornleifafélags (Íslenska)",
    "ets-ecole-de-technologie-superieure": "ÉTS - École de technologie supérieure (Français - Canada)",
    "ecole-pratique-des-hautes-etudes-sciences-historiques-et-philologiques": "École Pratique des Hautes Études - Sciences historiques et philologiques (Français)",
    "ecole-de-technologie-superieure-apa": "École de technologie supérieure - APA (Français - Canada)",
    "economie-et-statistique": "Économie et Statistique (Français)",
    "ecoscience": "Écoscience",
    "epidemiologie-et-sante-animale": "Épidémiologie et Santé Animale",
    "etudes-chinoises": "Études chinoises",
    "etudes-francaises": "Études françaises (Français)",
    "osterreichische-zeitschrift-fur-politikwissenschaft": "Österreichische Zeitschrift für Politikwissenschaft (Deutsch - Österreich)",
    "casopis-pro-pravni-vedu-a-praxi": "Časopis pro právní vědu a praxi",
    "ceska-zemedelska-univerzita-v-praze-fakulta-agrobiologie-potravinovych-a-prirodnich-zdroju": "Česká zemědělská univerzita v Praze - Fakulta agrobiologie, potravinových a přírodních zdrojů",
    "isnad": "İSNAD Atıf Sistemi 1. Edisyon (dipnotlu)",
    "isnad-dipnotlu": "İSNAD Atıf Sistemi 2. Edisyon (dipnotlu)",
    "isnad-metinici": "İSNAD Atıf Sistemi 2. Edisyon (metiniçi)",
    "istanbul-bilgi-universitesi-lisansustu-programlar-enstitusu-hukuk": "İstanbul Bilgi Üniversitesi Lisansüstü Programlar Enstitüsü - Hukuk (Türkçe)",
    "istanbul-medical-journal": "İstanbul Medical Journal",
    "istanbul-universitesi-sosyal-bilimler-enstitusu": "İstanbul Üniversitesi Sosyal Bilimler Enstitüsü (Türkçe)",
    "izmir-katip-celebi-universitesi-sosyal-bilimler-enstitusu": "İzmir Katip Çelebi Üniversitesi - Sosyal Bilimler Enstitüsü (Türkçe)",
    "biologiceskie-membrany": "Биологические мембраны",
    "rossiiskii-fiziologicheskii-zhurnal-imeni-i-m-sechenova": "Российский физиологический журнал им. И.М. Сеченова (Ру́сский)",
    "uspekhi-gerontologii": "Успехи геронтологии (Ру́сский)",
    "the-university-of-tokyo-law-review": "東京大学法科大学院ローレビュー (The University of Tokyo Law Review) (日本語)"
}
